// tslint:disable
/**
 * API Studiestedbruker API
 * ALP api for Stuidestedbrukere
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import { COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbstractSignatarDto
 */
export interface AbstractSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface AktivitetskravDto
 */
export interface AktivitetskravDto {
    /**
     * 
     * @type {string}
     * @memberof AktivitetskravDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AktivitetskravDto
     */
    'navn': string;
    /**
     * 
     * @type {number}
     * @memberof AktivitetskravDto
     */
    'sistEndret'?: number;
    /**
     * 
     * @type {number}
     * @memberof AktivitetskravDto
     */
    'antallSteder'?: number;
}
/**
 * 
 * @export
 * @interface AlpKommuneDto
 */
export interface AlpKommuneDto {
    /**
     * 
     * @type {number}
     * @memberof AlpKommuneDto
     */
    'fylkesnr': number;
    /**
     * 
     * @type {string}
     * @memberof AlpKommuneDto
     */
    'kommunenavn': string;
    /**
     * 
     * @type {number}
     * @memberof AlpKommuneDto
     */
    'kommunenr': number;
}
/**
 * 
 * @export
 * @interface AlpLandDto
 */
export interface AlpLandDto {
    /**
     * 
     * @type {number}
     * @memberof AlpLandDto
     */
    'landnr': number;
    /**
     * 
     * @type {string}
     * @memberof AlpLandDto
     */
    'landnavnNorsk': string;
    /**
     * 
     * @type {string}
     * @memberof AlpLandDto
     */
    'telefonlandnr'?: string;
}
/**
 * 
 * @export
 * @interface AlpPraksisstedGetDto
 */
export interface AlpPraksisstedGetDto {
    /**
     * 
     * @type {Array<AlpPraksisstedMedNivaaDto>}
     * @memberof AlpPraksisstedGetDto
     */
    'praksissteder': Array<AlpPraksisstedMedNivaaDto>;
    /**
     * 
     * @type {Array<AlpLandDto>}
     * @memberof AlpPraksisstedGetDto
     */
    'land': Array<AlpLandDto>;
    /**
     * 
     * @type {Array<AlpKommuneDto>}
     * @memberof AlpPraksisstedGetDto
     */
    'kommuner': Array<AlpKommuneDto>;
}
/**
 * 
 * @export
 * @interface AlpPraksisstedMedNivaaDto
 */
export interface AlpPraksisstedMedNivaaDto {
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedMedNivaaDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedMedNivaaDto
     */
    'praksisstedkode': string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedMedNivaaDto
     */
    'praksisstednavnBokmal': string;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedMedNivaaDto
     */
    'level': number;
}
/**
 * 
 * @export
 * @interface AlpPraksisstedPostDto
 */
export interface AlpPraksisstedPostDto {
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'praksisstedkodeEier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'praksisstednavnBokmal': string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'praksisstednavnNynorsk'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'praksisstednavnEngelsk'?: string;
    /**
     * 
     * @type {Array<PraksisstedtypeDto>}
     * @memberof AlpPraksisstedPostDto
     */
    'praksisstedtyper'?: Array<PraksisstedtypeDto>;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'adrlin1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'adrlin2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'adrlin3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'adresseland'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedPostDto
     */
    'landnr'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'telefonlandnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'telefonnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'emailadresse'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedPostDto
     */
    'orgnr'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedPostDto
     */
    'kommunenr'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedPostDto
     */
    'fylkesnr'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlpPraksisstedPostDto
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlpPraksisstedPostDto
     */
    'datoFra'?: number;
}
/**
 * 
 * @export
 * @interface AlpPraksisstedtyperGetDto
 */
export interface AlpPraksisstedtyperGetDto {
    /**
     * 
     * @type {Array<PraksisstedtypeDto>}
     * @memberof AlpPraksisstedtyperGetDto
     */
    'praksisstedertype'?: Array<PraksisstedtypeDto>;
}
/**
 * 
 * @export
 * @interface AvtalerDto
 */
export interface AvtalerDto {
    /**
     * 
     * @type {Array<MuligeStudiestedDto>}
     * @memberof AvtalerDto
     */
    'muligestudiesteder'?: Array<MuligeStudiestedDto>;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof AvtalerDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AvtalestatusDto = {
    IkkeAktiv: 'IkkeAktiv',
    Aktiv: 'Aktiv',
    SendtTilSignering: 'SendtTilSignering',
    InnhenterOpplysninger: 'InnhenterOpplysninger',
    Kansellert: 'Kansellert',
    Avsluttet: 'Avsluttet',
    Utkast: 'Utkast',
    Feil: 'FEIL'
} as const;

export type AvtalestatusDto = typeof AvtalestatusDto[keyof typeof AvtalestatusDto];


/**
 * Et gitt praksissted som er avtalestedet (toppnoden) for et praksissted hierarki. Definerer også om avtalen er omfattet, så betyr bare de angitte praksisstedene
 * @export
 * @interface AvtalestederMedMuligeOmfattedePraksisstedDto
 */
export interface AvtalestederMedMuligeOmfattedePraksisstedDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedDto
     */
    'avtalestedforelder'?: MinimalPraksisstedDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedDto
     */
    'omfattetPraksisstedsteder'?: Array<MinimalPraksisstedDto>;
}
/**
 * Et gitt praksissted som er avtalestedet (toppnoden) for et praksissted hierarki. Definerer også om avtalen er omfattet, så betyr bare de angitte praksisstedene
 * @export
 * @interface AvtalestederMedMuligeOmfattedePraksisstedPostDto
 */
export interface AvtalestederMedMuligeOmfattedePraksisstedPostDto {
    /**
     * 
     * @type {string}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedPostDto
     */
    'avtalestedforelderId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedPostDto
     */
    'omfattetPraksisstedstedIder'?: Array<string>;
}
/**
 * Et gitt praksissted som er avtalestedet (toppnoden) for et praksissted hierarki. Definerer også om avtalen er omfattet, så betyr bare de angitte praksisstedene
 * @export
 * @interface AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
 */
export interface AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto {
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiDto}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
     */
    'avtalestedforelder': MinimalPraksisstedMedHierarkiDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
     */
    'omfattetPraksisstedsteder'?: Array<MinimalPraksisstedDto>;
}
/**
 * 
 * @export
 * @interface BrukerinfoDto
 */
export interface BrukerinfoDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {BrukerinnstillingerDto}
     * @memberof BrukerinfoDto
     */
    'innstillinger': BrukerinnstillingerDto;
    /**
     * 
     * @type {boolean}
     * @memberof BrukerinfoDto
     */
    'toppNivaaAdmin': boolean;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof BrukerinfoDto
     */
    'hoeyesteRettighet': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface BrukerinnstillingerDto
 */
export interface BrukerinnstillingerDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinnstillingerDto
     */
    'spraakvalg'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrukerinnstillingerDto
     */
    'harGodtattBetingelser'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerrollerDto = {
    Administrator: 'Administrator',
    Registrererettighet: 'Registrererettighet',
    Skriverettighet: 'Skriverettighet',
    Leserettighet: 'Leserettighet'
} as const;

export type BrukerrollerDto = typeof BrukerrollerDto[keyof typeof BrukerrollerDto];


/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerrollerPSDto = {
    Administrator: 'Administrator',
    Skriverettighet: 'Skriverettighet',
    Leserettighet: 'Leserettighet'
} as const;

export type BrukerrollerPSDto = typeof BrukerrollerPSDto[keyof typeof BrukerrollerPSDto];


/**
 * Institusjon/studiested som eier avtalen, og hvilke studiesteder den gjelder for
 * @export
 * @interface EierAvtalestedMedMuligeOmfattedeStudiestedDto
 */
export interface EierAvtalestedMedMuligeOmfattedeStudiestedDto {
    /**
     * 
     * @type {MinimalMinimalStudiestedDto}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedDto
     */
    'avtalestedforelder'?: MinimalMinimalStudiestedDto;
    /**
     * 
     * @type {Array<MinimalMinimalStudiestedDto>}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedDto
     */
    'omfattetStudiesteder'?: Array<MinimalMinimalStudiestedDto>;
}
/**
 * Institusjon/studiested som eier avtalen, og hvilke studiesteder den gjelder for
 * @export
 * @interface EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
 */
export interface EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto {
    /**
     * 
     * @type {MinimalStudiestedDto}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
     */
    'avtalestedforelder': MinimalStudiestedDto;
    /**
     * 
     * @type {Array<MinimalMinimalStudiestedDto>}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
     */
    'omfattetStudiesteder'?: Array<MinimalMinimalStudiestedDto>;
}
/**
 * Institusjon/studiested som eier avtalen, og hvilke studiesteder den gjelder for
 * @export
 * @interface EierAvtalestedMedMuligeOmfattedeStudiestedPostDto
 */
export interface EierAvtalestedMedMuligeOmfattedeStudiestedPostDto {
    /**
     * 
     * @type {string}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedPostDto
     */
    'avtalestedforelderId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedPostDto
     */
    'omfattetStudiestedIder'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EksternSignatarDto
 */
export interface EksternSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface EmneDto
 */
export interface EmneDto {
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface EnhetsregEnhetAdresseDto
 */
export interface EnhetsregEnhetAdresseDto {
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetAdresseDto
     */
    'adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetAdresseDto
     */
    'postnummer'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetAdresseDto
     */
    'poststed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetAdresseDto
     */
    'kommune'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetAdresseDto
     */
    'land'?: string;
}
/**
 * 
 * @export
 * @interface EnhetsregEnhetDto
 */
export interface EnhetsregEnhetDto {
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetDto
     */
    'navn'?: string;
    /**
     * 
     * @type {EnhetsregEnhetAdresseDto}
     * @memberof EnhetsregEnhetDto
     */
    'forretningsadresse'?: EnhetsregEnhetAdresseDto;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetDto
     */
    'hjemmeside'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhetsregEnhetDto
     */
    'maalform'?: string;
}
/**
 * 
 * @export
 * @interface FSAktivitetfeilDto
 */
export interface FSAktivitetfeilDto {
    /**
     * 
     * @type {string}
     * @memberof FSAktivitetfeilDto
     */
    'praksisstedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FSAktivitetfeilDto
     */
    'praksisstedkode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FSAktivitetfeilDto
     */
    'praksisstednavn'?: string;
    /**
     * 
     * @type {FSFeiltypeDto}
     * @memberof FSAktivitetfeilDto
     */
    'feiltype': FSFeiltypeDto;
    /**
     * 
     * @type {FeilmeldingDto}
     * @memberof FSAktivitetfeilDto
     */
    'feilmelding'?: FeilmeldingDto;
}


/**
 * 
 * @export
 * @interface FSAktivitetstatusDto
 */
export interface FSAktivitetstatusDto {
    /**
     * 
     * @type {FSAktivitetstatustypeDto}
     * @memberof FSAktivitetstatusDto
     */
    'status': FSAktivitetstatustypeDto;
    /**
     * 
     * @type {Array<FSAktivitetfeilDto>}
     * @memberof FSAktivitetstatusDto
     */
    'feil': Array<FSAktivitetfeilDto>;
    /**
     * 
     * @type {string}
     * @memberof FSAktivitetstatusDto
     */
    'sistePubliseringTilFS'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FSAktivitetstatustypeDto = {
    IngenFeil: 'IngenFeil',
    FeilVedPublisering: 'FeilVedPublisering',
    UkjentFeil: 'UkjentFeil'
} as const;

export type FSAktivitetstatustypeDto = typeof FSAktivitetstatustypeDto[keyof typeof FSAktivitetstatustypeDto];


/**
 * 
 * @export
 * @interface FSFeilDto
 */
export interface FSFeilDto {
    /**
     * 
     * @type {FSFeiltypeDto}
     * @memberof FSFeilDto
     */
    'feiltype': FSFeiltypeDto;
    /**
     * 
     * @type {FeilmeldingDto}
     * @memberof FSFeilDto
     */
    'feilmelding'?: FeilmeldingDto;
}


/**
 * 
 * @export
 * @interface FSFeillisteDto
 */
export interface FSFeillisteDto {
    /**
     * 
     * @type {Array<FSFeilDto>}
     * @memberof FSFeillisteDto
     */
    'feil': Array<FSFeilDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FSFeiltypeDto = {
    Aktivitetfeil: 'Aktivitetfeil',
    UkjentFeil: 'UkjentFeil'
} as const;

export type FSFeiltypeDto = typeof FSFeiltypeDto[keyof typeof FSFeiltypeDto];


/**
 * 
 * @export
 * @enum {string}
 */

export const FSSyncStatusDto = {
    Ok: 'OK',
    FeiletSisteDogn: 'FeiletSisteDogn',
    Feilet: 'Feilet'
} as const;

export type FSSyncStatusDto = typeof FSSyncStatusDto[keyof typeof FSSyncStatusDto];


/**
 * 
 * @export
 * @interface FSSyncStatusPerTypeDto
 */
export interface FSSyncStatusPerTypeDto {
    /**
     * 
     * @type {FSSyncTypeDto}
     * @memberof FSSyncStatusPerTypeDto
     */
    'type': FSSyncTypeDto;
    /**
     * 
     * @type {FSSyncStatusDto}
     * @memberof FSSyncStatusPerTypeDto
     */
    'status'?: FSSyncStatusDto;
    /**
     * 
     * @type {string}
     * @memberof FSSyncStatusPerTypeDto
     */
    'sisteVellykket'?: string;
    /**
     * 
     * @type {string}
     * @memberof FSSyncStatusPerTypeDto
     */
    'nesteKjoring': string;
}


/**
 * 
 * @export
 * @interface FSSyncStatuserDto
 */
export interface FSSyncStatuserDto {
    /**
     * 
     * @type {Array<FSSyncStatusPerTypeDto>}
     * @memberof FSSyncStatuserDto
     */
    'syncStatus': Array<FSSyncStatusPerTypeDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FSSyncTypeDto = {
    Institusjon: 'Institusjon',
    Emne: 'Emne',
    Praksisavtale: 'Praksisavtale',
    Praksissted: 'Praksissted',
    Praksistype: 'Praksistype',
    Student: 'Student',
    Studiested: 'Studiested',
    Undervisningsenhet: 'Undervisningsenhet'
} as const;

export type FSSyncTypeDto = typeof FSSyncTypeDto[keyof typeof FSSyncTypeDto];


/**
 * 
 * @export
 * @interface FeilmeldingDto
 */
export interface FeilmeldingDto {
    /**
     * 
     * @type {string}
     * @memberof FeilmeldingDto
     */
    'feilmeldingId': string;
    /**
     * 
     * @type {string}
     * @memberof FeilmeldingDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface HalPraksisavtaleVedleggMinimalListDto
 */
export interface HalPraksisavtaleVedleggMinimalListDto {
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof HalPraksisavtaleVedleggMinimalListDto
     */
    'items'?: Array<PraksisavtaleVedleggMinimalDto>;
}
/**
 * @type HalPraksisstedavtaleDto
 * @export
 */
export type HalPraksisstedavtaleDto = HalPraksisstedavtaleOneOf1Dto | HalPraksisstedavtaleOneOfDto;

/**
 * 
 * @export
 * @interface HalPraksisstedavtaleOneOf1Dto
 */
export interface HalPraksisstedavtaleOneOf1Dto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }}
     * @memberof HalPraksisstedavtaleOneOf1Dto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; };
}


/**
 * 
 * @export
 * @interface HalPraksisstedavtaleOneOfDto
 */
export interface HalPraksisstedavtaleOneOfDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedDto}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }}
     * @memberof HalPraksisstedavtaleOneOfDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; };
}


/**
 * 
 * @export
 * @interface HalPraksisstedavtalerDto
 */
export interface HalPraksisstedavtalerDto {
    /**
     * 
     * @type {Array<PraksisstedavtaleDto>}
     * @memberof HalPraksisstedavtalerDto
     */
    'avtaler'?: Array<PraksisstedavtaleDto>;
}
/**
 * 
 * @export
 * @interface InviterStudiestedbrukerDto
 */
export interface InviterStudiestedbrukerDto {
    /**
     * 
     * @type {Array<MuligeStudiestedbrukereDto>}
     * @memberof InviterStudiestedbrukerDto
     */
    'muligeBrukere'?: Array<MuligeStudiestedbrukereDto>;
    /**
     * 
     * @type {Array<MuligeStudiestedDto>}
     * @memberof InviterStudiestedbrukerDto
     */
    'muligeSteder'?: Array<MuligeStudiestedDto>;
}
/**
 * 
 * @export
 * @interface LaeringsutbytteDto
 */
export interface LaeringsutbytteDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {Array<VurderingskriterieDto>}
     * @memberof LaeringsutbytteDto
     */
    'vurderingskriterier'?: Array<VurderingskriterieDto>;
}
/**
 * 
 * @export
 * @interface LaeringsutbytteKommentarDto
 */
export interface LaeringsutbytteKommentarDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'studentVurderingId': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'laeringsutbytteId': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'tekst': string;
    /**
     * 
     * @type {boolean}
     * @memberof LaeringsutbytteKommentarDto
     */
    'delt': boolean;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'sistEndret': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarDto
     */
    'kommentatorNavn': string;
}
/**
 * 
 * @export
 * @interface LaeringsutbytteKommentarRedigerDto
 */
export interface LaeringsutbytteKommentarRedigerDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarRedigerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarRedigerDto
     */
    'laeringsutbytteId': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommentarRedigerDto
     */
    'tekst': string;
    /**
     * 
     * @type {boolean}
     * @memberof LaeringsutbytteKommentarRedigerDto
     */
    'delt': boolean;
}
/**
 * 
 * @export
 * @interface LaeringsutbytteKommenterDto
 */
export interface LaeringsutbytteKommenterDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommenterDto
     */
    'studentVurderingId': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommenterDto
     */
    'laeringsutbytteId': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbytteKommenterDto
     */
    'tekst': string;
    /**
     * 
     * @type {boolean}
     * @memberof LaeringsutbytteKommenterDto
     */
    'delt': boolean;
}
/**
 * 
 * @export
 * @interface LaeringsutbytteMedRollersKommentarDto
 */
export interface LaeringsutbytteMedRollersKommentarDto {
    /**
     * 
     * @type {LaeringsutbytteDto}
     * @memberof LaeringsutbytteMedRollersKommentarDto
     */
    'laeringsutbytte': LaeringsutbytteDto;
    /**
     * 
     * @type {LaeringsutbytteKommentarDto}
     * @memberof LaeringsutbytteMedRollersKommentarDto
     */
    'studentKommentar': LaeringsutbytteKommentarDto;
    /**
     * 
     * @type {LaeringsutbytteKommentarDto}
     * @memberof LaeringsutbytteMedRollersKommentarDto
     */
    'underviserKommentar': LaeringsutbytteKommentarDto;
    /**
     * 
     * @type {LaeringsutbytteKommentarDto}
     * @memberof LaeringsutbytteMedRollersKommentarDto
     */
    'veilederKommentar': LaeringsutbytteKommentarDto;
}
/**
 * 
 * @export
 * @interface LaeringsutbyttegruppeDto
 */
export interface LaeringsutbyttegruppeDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {Array<LaeringsutbytteDto>}
     * @memberof LaeringsutbyttegruppeDto
     */
    'laeringsutbytter'?: Array<LaeringsutbytteDto>;
    /**
     * 
     * @type {LaeringsutbyttegruppeEnumDto}
     * @memberof LaeringsutbyttegruppeDto
     */
    'vurderingsmetode': LaeringsutbyttegruppeEnumDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LaeringsutbyttegruppeEnumDto = {
    Fritekst: 'fritekst',
    Karakterbasert: 'karakterbasert'
} as const;

export type LaeringsutbyttegruppeEnumDto = typeof LaeringsutbyttegruppeEnumDto[keyof typeof LaeringsutbyttegruppeEnumDto];


/**
 * 
 * @export
 * @interface LaeringsutbyttegruppeMinimalDto
 */
export interface LaeringsutbyttegruppeMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeMinimalDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeMinimalDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface LaeringsutbyttegruppeNyDto
 */
export interface LaeringsutbyttegruppeNyDto {
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeNyDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof LaeringsutbyttegruppeNyDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {Array<LaeringsutbytteDto>}
     * @memberof LaeringsutbyttegruppeNyDto
     */
    'laeringsutbytter'?: Array<LaeringsutbytteDto>;
    /**
     * 
     * @type {LaeringsutbyttegruppeEnumDto}
     * @memberof LaeringsutbyttegruppeNyDto
     */
    'vurderingsmetode': LaeringsutbyttegruppeEnumDto;
}


/**
 * 
 * @export
 * @interface MatchingPraksisstedDto
 */
export interface MatchingPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MatchingPraksisstedDto
     */
    'navn'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingPraksisstedDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingPraksisstedDto
     */
    'adresse'?: string;
}
/**
 * 
 * @export
 * @interface MinimalAktivitetInfoDto
 */
export interface MinimalAktivitetInfoDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'aktivitetId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'emnekode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'praksistypenavn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'praksisklassenavn': string;
    /**
     * 
     * @type {number}
     * @memberof MinimalAktivitetInfoDto
     */
    'studenter'?: number;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'aktivitetVurderingStatus': MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum;
}

export const MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum = {
    Gjennomfoert: 'Gjennomfoert',
    Aktiv: 'Aktiv',
    Framtidig: 'Framtidig'
} as const;

export type MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum = typeof MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum[keyof typeof MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum];

/**
 * 
 * @export
 * @interface MinimalAktiviteterDto
 */
export interface MinimalAktiviteterDto {
    /**
     * 
     * @type {Array<MinimalAktivitetInfoDto>}
     * @memberof MinimalAktiviteterDto
     */
    'aktiviteter'?: Array<MinimalAktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface MinimalMinimalStudiestedDto
 */
export interface MinimalMinimalStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalMinimalStudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalMinimalStudiestedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedDto
 */
export interface MinimalPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedMedHierarkiDto
 */
export interface MinimalPraksisstedMedHierarkiDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'orgnr'?: string;
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiNoderDto}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'noder': MinimalPraksisstedMedHierarkiNoderDto;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedMedHierarkiNoderDto
 */
export interface MinimalPraksisstedMedHierarkiNoderDto {
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiDto}
     * @memberof MinimalPraksisstedMedHierarkiNoderDto
     */
    'over'?: MinimalPraksisstedMedHierarkiDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedMedHierarkiDto>}
     * @memberof MinimalPraksisstedMedHierarkiNoderDto
     */
    'under': Array<MinimalPraksisstedMedHierarkiDto>;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedDto
 */
export interface MinimalStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'navn': string;
    /**
     * 
     * @type {MinimalStudiestedNoderDto}
     * @memberof MinimalStudiestedDto
     */
    'noder': MinimalStudiestedNoderDto;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedNoderDto
 */
export interface MinimalStudiestedNoderDto {
    /**
     * 
     * @type {Array<MinimalStudiestedDto>}
     * @memberof MinimalStudiestedNoderDto
     */
    'over': Array<MinimalStudiestedDto>;
    /**
     * 
     * @type {Array<MinimalStudiestedDto>}
     * @memberof MinimalStudiestedNoderDto
     */
    'under': Array<MinimalStudiestedDto>;
}
/**
 * 
 * @export
 * @interface MuligePraksisstedDto
 */
export interface MuligePraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MuligePraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MuligePraksisstedDto
     */
    'navn': string;
    /**
     * Hvor dypt i praksisstedshierarkiet stedet ligger, brukes til visualisering i frontend
     * @type {number}
     * @memberof MuligePraksisstedDto
     */
    'dybde': number;
    /**
     * Om praksisstedet skal merkes som deaktivert ved opplisting
     * @type {boolean}
     * @memberof MuligePraksisstedDto
     */
    'deaktivert'?: boolean;
}
/**
 * 
 * @export
 * @interface MuligeStudiestedDto
 */
export interface MuligeStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedDto
     */
    'type': MuligeStudiestedDtoTypeDtoEnum;
    /**
     * Om studiestedet skal merkes som deaktivert ved opplisting
     * @type {boolean}
     * @memberof MuligeStudiestedDto
     */
    'deaktivert': boolean;
}

export const MuligeStudiestedDtoTypeDtoEnum = {
    Institusjon: 'Institusjon',
    Fakultet: 'Fakultet',
    Institutt: 'Institutt',
    Gruppe: 'Gruppe'
} as const;

export type MuligeStudiestedDtoTypeDtoEnum = typeof MuligeStudiestedDtoTypeDtoEnum[keyof typeof MuligeStudiestedDtoTypeDtoEnum];

/**
 * 
 * @export
 * @interface MuligeStudiestedbrukereDto
 */
export interface MuligeStudiestedbrukereDto {
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedbrukereDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedbrukereDto
     */
    'brukernavn': string;
    /**
     * 
     * @type {string}
     * @memberof MuligeStudiestedbrukereDto
     */
    'feideId': string;
}
/**
 * 
 * @export
 * @interface MultiSignatarerDto
 */
export interface MultiSignatarerDto {
    /**
     * 
     * @type {Array<EksternSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'eksternbrukere'?: Array<EksternSignatarDto>;
    /**
     * 
     * @type {Array<StudiestedbrukerSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'studiestedbrukere'?: Array<StudiestedbrukerSignatarDto>;
    /**
     * 
     * @type {Array<PraksisstedbrukerSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'praksisstedbrukere'?: Array<PraksisstedbrukerSignatarDto>;
}
/**
 * 
 * @export
 * @interface NyPraksisaktivitetDto
 */
export interface NyPraksisaktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof NyPraksisaktivitetDto
     */
    'klasseId': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisaktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisaktivitetDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisaktivitetDto
     */
    'aktivitetskravId'?: string;
}
/**
 * 
 * @export
 * @interface NyPraksisklasseDto
 */
export interface NyPraksisklasseDto {
    /**
     * 
     * @type {string}
     * @memberof NyPraksisklasseDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface NyPraksisstedbrukerInvitasjonDto
 */
export interface NyPraksisstedbrukerInvitasjonDto {
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'fnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {BrukerrollerPSDto}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'brukerrolle': BrukerrollerPSDto;
}


/**
 * 
 * @export
 * @interface NyPraksisstedbrukerRolleDto
 */
export interface NyPraksisstedbrukerRolleDto {
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerRolleDto
     */
    'praksisstedbrukerId'?: string;
    /**
     * 
     * @type {PraksisstedRollerDto}
     * @memberof NyPraksisstedbrukerRolleDto
     */
    'type'?: PraksisstedRollerDto;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerRolleDto
     */
    'praksisstedId'?: string;
}


/**
 * 
 * @export
 * @interface NyStudiestedbrukerInvitasjonDto
 */
export interface NyStudiestedbrukerInvitasjonDto {
    /**
     * 
     * @type {string}
     * @memberof NyStudiestedbrukerInvitasjonDto
     */
    'feideId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NyStudiestedbrukerInvitasjonDto
     */
    'fsBrukernavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof NyStudiestedbrukerInvitasjonDto
     */
    'studiestedId'?: string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof NyStudiestedbrukerInvitasjonDto
     */
    'brukerrolle'?: BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface NyStudiestedbrukerRolleDto
 */
export interface NyStudiestedbrukerRolleDto {
    /**
     * 
     * @type {string}
     * @memberof NyStudiestedbrukerRolleDto
     */
    'studiestedbrukerId'?: string;
    /**
     * 
     * @type {StudiestedRollerDto}
     * @memberof NyStudiestedbrukerRolleDto
     */
    'type'?: StudiestedRollerDto;
}


/**
 * 
 * @export
 * @interface OverlappendePraksisstedavtalesokRequestDto
 */
export interface OverlappendePraksisstedavtalesokRequestDto {
    /**
     * 
     * @type {string}
     * @memberof OverlappendePraksisstedavtalesokRequestDto
     */
    'studiestedIdEierAvAvtale': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OverlappendePraksisstedavtalesokRequestDto
     */
    'avtalestedIder': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OverlappendePraksisstedavtalesokRequestDto
     */
    'praksistypekoder': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OverlappendePraksisstedavtalesokRequestDto
     */
    'avtalestart': string;
    /**
     * 
     * @type {string}
     * @memberof OverlappendePraksisstedavtalesokRequestDto
     */
    'avtaleslutt'?: string;
}
/**
 * 
 * @export
 * @interface OverlappendePraksisstedavtalesokResponseDto
 */
export interface OverlappendePraksisstedavtalesokResponseDto {
    /**
     * 
     * @type {Array<PraksisstedavtaleDto>}
     * @memberof OverlappendePraksisstedavtalesokResponseDto
     */
    'overlappendeAvtaler': Array<PraksisstedavtaleDto>;
}
/**
 * 
 * @export
 * @interface PeriodeDto
 */
export interface PeriodeDto {
    /**
     * 
     * @type {string}
     * @memberof PeriodeDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodeDto
     */
    'sluttDato': string;
}
/**
 * 
 * @export
 * @interface PersonDto
 */
export interface PersonDto {
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'fsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'etternavn': string;
}
/**
 * 
 * @export
 * @interface PraksisDto
 */
export interface PraksisDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetAvtalerDto
 */
export interface PraksisaktivitetAvtalerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetAvtalerDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetAvtalerDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {PraksisavtaleStedDto}
     * @memberof PraksisaktivitetAvtalerDto
     */
    'praksissted': PraksisavtaleStedDto;
    /**
     * 
     * @type {PraksisavtaleStedBestillingspunktTypeDto}
     * @memberof PraksisaktivitetAvtalerDto
     */
    'bestillingsmodus': PraksisavtaleStedBestillingspunktTypeDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetAvtalerDto
     */
    'periode'?: string;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetBestillingPutDto
 */
export interface PraksisaktivitetBestillingPutDto {
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetBestillingPutDto
     */
    'delt'?: boolean;
    /**
     * 
     * @type {Array<PraksisaktivitetPutBestillingDto>}
     * @memberof PraksisaktivitetBestillingPutDto
     */
    'bestillinger'?: Array<PraksisaktivitetPutBestillingDto>;
    /**
     * 
     * @type {Array<PraksisaktivitetPutKapasitetDto>}
     * @memberof PraksisaktivitetBestillingPutDto
     */
    'kapasiteter'?: Array<PraksisaktivitetPutKapasitetDto>;
    /**
     * 
     * @type {Array<PraksisavtaleIdToPraksisstedIderDto>}
     * @memberof PraksisaktivitetBestillingPutDto
     */
    'deaktiverteSteder'?: Array<PraksisavtaleIdToPraksisstedIderDto>;
    /**
     * 
     * @type {Array<PraksisavtaleIdToPraksisstedIderDto>}
     * @memberof PraksisaktivitetBestillingPutDto
     */
    'skjulteSteder'?: Array<PraksisavtaleIdToPraksisstedIderDto>;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetDto
 */
export interface PraksisaktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisaktivitetDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {AktivitetskravDto}
     * @memberof PraksisaktivitetDto
     */
    'krav': AktivitetskravDto;
    /**
     * 
     * @type {Array<AktivitetskravDto>}
     * @memberof PraksisaktivitetDto
     */
    'muligeKrav': Array<AktivitetskravDto>;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'sluttDato': string;
    /**
     * Delt med noen eller alle
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'delt': boolean;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'behov': number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'kapasitet': number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'studenter': number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'registreringsVarsler': number;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {Array<PraksisaktivitetAvtalerDto>}
     * @memberof PraksisaktivitetDto
     */
    'avtaler'?: Array<PraksisaktivitetAvtalerDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'publisertTilFs': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'publisertTilPs': boolean;
    /**
     * 
     * @type {PraksisaktivitetOnskelisteInfoDto}
     * @memberof PraksisaktivitetDto
     */
    'onskeliste': PraksisaktivitetOnskelisteInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {Array<PraksisavtaleIdToPraksisstedIderDto>}
     * @memberof PraksisaktivitetDto
     */
    'deaktiverteSteder': Array<PraksisavtaleIdToPraksisstedIderDto>;
    /**
     * 
     * @type {Array<PraksisavtaleIdToPraksisstedIderDto>}
     * @memberof PraksisaktivitetDto
     */
    'skjulteSteder': Array<PraksisavtaleIdToPraksisstedIderDto>;
    /**
     * 
     * @type {Array<PraksisavtaleIdToPraksisstedIderDto>}
     * @memberof PraksisaktivitetDto
     */
    'praksisstederMedFordelteStudenter'?: Array<PraksisavtaleIdToPraksisstedIderDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PraksisaktivitetDto
     */
    'praksisstederMedStudentOnsker'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'fritekst'?: string;
    /**
     * 
     * @type {PraksisaktivitetEndretDto}
     * @memberof PraksisaktivitetDto
     */
    'endret'?: PraksisaktivitetEndretDto;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'benytterVurdering'?: boolean;
    /**
     * 
     * @type {LaeringsutbyttegruppeDto}
     * @memberof PraksisaktivitetDto
     */
    'valgtLaeringsutbyttegruppe'?: LaeringsutbyttegruppeDto;
    /**
     * 
     * @type {FSAktivitetstatusDto}
     * @memberof PraksisaktivitetDto
     */
    'fsStatus': FSAktivitetstatusDto;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetEndretDto
 */
export interface PraksisaktivitetEndretDto {
    /**
     * 
     * @type {PersonDto}
     * @memberof PraksisaktivitetEndretDto
     */
    'endretAv'?: PersonDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetEndretDto
     */
    'endretTidspunkt'?: string;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDetaljertPsDto
 */
export interface PraksisaktivitetInfoDetaljertPsDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'emne'?: EmneDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'behov'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {Array<PraksisstedRollerDto>}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'rolle'?: Array<PraksisstedRollerDto>;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDetaljertUhDto
 */
export interface PraksisaktivitetInfoDetaljertUhDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'emne'?: EmneDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'behov'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {Array<StudiestedRollerDto>}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'rolle'?: Array<StudiestedRollerDto>;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDto
 */
export interface PraksisaktivitetInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDto
     */
    'behov': number;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetKopiEgenskaperDto
 */
export interface PraksisaktivitetKopiEgenskaperDto {
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetKopiEgenskaperDto
     */
    'kopierAktivitetskrav': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetKopiEgenskaperDto
     */
    'kopierFritekst': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetKopiEgenskaperDto
     */
    'kopierBestillinger': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetKopiEgenskaperDto
     */
    'kopierRoller': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetKopiEgenskaperDto
     */
    'kopierFordeling': boolean;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetKopiPostDto
 */
export interface PraksisaktivitetKopiPostDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetKopiPostDto
     */
    'praksisklasseId'?: string;
    /**
     * 
     * @type {PeriodeDto}
     * @memberof PraksisaktivitetKopiPostDto
     */
    'periode': PeriodeDto;
    /**
     * 
     * @type {PraksisaktivitetKopiEgenskaperDto}
     * @memberof PraksisaktivitetKopiPostDto
     */
    'egenskaper': PraksisaktivitetKopiEgenskaperDto;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetOnskelisteInfoDto
 */
export interface PraksisaktivitetOnskelisteInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetOnskelisteInfoDto
     */
    'aapnet': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetOnskelisteInfoDto
     */
    'aktivert': boolean;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetOnskelisteInfoDto
     */
    'kanEndresFra'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetOnskelisteInfoDto
     */
    'kanEndresTil'?: string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetOnskelisteInfoDto
     */
    'antallOnsker': number;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetPutBestillingDto
 */
export interface PraksisaktivitetPutBestillingDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutBestillingDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutBestillingDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutBestillingDto
     */
    'bestilling': number;
    /**
     * 
     * @type {PraksisavtaleStedBestillingspunktTypeDto}
     * @memberof PraksisaktivitetPutBestillingDto
     */
    'bestillingsmodus': PraksisavtaleStedBestillingspunktTypeDto;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetPutDto
 */
export interface PraksisaktivitetPutDto {
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutDto
     */
    'startDato'?: number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutDto
     */
    'sluttDato'?: number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutDto
     */
    'behov'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutDto
     */
    'aktivitetskravId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutDto
     */
    'klassenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutDto
     */
    'fritekst'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetPutDto
     */
    'benytterVurdering'?: boolean;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetPutKapasitetDto
 */
export interface PraksisaktivitetPutKapasitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutKapasitetDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutKapasitetDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutKapasitetDto
     */
    'kapasitet'?: number;
    /**
     * Om kapasitetpunkt skal settes
     * @type {boolean}
     * @memberof PraksisaktivitetPutKapasitetDto
     */
    'kapasitetspunkt'?: boolean;
    /**
     * 
     * @type {PraksisavtaleStedBestillingspunktTypeDto}
     * @memberof PraksisaktivitetPutKapasitetDto
     */
    'bestillingsmodus': PraksisavtaleStedBestillingspunktTypeDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisaktivitetStatusDto = {
    ManglerBehov: 'ManglerBehov',
    KanDeles: 'KanDeles',
    DeltMenManglerKapasitet: 'DeltMenManglerKapasitet',
    DeltMedNoenPraksissteder: 'DeltMedNoenPraksissteder',
    DeltOgHarKapasitet: 'DeltOgHarKapasitet',
    VenterPaaOnskeliste: 'VenterPaaOnskeliste',
    AvsluttetOnskeliste: 'AvsluttetOnskeliste',
    StudenterManglerKlasse: 'StudenterManglerKlasse',
    StudenterManglerPlass: 'StudenterManglerPlass',
    AlleStudenterFordelt: 'AlleStudenterFordelt',
    FordelingsresultatDelt: 'FordelingsresultatDelt',
    Aktiv: 'Aktiv',
    Gjennomfoert: 'Gjennomfoert',
    Avtalefeil: 'Avtalefeil'
} as const;

export type PraksisaktivitetStatusDto = typeof PraksisaktivitetStatusDto[keyof typeof PraksisaktivitetStatusDto];


/**
 * 
 * @export
 * @interface PraksisaktiviteterDto
 */
export interface PraksisaktiviteterDto {
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'gamle'?: Array<PraksisaktivitetInfoDto>;
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'aktive'?: Array<PraksisaktivitetInfoDto>;
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'fremtidige'?: Array<PraksisaktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisaktiviteterInfoDto
 */
export interface PraksisaktiviteterInfoDto {
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterInfoDto
     */
    'aktiviteter'?: Array<PraksisaktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisavtaleIdToPraksisstedIderDto
 */
export interface PraksisavtaleIdToPraksisstedIderDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleIdToPraksisstedIderDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PraksisavtaleIdToPraksisstedIderDto
     */
    'praksisstedIder': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleStedBestillingspunktTypeDto = {
    AvtaleSted: 'AvtaleSted',
    OmfattetAvtaleSted: 'OmfattetAvtaleSted'
} as const;

export type PraksisavtaleStedBestillingspunktTypeDto = typeof PraksisavtaleStedBestillingspunktTypeDto[keyof typeof PraksisavtaleStedBestillingspunktTypeDto];


/**
 * 
 * @export
 * @interface PraksisavtaleStedDto
 */
export interface PraksisavtaleStedDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleStedBestillingspunktTypeDto}
     * @memberof PraksisavtaleStedDto
     */
    'bestillingspunkt'?: PraksisavtaleStedBestillingspunktTypeDto;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtaleStedDto
     */
    'bestilling'?: number;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtaleStedDto
     */
    'kapasitet'?: number;
    /**
     * Om det kan meldes inn kapasitet på stedet
     * @type {boolean}
     * @memberof PraksisavtaleStedDto
     */
    'kapasitetspunkt': boolean;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'kapasitetstype'?: PraksisavtaleStedDtoKapasitetstypeDtoEnum;
    /**
     * 
     * @type {PraksisavtalestedValideringfeilDto}
     * @memberof PraksisavtaleStedDto
     */
    'valideringsfeil'?: PraksisavtalestedValideringfeilDto;
    /**
     * Nodens overnoder (direkte sti)
     * @type {Array<string>}
     * @memberof PraksisavtaleStedDto
     */
    'overnoder': Array<string>;
    /**
     * Nodens overnoder (sti inkl. alle søsken)
     * @type {Array<string>}
     * @memberof PraksisavtaleStedDto
     */
    'overnoderOgDeresSosken': Array<string>;
    /**
     * Nodens søsken (samme nivå i hierarkiet)
     * @type {Array<string>}
     * @memberof PraksisavtaleStedDto
     */
    'soskennoder': Array<string>;
    /**
     * 
     * @type {Array<PraksisavtaleStedDto>}
     * @memberof PraksisavtaleStedDto
     */
    'undernoder': Array<PraksisavtaleStedDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisavtaleStedDto
     */
    'harRegistrertAdminBruker': boolean;
}

export const PraksisavtaleStedDtoKapasitetstypeDtoEnum = {
    Praksissted: 'Praksissted',
    Studiested: 'Studiested'
} as const;

export type PraksisavtaleStedDtoKapasitetstypeDtoEnum = typeof PraksisavtaleStedDtoKapasitetstypeDtoEnum[keyof typeof PraksisavtaleStedDtoKapasitetstypeDtoEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleValideringfeiltypeDto = {
    Avtalenavn: 'MANGLER_AVTALENAVN',
    Avtalested: 'MANGLER_AVTALESTED',
    AvtaleVersjon: 'MANGLER_AVTALE_VERSJON',
    AvtalePraksistyper: 'MANGLER_AVTALE_PRAKSISTYPER',
    Avtaleeier: 'MANGLER_AVTALEEIER',
    AvtaleDato: 'MANGLER_AVTALE_DATO',
    AvtaleData: 'MANGLER_AVTALE_DATA'
} as const;

export type PraksisavtaleValideringfeiltypeDto = typeof PraksisavtaleValideringfeiltypeDto[keyof typeof PraksisavtaleValideringfeiltypeDto];


/**
 * 
 * @export
 * @interface PraksisavtaleValideringsfeilDto
 */
export interface PraksisavtaleValideringsfeilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleValideringsfeilDto
     */
    'message': string;
    /**
     * 
     * @type {PraksisavtaleValideringfeiltypeDto}
     * @memberof PraksisavtaleValideringsfeilDto
     */
    'errorType': PraksisavtaleValideringfeiltypeDto;
}


/**
 * 
 * @export
 * @interface PraksisavtaleVedleggDto
 */
export interface PraksisavtaleVedleggDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleVedleggTypeDto}
     * @memberof PraksisavtaleVedleggDto
     */
    'type': PraksisavtaleVedleggTypeDto;
    /**
     * Filstørrelse gitt i antall bytes
     * @type {number}
     * @memberof PraksisavtaleVedleggDto
     */
    'filStorrelse': number;
    /**
     * Signert URI som fungerer som billett for å få laste ned vedlegg. Billett utløper etter 10 minutter, og kan bare brukes en gang. 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'vedlegg': string;
}


/**
 * 
 * @export
 * @interface PraksisavtaleVedleggMinimalDto
 */
export interface PraksisavtaleVedleggMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleVedleggTypeDto}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'type': PraksisavtaleVedleggTypeDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'resourceLink': string;
}


/**
 * 
 * @export
 * @interface PraksisavtaleVedleggPostDto
 */
export interface PraksisavtaleVedleggPostDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggPostDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleVedleggTypeDto}
     * @memberof PraksisavtaleVedleggPostDto
     */
    'type': PraksisavtaleVedleggTypeDto;
    /**
     * 
     * @type {File}
     * @memberof PraksisavtaleVedleggPostDto
     */
    'vedlegg': File;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleVedleggTypeDto = {
    Samarbeidsavtale: 'Samarbeidsavtale',
    Databehandleravtale: 'Databehandleravtale',
    Annet: 'Annet'
} as const;

export type PraksisavtaleVedleggTypeDto = typeof PraksisavtaleVedleggTypeDto[keyof typeof PraksisavtaleVedleggTypeDto];


/**
 * 
 * @export
 * @interface PraksisavtalestedValideringfeilDto
 */
export interface PraksisavtalestedValideringfeilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'message': string;
    /**
     * 
     * @type {PraksisavtalestedValideringfeiltypeDto}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'errorType': PraksisavtalestedValideringfeiltypeDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'sourceType'?: PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'bestilling'?: number;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'kapasitet'?: number;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisavtalestedValideringfeilDto
     */
    'praksisstedForBesvarelsensBestilling'?: MinimalPraksisstedDto;
}

export const PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum = {
    Bestilling: 'BESTILLING',
    Besvarelse: 'BESVARELSE'
} as const;

export type PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum = typeof PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum[keyof typeof PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtalestedValideringfeiltypeDto = {
    MissingAvtalested: 'MISSING_AVTALESTED',
    MissingFromAktivitetskrav: 'MISSING_FROM_AKTIVITETSKRAV',
    MissingFromTopTree: 'MISSING_FROM_TOP_TREE',
    MissingOmfattetPraksissted: 'MISSING_OMFATTET_PRAKSISSTED',
    DeaktivertSted: 'DEAKTIVERT_STED',
    PathMismatch: 'PATH_MISMATCH',
    UtloeptSted: 'UTLOEPT_STED',
    UnderliggendeFeil: 'UNDERLIGGENDE_FEIL',
    HierarchicalBestilling: 'HIERARCHICAL_BESTILLING',
    OverlappingAvtalestedHierarchies: 'OVERLAPPING_AVTALESTED_HIERARCHIES',
    OverlappingBesvarelse: 'OVERLAPPING_BESVARELSE',
    NotWithinAvtalePeriod: 'NOT_WITHIN_AVTALE_PERIOD',
    InactivePraksistype: 'INACTIVE_PRAKSISTYPE',
    InactivePraksisavtale: 'INACTIVE_PRAKSISAVTALE'
} as const;

export type PraksisavtalestedValideringfeiltypeDto = typeof PraksisavtalestedValideringfeiltypeDto[keyof typeof PraksisavtalestedValideringfeiltypeDto];


/**
 * 
 * @export
 * @interface PraksiskalenderAktivitetDto
 */
export interface PraksiskalenderAktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'klasseId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksiskalenderAktivitetDto
     */
    'delt': boolean;
    /**
     * 
     * @type {number}
     * @memberof PraksiskalenderAktivitetDto
     */
    'behov': number;
    /**
     * 
     * @type {number}
     * @memberof PraksiskalenderAktivitetDto
     */
    'kapasitet': number;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksiskalenderAktivitetDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {FSAktivitetstatustypeDto}
     * @memberof PraksiskalenderAktivitetDto
     */
    'fsStatus': FSAktivitetstatustypeDto;
}


/**
 * 
 * @export
 * @interface PraksiskalenderDto
 */
export interface PraksiskalenderDto {
    /**
     * 
     * @type {Array<PraksisklasserPrEmneDto>}
     * @memberof PraksiskalenderDto
     */
    'klasser': Array<PraksisklasserPrEmneDto>;
    /**
     * 
     * @type {Array<PraksiskalenderAktivitetDto>}
     * @memberof PraksiskalenderDto
     */
    'aktiviteter': Array<PraksiskalenderAktivitetDto>;
}
/**
 * 
 * @export
 * @interface PraksisklasseDto
 */
export interface PraksisklasseDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'bokstav': string;
    /**
     * 
     * @type {UndervisningsenhetPeriodeDto}
     * @memberof PraksisklasseDto
     */
    'undervisningsenhetPeriode': UndervisningsenhetPeriodeDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'presentertNavn'?: string;
}
/**
 * 
 * @export
 * @interface PraksisklasseMedAktiviteterDto
 */
export interface PraksisklasseMedAktiviteterDto {
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisklasseMedAktiviteterDto
     */
    'praksisklasse': PraksisklasseDto;
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisklasseMedAktiviteterDto
     */
    'aktiviteter': Array<PraksisaktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisklasserPrEmneDto
 */
export interface PraksisklasserPrEmneDto {
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisklasserPrEmneDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisklasserPrEmneDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisklasserPrEmneDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {Array<PraksisklasseDto>}
     * @memberof PraksisklasserPrEmneDto
     */
    'klasser': Array<PraksisklasseDto>;
}
/**
 * 
 * @export
 * @interface PraksisplassTilFordelingDto
 */
export interface PraksisplassTilFordelingDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisplassTilFordelingDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {number}
     * @memberof PraksisplassTilFordelingDto
     */
    'kapasitet': number;
    /**
     * 
     * @type {string}
     * @memberof PraksisplassTilFordelingDto
     */
    'hierarkiSti': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisplassTilFordelingDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof PraksisplassTilFordelingDto
     */
    'muligeVeiledere': Array<PersonDto>;
    /**
     * Om det er valideringsfeil for tildelt kapasitet på praksisstedet
     * @type {boolean}
     * @memberof PraksisplassTilFordelingDto
     */
    'hasValideringsfeil': boolean;
}
/**
 * 
 * @export
 * @interface PraksisstedByAvtaleIdDto
 */
export interface PraksisstedByAvtaleIdDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedByAvtaleIdDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedByAvtaleIdDto
     */
    'avtaleId': string;
}
/**
 * 
 * @export
 * @interface PraksisstedDto
 */
export interface PraksisstedDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedDto
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedDto
     */
    'brukerStatus': PraksisstedDtoBrukerStatusDtoEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisstedDto
     */
    'canInvite'?: boolean;
}

export const PraksisstedDtoBrukerStatusDtoEnum = {
    IkkeInvitert: 'ikke_invitert',
    Invitert: 'invitert',
    HarBruker: 'har_bruker'
} as const;

export type PraksisstedDtoBrukerStatusDtoEnum = typeof PraksisstedDtoBrukerStatusDtoEnum[keyof typeof PraksisstedDtoBrukerStatusDtoEnum];

/**
 * 
 * @export
 * @interface PraksisstedInfoPutDto
 */
export interface PraksisstedInfoPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'adresselinje1': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'postnr': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'poststed': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'telefonlandnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedMedValideringsfeilDto
 */
export interface PraksisstedMedValideringsfeilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedValideringsfeilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedValideringsfeilDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedValideringsfeilDto
     */
    'avtaleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedValideringsfeilDto
     */
    'avtaleNavn'?: string;
    /**
     * 
     * @type {PraksisavtalestedValideringfeilDto}
     * @memberof PraksisstedMedValideringsfeilDto
     */
    'valideringsfeil'?: PraksisavtalestedValideringfeilDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisstedRollerDto = {
    Koordinator: 'Koordinator',
    Veileder: 'Veileder'
} as const;

export type PraksisstedRollerDto = typeof PraksisstedRollerDto[keyof typeof PraksisstedRollerDto];


/**
 * 
 * @export
 * @interface PraksisstedTilFordelingDto
 */
export interface PraksisstedTilFordelingDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedTilFordelingDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {Array<PraksisplassTilFordelingDto>}
     * @memberof PraksisstedTilFordelingDto
     */
    'muligePraksisplasser': Array<PraksisplassTilFordelingDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedTilgangerDto
 */
export interface PraksisstedTilgangerDto {
    /**
     * Om innlogget bruker har lov til å slette tilgangen
     * @type {boolean}
     * @memberof PraksisstedTilgangerDto
     */
    'kanRedigere': boolean;
    /**
     * 
     * @type {MuligePraksisstedDto}
     * @memberof PraksisstedTilgangerDto
     */
    'praksissted': MuligePraksisstedDto;
    /**
     * 
     * @type {BrukerrollerPSDto}
     * @memberof PraksisstedTilgangerDto
     */
    'brukerrolle': BrukerrollerPSDto;
}


/**
 * 
 * @export
 * @interface PraksisstedUndernodeDto
 */
export interface PraksisstedUndernodeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedUndernodeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedUndernodeDto
     */
    'navn'?: string;
    /**
     * 
     * @type {Array<PraksisstedUndernodeDto>}
     * @memberof PraksisstedUndernodeDto
     */
    'under'?: Array<PraksisstedUndernodeDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedavtaleAllOfDto
 */
export interface PraksisstedavtaleAllOfDto {
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedDto}
     * @memberof PraksisstedavtaleAllOfDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }}
     * @memberof PraksisstedavtaleAllOfDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; };
}
/**
 * 
 * @export
 * @interface PraksisstedavtaleCommonDto
 */
export interface PraksisstedavtaleCommonDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'kanEndre': boolean;
}


/**
 * 
 * @export
 * @interface PraksisstedavtaleDto
 */
export interface PraksisstedavtaleDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedDto}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }}
     * @memberof PraksisstedavtaleDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; };
}


/**
 * 
 * @export
 * @interface PraksisstedavtaleMedStedForelderHierarkiAllOfDto
 */
export interface PraksisstedavtaleMedStedForelderHierarkiAllOfDto {
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiAllOfDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiAllOfDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; };
}
/**
 * 
 * @export
 * @interface PraksisstedavtaleMedStedForelderHierarkiDto
 */
export interface PraksisstedavtaleMedStedForelderHierarkiDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; };
}


/**
 * 
 * @export
 * @interface PraksisstedavtalePostDto
 */
export interface PraksisstedavtalePostDto {
    /**
     * Navnet på praksisavtalen
     * @type {string}
     * @memberof PraksisstedavtalePostDto
     */
    'avtalenavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtalePostDto
     */
    'avtalestart': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtalePostDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtalePostDto
     */
    'signatarer': MultiSignatarerDto;
    /**
     * 
     * @type {SaksansvarligDto}
     * @memberof PraksisstedavtalePostDto
     */
    'saksansvarlig': SaksansvarligDto;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedPostDto}
     * @memberof PraksisstedavtalePostDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedPostDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {Array<AvtalestederMedMuligeOmfattedePraksisstedPostDto>}
     * @memberof PraksisstedavtalePostDto
     */
    'avtalesteder': Array<AvtalestederMedMuligeOmfattedePraksisstedPostDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PraksisstedavtalePostDto
     */
    'praksistypekoder': Array<string>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtalePostDto
     */
    'avtaleErSignertAvAlle': boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtalePostDto
     */
    'delIdentitetsnummer': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisstedavtaleViewDto = {
    Praksisstedavtale: 'Praksisstedavtale',
    PraksisstedavtaleMedStedForelderHierarki: 'PraksisstedavtaleMedStedForelderHierarki'
} as const;

export type PraksisstedavtaleViewDto = typeof PraksisstedavtaleViewDto[keyof typeof PraksisstedavtaleViewDto];


/**
 * 
 * @export
 * @interface PraksisstedavtalerDto
 */
export interface PraksisstedavtalerDto {
    /**
     * 
     * @type {Array<PraksisstedavtaleDto>}
     * @memberof PraksisstedavtalerDto
     */
    'avtaler'?: Array<PraksisstedavtaleDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerDto
 */
export interface PraksisstedbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {BrukerrollerPSDto}
     * @memberof PraksisstedbrukerDto
     */
    'tilgangsrolle': BrukerrollerPSDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'lagtTilAvInstitusjon'?: string;
    /**
     * Om brukeren er slettet eller utløpt
     * @type {boolean}
     * @memberof PraksisstedbrukerDto
     */
    'deaktivert'?: boolean;
    /**
     * Om brukeren er en plassholder (invitert - ikke registrert)
     * @type {boolean}
     * @memberof PraksisstedbrukerDto
     */
    'plassholder'?: boolean;
}


/**
 * 
 * @export
 * @interface PraksisstedbrukerSignatarDto
 */
export interface PraksisstedbrukerSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'praksisstedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilDto
 */
export interface PraksisstedbrukerprofilDto {
    /**
     * 
     * @type {PraksisstedbrukerDto}
     * @memberof PraksisstedbrukerprofilDto
     */
    'bruker': PraksisstedbrukerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilDto
     */
    'praksisstedNavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilDto
     */
    'bildeUrl'?: string;
    /**
     * 
     * @type {PraksisstedbrukerprofilKanRedigereDto}
     * @memberof PraksisstedbrukerprofilDto
     */
    'kanRedigere': PraksisstedbrukerprofilKanRedigereDto;
    /**
     * 
     * @type {Array<PraksisstedTilgangerDto>}
     * @memberof PraksisstedbrukerprofilDto
     */
    'tilganger'?: Array<PraksisstedTilgangerDto>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisstedbrukerprofilKanRedigereDto = {
    ProfilOgTilganger: 'ProfilOgTilganger',
    Profil: 'Profil',
    Ingen: 'Ingen'
} as const;

export type PraksisstedbrukerprofilKanRedigereDto = typeof PraksisstedbrukerprofilKanRedigereDto[keyof typeof PraksisstedbrukerprofilKanRedigereDto];


/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilPutDto
 */
export interface PraksisstedbrukerprofilPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {Array<PraksisstedbrukerprofilPutTilgangerInnerDto>}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'tilganger'?: Array<PraksisstedbrukerprofilPutTilgangerInnerDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilPutTilgangerInnerDto
 */
export interface PraksisstedbrukerprofilPutTilgangerInnerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutTilgangerInnerDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {BrukerrollerPSDto}
     * @memberof PraksisstedbrukerprofilPutTilgangerInnerDto
     */
    'tilgangsrolle': BrukerrollerPSDto;
}


/**
 * 
 * @export
 * @interface PraksisstederForAktivitetskravDto
 */
export interface PraksisstederForAktivitetskravDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstederForAktivitetskravDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstederForAktivitetskravDto
     */
    'navn': string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisstederForAktivitetskravDto
     */
    'oppfyllerKrav': boolean;
    /**
     * 
     * @type {Array<PraksisstederForAktivitetskravDto>}
     * @memberof PraksisstederForAktivitetskravDto
     */
    'undernoder': Array<PraksisstederForAktivitetskravDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilAdresseDto
 */
export interface PraksisstedprofilAdresseDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'poststed'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilDto
 */
export interface PraksisstedprofilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'orgnr'?: string;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedprofilDto
     */
    'avdeling'?: MinimalPraksisstedDto;
    /**
     * 
     * @type {PraksisstedprofilAdresseDto}
     * @memberof PraksisstedprofilDto
     */
    'adresse'?: PraksisstedprofilAdresseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'nettsideUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'telefonlandnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'bildeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisstedprofilNoderDto}
     * @memberof PraksisstedprofilDto
     */
    'noder': PraksisstedprofilNoderDto;
    /**
     * Om innlogget bruker har lov til å redigere profilen
     * @type {boolean}
     * @memberof PraksisstedprofilDto
     */
    'kanRedigere': boolean;
    /**
     * Om innlogget bruker er admin over praksisstedet
     * @type {boolean}
     * @memberof PraksisstedprofilDto
     */
    'erAdmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'sistEndret'?: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof PraksisstedprofilDto
     */
    'sistEndretAvStudiestedbruker'?: PersonDto;
    /**
     * 
     * @type {PersonDto}
     * @memberof PraksisstedprofilDto
     */
    'sistEndretAvPraksisstedbruker'?: PersonDto;
    /**
     * Praksisstedbrukere med spesifikk tilgang ved praksisstedet
     * @type {Array<PraksisstedbrukerDto>}
     * @memberof PraksisstedprofilDto
     */
    'brukere'?: Array<PraksisstedbrukerDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilNoderDto
 */
export interface PraksisstedprofilNoderDto {
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof PraksisstedprofilNoderDto
     */
    'over': Array<MinimalPraksisstedDto>;
    /**
     * 
     * @type {Array<PraksisstedUndernodeDto>}
     * @memberof PraksisstedprofilNoderDto
     */
    'under': Array<PraksisstedUndernodeDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilPutDto
 */
export interface PraksisstedprofilPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilPutDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilPutDto
     */
    'krav'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedtypeDto
 */
export interface PraksisstedtypeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedtypeDto
     */
    'praksisstedtypekode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedtypeDto
     */
    'praksisstedtypenavn'?: string;
}
/**
 * 
 * @export
 * @interface PraksistypeDto
 */
export interface PraksistypeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksistypeDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof PraksistypeDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface PraksistypeMedAktivitetskravDto
 */
export interface PraksistypeMedAktivitetskravDto {
    /**
     * 
     * @type {PraksistypeDto}
     * @memberof PraksistypeMedAktivitetskravDto
     */
    'praksistype': PraksistypeDto;
    /**
     * 
     * @type {Array<AktivitetskravDto>}
     * @memberof PraksistypeMedAktivitetskravDto
     */
    'aktivitetskrav': Array<AktivitetskravDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PraksistypeMedAktivitetskravDto
     */
    'kanEndre': boolean;
}
/**
 * 
 * @export
 * @interface PraksistypeMedEmnerDto
 */
export interface PraksistypeMedEmnerDto {
    /**
     * 
     * @type {PraksistypeDto}
     * @memberof PraksistypeMedEmnerDto
     */
    'praksistype': PraksistypeDto;
    /**
     * 
     * @type {Array<EmneDto>}
     * @memberof PraksistypeMedEmnerDto
     */
    'emner': Array<EmneDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RegistreringsStatusDto = {
    Avmeldt: 'Avmeldt',
    IkkeRegistrert: 'IkkeRegistrert',
    Registrert: 'Registrert'
} as const;

export type RegistreringsStatusDto = typeof RegistreringsStatusDto[keyof typeof RegistreringsStatusDto];


/**
 * 
 * @export
 * @interface RolleDto
 */
export interface RolleDto {
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {RolleTypeDto}
     * @memberof RolleDto
     */
    'type': RolleTypeDto;
    /**
     * Om brukeren er slettet
     * @type {boolean}
     * @memberof RolleDto
     */
    'slettet': boolean;
}
/**
 * 
 * @export
 * @interface RolleTypeDto
 */
export interface RolleTypeDto {
    /**
     * 
     * @type {StudiestedRollerDto}
     * @memberof RolleTypeDto
     */
    'studiestedrolle'?: StudiestedRollerDto;
    /**
     * 
     * @type {PraksisstedRollerDto}
     * @memberof RolleTypeDto
     */
    'praksisstedrolle'?: PraksisstedRollerDto;
}


/**
 * 
 * @export
 * @interface SaksansvarligDto
 */
export interface SaksansvarligDto {
    /**
     * 
     * @type {string}
     * @memberof SaksansvarligDto
     */
    'studiestedbrukerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaksansvarligDto
     */
    'navn'?: string;
}
/**
 * 
 * @export
 * @interface StudentVurderingDto
 */
export interface StudentVurderingDto {
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'studentVurderingId': string;
    /**
     * 
     * @type {VurderingStudentDto}
     * @memberof StudentVurderingDto
     */
    'student': VurderingStudentDto;
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'vurderingsstatus': StudentVurderingDtoVurderingsstatusDtoEnum;
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'studiestedNavn': string;
}

export const StudentVurderingDtoVurderingsstatusDtoEnum = {
    Aktiv: 'Aktiv',
    AvbruttPraksis: 'Avbrutt Praksis',
    PraksisFullfrt: 'Praksis Fullført'
} as const;

export type StudentVurderingDtoVurderingsstatusDtoEnum = typeof StudentVurderingDtoVurderingsstatusDtoEnum[keyof typeof StudentVurderingDtoVurderingsstatusDtoEnum];

/**
 * 
 * @export
 * @interface StudentbrukerDto
 */
export interface StudentbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'telefonnummer': string;
}
/**
 * 
 * @export
 * @interface StudentbrukerprofilDto
 */
export interface StudentbrukerprofilDto {
    /**
     * 
     * @type {StudentbrukerDto}
     * @memberof StudentbrukerprofilDto
     */
    'bruker': StudentbrukerDto;
}
/**
 * 
 * @export
 * @interface StudenterForVurderingDto
 */
export interface StudenterForVurderingDto {
    /**
     * 
     * @type {Array<StudentVurderingDto>}
     * @memberof StudenterForVurderingDto
     */
    'studenter': Array<StudentVurderingDto>;
}
/**
 * 
 * @export
 * @interface StudenterMedKlasseDto
 */
export interface StudenterMedKlasseDto {
    /**
     * 
     * @type {string}
     * @memberof StudenterMedKlasseDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudenterMedKlasseDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudenterMedKlasseDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudenterMedKlasseDto
     */
    'fsKlasse'?: string;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof StudenterMedKlasseDto
     */
    'klasse'?: PraksisklasseDto;
    /**
     * 
     * @type {RegistreringsStatusDto}
     * @memberof StudenterMedKlasseDto
     */
    'status': RegistreringsStatusDto;
}


/**
 * 
 * @export
 * @interface StudentfordelingDto
 */
export interface StudentfordelingDto {
    /**
     * 
     * @type {PersonDto}
     * @memberof StudentfordelingDto
     */
    'student': PersonDto;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingDto
     */
    'undervisere'?: Array<PersonDto>;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingDto
     */
    'veiledere'?: Array<PersonDto>;
    /**
     * 
     * @type {PraksisstedByAvtaleIdDto}
     * @memberof StudentfordelingDto
     */
    'praksisplass'?: PraksisstedByAvtaleIdDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof StudentfordelingDto
     */
    'onskeliste'?: Array<MinimalPraksisstedDto>;
    /**
     * Om det er valideringsfeil for tildelt kapasitet på praksisplassen
     * @type {boolean}
     * @memberof StudentfordelingDto
     */
    'hasValideringsfeil': boolean;
}
/**
 * 
 * @export
 * @interface StudentfordelingMedValgDto
 */
export interface StudentfordelingMedValgDto {
    /**
     * 
     * @type {Array<StudentfordelingDto>}
     * @memberof StudentfordelingMedValgDto
     */
    'studentfordeling': Array<StudentfordelingDto>;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingMedValgDto
     */
    'muligeUndervisere': Array<PersonDto>;
    /**
     * 
     * @type {Array<PraksisstedTilFordelingDto>}
     * @memberof StudentfordelingMedValgDto
     */
    'muligePraksissteder': Array<PraksisstedTilFordelingDto>;
}
/**
 * 
 * @export
 * @interface StudentfordelingPutDto
 */
export interface StudentfordelingPutDto {
    /**
     * 
     * @type {string}
     * @memberof StudentfordelingPutDto
     */
    'studentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudentfordelingPutDto
     */
    'underviserIder'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StudentfordelingPutDto
     */
    'praksisplassId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudentfordelingPutDto
     */
    'veilederIder'?: Array<string>;
}
/**
 * 
 * @export
 * @interface StudentregistreringDto
 */
export interface StudentregistreringDto {
    /**
     * 
     * @type {Array<PraksisklasseDto>}
     * @memberof StudentregistreringDto
     */
    'muligeKlasser': Array<PraksisklasseDto>;
    /**
     * 
     * @type {Array<StudenterMedKlasseDto>}
     * @memberof StudentregistreringDto
     */
    'studenter': Array<StudenterMedKlasseDto>;
}
/**
 * 
 * @export
 * @interface StudentregistreringPutDto
 */
export interface StudentregistreringPutDto {
    /**
     * 
     * @type {string}
     * @memberof StudentregistreringPutDto
     */
    'studentId': string;
    /**
     * 
     * @type {string}
     * @memberof StudentregistreringPutDto
     */
    'klasseId'?: string;
}
/**
 * 
 * @export
 * @interface StudentregistreringPutWrappedDto
 */
export interface StudentregistreringPutWrappedDto {
    /**
     * 
     * @type {Array<StudentregistreringPutDto>}
     * @memberof StudentregistreringPutWrappedDto
     */
    'wrapped': Array<StudentregistreringPutDto>;
}
/**
 * 
 * @export
 * @interface StudiestedDto
 */
export interface StudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudiestedDto
     */
    'navn': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StudiestedRollerDto = {
    Koordinator: 'Koordinator',
    Underviser: 'Underviser'
} as const;

export type StudiestedRollerDto = typeof StudiestedRollerDto[keyof typeof StudiestedRollerDto];


/**
 * 
 * @export
 * @interface StudiestedTilgangerDto
 */
export interface StudiestedTilgangerDto {
    /**
     * Om innlogget bruker har lov til å slette tilgangen
     * @type {boolean}
     * @memberof StudiestedTilgangerDto
     */
    'kanRedigere': boolean;
    /**
     * 
     * @type {MuligeStudiestedDto}
     * @memberof StudiestedTilgangerDto
     */
    'studiested': MuligeStudiestedDto;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof StudiestedTilgangerDto
     */
    'brukerrolle': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface StudiestedbrukerDto
 */
export interface StudiestedbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof StudiestedbrukerDto
     */
    'tilgangsrolle': BrukerrollerDto;
    /**
     * 
     * @type {StudiestedTilgangerDto}
     * @memberof StudiestedbrukerDto
     */
    'tilhorighet'?: StudiestedTilgangerDto;
    /**
     * 
     * @type {boolean}
     * @memberof StudiestedbrukerDto
     */
    'kanSlette'?: boolean;
}


/**
 * 
 * @export
 * @interface StudiestedbrukerSignatarDto
 */
export interface StudiestedbrukerSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'studiestedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'studiestedbrukerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'telefonnummer': string;
}
/**
 * 
 * @export
 * @interface StudiestedbrukerprofilDto
 */
export interface StudiestedbrukerprofilDto {
    /**
     * 
     * @type {StudiestedbrukerDto}
     * @memberof StudiestedbrukerprofilDto
     */
    'bruker': StudiestedbrukerDto;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilDto
     */
    'bildeUrl'?: string;
    /**
     * Om innlogget bruker har lov til å redigere profilen
     * @type {boolean}
     * @memberof StudiestedbrukerprofilDto
     */
    'kanRedigere': boolean;
    /**
     * 
     * @type {Array<StudiestedTilgangerDto>}
     * @memberof StudiestedbrukerprofilDto
     */
    'tilganger': Array<StudiestedTilgangerDto>;
}
/**
 * 
 * @export
 * @interface StudiestedbrukerprofilPutDto
 */
export interface StudiestedbrukerprofilPutDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilPutDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilPutDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilPutDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {Array<StudiestedbrukerprofilPutTilgangerInnerDto>}
     * @memberof StudiestedbrukerprofilPutDto
     */
    'tilganger'?: Array<StudiestedbrukerprofilPutTilgangerInnerDto>;
}
/**
 * 
 * @export
 * @interface StudiestedbrukerprofilPutTilgangerInnerDto
 */
export interface StudiestedbrukerprofilPutTilgangerInnerDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilPutTilgangerInnerDto
     */
    'studiestedId': string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof StudiestedbrukerprofilPutTilgangerInnerDto
     */
    'brukerrolle': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface UndervisningsenhetPeriodeDto
 */
export interface UndervisningsenhetPeriodeDto {
    /**
     * 
     * @type {string}
     * @memberof UndervisningsenhetPeriodeDto
     */
    'undervisningsenhetId': string;
    /**
     * 
     * @type {number}
     * @memberof UndervisningsenhetPeriodeDto
     */
    'start': number;
    /**
     * 
     * @type {number}
     * @memberof UndervisningsenhetPeriodeDto
     */
    'slutt': number;
}
/**
 * 
 * @export
 * @interface UndervisningsenhetToPraksisklasseMedAktiviteterDto
 */
export interface UndervisningsenhetToPraksisklasseMedAktiviteterDto {
    /**
     * 
     * @type {UndervisningsenhetPeriodeDto}
     * @memberof UndervisningsenhetToPraksisklasseMedAktiviteterDto
     */
    'undervisningsenhetPeriode': UndervisningsenhetPeriodeDto;
    /**
     * 
     * @type {Array<PraksisklasseMedAktiviteterDto>}
     * @memberof UndervisningsenhetToPraksisklasseMedAktiviteterDto
     */
    'praksisklasseMedAktiviteter': Array<PraksisklasseMedAktiviteterDto>;
}
/**
 * 
 * @export
 * @interface VurderingKommentarerDto
 */
export interface VurderingKommentarerDto {
    /**
     * 
     * @type {Array<LaeringsutbytteMedRollersKommentarDto>}
     * @memberof VurderingKommentarerDto
     */
    'laeringsutbytteMedRollersKommentar': Array<LaeringsutbytteMedRollersKommentarDto>;
}
/**
 * 
 * @export
 * @interface VurderingOppsummeringDto
 */
export interface VurderingOppsummeringDto {
    /**
     * 
     * @type {string}
     * @memberof VurderingOppsummeringDto
     */
    'oppsummering': string;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'ikkeBestatt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'samletVurderingDelt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'vurderingBekreftet': boolean;
    /**
     * 
     * @type {number}
     * @memberof VurderingOppsummeringDto
     */
    'timerFravaer'?: number;
}
/**
 * 
 * @export
 * @interface VurderingStudentDto
 */
export interface VurderingStudentDto {
    /**
     * Id pointing to a specific evaluation for a student.
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'fsStudentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'etternavn': string;
    /**
     * 
     * @type {number}
     * @memberof VurderingStudentDto
     */
    'studentnr'?: number;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'telefon'?: string;
}
/**
 * 
 * @export
 * @interface VurderingsinnstillingerDto
 */
export interface VurderingsinnstillingerDto {
    /**
     * 
     * @type {VurderingsrollerDto}
     * @memberof VurderingsinnstillingerDto
     */
    'roller': VurderingsrollerDto;
    /**
     * 
     * @type {VurderingstyperDto}
     * @memberof VurderingsinnstillingerDto
     */
    'vurderingstyper': VurderingstyperDto;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingsinnstillingerDto
     */
    'usesVurdering': boolean;
}
/**
 * 
 * @export
 * @interface VurderingskriterieDto
 */
export interface VurderingskriterieDto {
    /**
     * 
     * @type {string}
     * @memberof VurderingskriterieDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VurderingskriterieDto
     */
    'navn': string;
    /**
     * Beskrivelse for vurderingskriterie
     * @type {string}
     * @memberof VurderingskriterieDto
     */
    'beskrivelse'?: string;
}
/**
 * 
 * @export
 * @interface VurderingsrollerDto
 */
export interface VurderingsrollerDto {
    /**
     * 
     * @type {boolean}
     * @memberof VurderingsrollerDto
     */
    'underviser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingsrollerDto
     */
    'veileder': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingsrollerDto
     */
    'student': boolean;
}
/**
 * 
 * @export
 * @interface VurderingstyperDto
 */
export interface VurderingstyperDto {
    /**
     * 
     * @type {boolean}
     * @memberof VurderingstyperDto
     */
    'kontinuerlig': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingstyperDto
     */
    'midtveisvurdering': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingstyperDto
     */
    'sluttvurdering': boolean;
}

        /**
        * AvtaleApi - object-oriented interface
        * @export
        * @class AvtaleApiInterface
        * @extends {BaseAPI}
        */
        export interface AvtaleApiInterface {
            /**
            * 
                * @summary Henter alle vedlegg til praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggGet(params: { 
                pathParams: { avtaleId: string,  },
            options?: any
            }): Promise<HalPraksisavtaleVedleggMinimalListDto>;
            /**
            * 
                * @summary Opprette ny vedlegg for praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggPost(params: { 
                pathParams: { avtaleId: string,  },
                formParams: { navn:string, type:PraksisavtaleVedleggTypeDto, vedlegg:File,  }, 
            options?: any
            }): Promise<PraksisavtaleVedleggMinimalDto>;
            /**
            * 
                * @summary Sletter avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggVedleggIdDelete(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter gitt avtalevedlegg ved gyldig nedlasting billett
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<File>;
            /**
            * 
                * @summary Henter en avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggVedleggIdGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<PraksisavtaleVedleggDto>;
            }
        /**
        * AvtaleApi - object-oriented interface
        * @export
        * @class AvtaleApi
        * @extends {BaseAPI}
        */
            export class AvtaleApi extends BaseAPI implements AvtaleApiInterface {
            /**
            * 
                * @summary Henter alle vedlegg til praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggGet(params: { 
                pathParams: { avtaleId: string,  },
            options?: any
            }): Promise<HalPraksisavtaleVedleggMinimalListDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Opprette ny vedlegg for praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggPost(params: { 
                pathParams: { avtaleId: string,  },
                formParams: { navn:string, type:PraksisavtaleVedleggTypeDto, vedlegg:File,  }, 
            options?: any
            }): Promise<PraksisavtaleVedleggMinimalDto> {
            return await this.POST(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg", params.pathParams),
        {},
        { body: params.formParams, contentType: "application/x-www-form-urlencoded" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggVedleggIdDelete(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg/{vedleggId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter gitt avtalevedlegg ved gyldig nedlasting billett
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<File> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg/{vedleggId}/download", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter en avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggVedleggIdGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<PraksisavtaleVedleggDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg/{vedleggId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockAvtaleApi(operations: {
            avtalerPraksisAvtaleIdVedleggGet?: (params: { 
                    pathParams: { avtaleId: string,  },
                options?: any
                }) => Promise<HalPraksisavtaleVedleggMinimalListDto>
            avtalerPraksisAvtaleIdVedleggPost?: (params: { 
                    pathParams: { avtaleId: string,  },
                    formParams: { navn:string, type:PraksisavtaleVedleggTypeDto, vedlegg:File,  }, 
                options?: any
                }) => Promise<PraksisavtaleVedleggMinimalDto>
            avtalerPraksisAvtaleIdVedleggVedleggIdDelete?: (params: { 
                    pathParams: { avtaleId: string, vedleggId: string,  },
                options?: any
                }) => Promise<void>
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet?: (params: { 
                    pathParams: { avtaleId: string, vedleggId: string,  },
                options?: any
                }) => Promise<File>
            avtalerPraksisAvtaleIdVedleggVedleggIdGet?: (params: { 
                    pathParams: { avtaleId: string, vedleggId: string,  },
                options?: any
                }) => Promise<PraksisavtaleVedleggDto>
            }): AvtaleApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            avtalerPraksisAvtaleIdVedleggGet: (operations.avtalerPraksisAvtaleIdVedleggGet || reject("avtalerPraksisAvtaleIdVedleggGet")),
            avtalerPraksisAvtaleIdVedleggPost: (operations.avtalerPraksisAvtaleIdVedleggPost || reject("avtalerPraksisAvtaleIdVedleggPost")),
            avtalerPraksisAvtaleIdVedleggVedleggIdDelete: (operations.avtalerPraksisAvtaleIdVedleggVedleggIdDelete || reject("avtalerPraksisAvtaleIdVedleggVedleggIdDelete")),
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet: (operations.avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet || reject("avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet")),
            avtalerPraksisAvtaleIdVedleggVedleggIdGet: (operations.avtalerPraksisAvtaleIdVedleggVedleggIdGet || reject("avtalerPraksisAvtaleIdVedleggVedleggIdGet")),
            };
            }


        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApiInterface
        * @extends {BaseAPI}
        */
        export interface BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto>;
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoInnstillingerPut(params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterDetaljertPsIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterDetaljertUhIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertUhDto>>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter brukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterDto>;
            }
        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApi
        * @extends {BaseAPI}
        */
            export class BrukerApi extends BaseAPI implements BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto> {
            return await this.GET(
        "/brukerinfo",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoInnstillingerPut(params: { 
            brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        "/brukerinfo/innstillinger",
        {},
        { body: params.brukerinnstillingerDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterDetaljertPsIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>> {
            return await this.GET(
        this.path("/praksisaktiviteter/detaljert/ps/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterDetaljertUhIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertUhDto>> {
            return await this.GET(
        this.path("/praksisaktiviteter/detaljert/uh/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter brukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterDto> {
            return await this.GET(
        this.path("/praksisaktiviteter/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockBrukerApi(operations: {
            brukerinfoGet?: (params?: { 
                options?: any
                }) => Promise<BrukerinfoDto>
            brukerinfoInnstillingerPut?: (params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
                options?: any
                }) => Promise<void>
            praksisaktiviteterDetaljertPsIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>
            praksisaktiviteterDetaljertUhIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisaktivitetInfoDetaljertUhDto>>
            praksisaktiviteterIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktiviteterDto>
            }): BrukerApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            brukerinfoGet: (operations.brukerinfoGet || reject("brukerinfoGet")),
            brukerinfoInnstillingerPut: (operations.brukerinfoInnstillingerPut || reject("brukerinfoInnstillingerPut")),
            praksisaktiviteterDetaljertPsIdGet: (operations.praksisaktiviteterDetaljertPsIdGet || reject("praksisaktiviteterDetaljertPsIdGet")),
            praksisaktiviteterDetaljertUhIdGet: (operations.praksisaktiviteterDetaljertUhIdGet || reject("praksisaktiviteterDetaljertUhIdGet")),
            praksisaktiviteterIdGet: (operations.praksisaktiviteterIdGet || reject("praksisaktiviteterIdGet")),
            };
            }


        /**
        * DashbordApi - object-oriented interface
        * @export
        * @class DashbordApiInterface
        * @extends {BaseAPI}
        */
        export interface DashbordApiInterface {
            /**
            * 
                * @summary Hent feil fra FS som påvirker studiesteder etc. brukeren har tilgang på.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            dashbordFsfeilGet(params?: { 
            options?: any
            }): Promise<FSFeillisteDto>;
            /**
            * 
                * @summary Be om å slette en fsdbfeilmelding som ikke er knyttet til en praksisaktivitet.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            dashbordFsstatusFsdbfeilmeldingIdDelete(params: { 
                pathParams: { fsdbfeilmeldingId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent status på synkronisering av FS-tabeller ved egen institusjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            dashbordFsstatusGet(params?: { 
            options?: any
            }): Promise<FSSyncStatuserDto>;
            }
        /**
        * DashbordApi - object-oriented interface
        * @export
        * @class DashbordApi
        * @extends {BaseAPI}
        */
            export class DashbordApi extends BaseAPI implements DashbordApiInterface {
            /**
            * 
                * @summary Hent feil fra FS som påvirker studiesteder etc. brukeren har tilgang på.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            public async dashbordFsfeilGet(params?: { 
            options?: any
            }): Promise<FSFeillisteDto> {
            return await this.GET(
        "/dashbord/fsfeil",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Be om å slette en fsdbfeilmelding som ikke er knyttet til en praksisaktivitet.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            public async dashbordFsstatusFsdbfeilmeldingIdDelete(params: { 
                pathParams: { fsdbfeilmeldingId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/dashbord/fsstatus/{fsdbfeilmeldingId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent status på synkronisering av FS-tabeller ved egen institusjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof DashbordApi
            */
            public async dashbordFsstatusGet(params?: { 
            options?: any
            }): Promise<FSSyncStatuserDto> {
            return await this.GET(
        "/dashbord/fsstatus",
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockDashbordApi(operations: {
            dashbordFsfeilGet?: (params?: { 
                options?: any
                }) => Promise<FSFeillisteDto>
            dashbordFsstatusFsdbfeilmeldingIdDelete?: (params: { 
                    pathParams: { fsdbfeilmeldingId: string,  },
                options?: any
                }) => Promise<void>
            dashbordFsstatusGet?: (params?: { 
                options?: any
                }) => Promise<FSSyncStatuserDto>
            }): DashbordApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            dashbordFsfeilGet: (operations.dashbordFsfeilGet || reject("dashbordFsfeilGet")),
            dashbordFsstatusFsdbfeilmeldingIdDelete: (operations.dashbordFsstatusFsdbfeilmeldingIdDelete || reject("dashbordFsstatusFsdbfeilmeldingIdDelete")),
            dashbordFsstatusGet: (operations.dashbordFsstatusGet || reject("dashbordFsstatusGet")),
            };
            }


        /**
        * FordelingApi - object-oriented interface
        * @export
        * @class FordelingApiInterface
        * @extends {BaseAPI}
        */
        export interface FordelingApiInterface {
            /**
            * 
                * @summary Hent csv for alle studenter som er fordelt på aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof FordelingApi
            */
            praksisaktivitetIdFordelingDownloadGet(params: { 
                pathParams: { aktivitetId: string,  },
                queryParams?: { skipHeader?: boolean, includeIdentitetsnummer?: boolean,  },
            options?: any
            }): Promise<string>;
            }
        /**
        * FordelingApi - object-oriented interface
        * @export
        * @class FordelingApi
        * @extends {BaseAPI}
        */
            export class FordelingApi extends BaseAPI implements FordelingApiInterface {
            /**
            * 
                * @summary Hent csv for alle studenter som er fordelt på aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof FordelingApi
            */
            public async praksisaktivitetIdFordelingDownloadGet(params: { 
                pathParams: { aktivitetId: string,  },
                queryParams?: { skipHeader?: boolean, includeIdentitetsnummer?: boolean,  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/fordeling/download", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
        }
            export function mockFordelingApi(operations: {
            praksisaktivitetIdFordelingDownloadGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                    queryParams?: { skipHeader?: boolean, includeIdentitetsnummer?: boolean,  },
                options?: any
                }) => Promise<string>
            }): FordelingApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisaktivitetIdFordelingDownloadGet: (operations.praksisaktivitetIdFordelingDownloadGet || reject("praksisaktivitetIdFordelingDownloadGet")),
            };
            }


        /**
        * PraksisaktivitetVurderingApi - object-oriented interface
        * @export
        * @class PraksisaktivitetVurderingApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisaktivitetVurderingApiInterface {
            /**
            * 
                * @summary Henter vurderingsinnstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingInnstillingerGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<VurderingsinnstillingerDto>;
            /**
            * 
                * @summary Endre vurderingsinnstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingInnstillingerPut(params: { 
                pathParams: { aktivitetId: string,  },
                vurderingsinnstillingerDto: VurderingsinnstillingerDto,
            options?: any
            }): Promise<VurderingsinnstillingerDto>;
            /**
            * 
                * @summary Henter alle navn til læringsutbyttegrupper på praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<Array<LaeringsutbyttegruppeMinimalDto>>;
            /**
            * 
                * @summary Sletter læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter en læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
            options?: any
            }): Promise<LaeringsutbyttegruppeDto>;
            /**
            * 
                * @summary Endre en læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
                laeringsutbyttegruppeDto: LaeringsutbyttegruppeDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto>;
            /**
            * 
                * @summary Opprette ny læringsutbyttegruppe for praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost(params: { 
                pathParams: { aktivitetId: string,  },
                laeringsutbyttegruppeNyDto: LaeringsutbyttegruppeNyDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto>;
            /**
            * 
                * @summary Endre læringsutbyttegruppe for praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut(params: { 
                pathParams: { aktivitetId: string,  },
                laeringsutbyttegruppeMinimalDto: LaeringsutbyttegruppeMinimalDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto>;
            }
        /**
        * PraksisaktivitetVurderingApi - object-oriented interface
        * @export
        * @class PraksisaktivitetVurderingApi
        * @extends {BaseAPI}
        */
            export class PraksisaktivitetVurderingApi extends BaseAPI implements PraksisaktivitetVurderingApiInterface {
            /**
            * 
                * @summary Henter vurderingsinnstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingInnstillingerGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<VurderingsinnstillingerDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/innstillinger", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre vurderingsinnstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingInnstillingerPut(params: { 
                pathParams: { aktivitetId: string,  },
            vurderingsinnstillingerDto: VurderingsinnstillingerDto,
            options?: any
            }): Promise<VurderingsinnstillingerDto> {
            return await this.PUT(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/innstillinger", params.pathParams),
        {},
        { body: params.vurderingsinnstillingerDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle navn til læringsutbyttegrupper på praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<Array<LaeringsutbyttegruppeMinimalDto>> {
            return await this.GET(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe/{laeringsutbyttegruppeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter en læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
            options?: any
            }): Promise<LaeringsutbyttegruppeDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe/{laeringsutbyttegruppeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre en læringsutbyttegruppe
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut(params: { 
                pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
            laeringsutbyttegruppeDto: LaeringsutbyttegruppeDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto> {
            return await this.PUT(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe/{laeringsutbyttegruppeId}", params.pathParams),
        {},
        { body: params.laeringsutbyttegruppeDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Opprette ny læringsutbyttegruppe for praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost(params: { 
                pathParams: { aktivitetId: string,  },
            laeringsutbyttegruppeNyDto: LaeringsutbyttegruppeNyDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto> {
            return await this.POST(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe", params.pathParams),
        {},
        { body: params.laeringsutbyttegruppeNyDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre læringsutbyttegruppe for praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisaktivitetVurderingApi
            */
            public async praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut(params: { 
                pathParams: { aktivitetId: string,  },
            laeringsutbyttegruppeMinimalDto: LaeringsutbyttegruppeMinimalDto,
            options?: any
            }): Promise<LaeringsutbyttegruppeDto> {
            return await this.PUT(
        this.path("/praksisaktivitet/{aktivitetId}/vurdering/laeringsutbyttegruppe", params.pathParams),
        {},
        { body: params.laeringsutbyttegruppeMinimalDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockPraksisaktivitetVurderingApi(operations: {
            praksisaktivitetAktivitetIdVurderingInnstillingerGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<VurderingsinnstillingerDto>
            praksisaktivitetAktivitetIdVurderingInnstillingerPut?: (params: { 
                    pathParams: { aktivitetId: string,  },
                vurderingsinnstillingerDto: VurderingsinnstillingerDto,
                options?: any
                }) => Promise<VurderingsinnstillingerDto>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<Array<LaeringsutbyttegruppeMinimalDto>>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete?: (params: { 
                    pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet?: (params: { 
                    pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
                options?: any
                }) => Promise<LaeringsutbyttegruppeDto>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut?: (params: { 
                    pathParams: { aktivitetId: string, laeringsutbyttegruppeId: string,  },
                laeringsutbyttegruppeDto: LaeringsutbyttegruppeDto,
                options?: any
                }) => Promise<LaeringsutbyttegruppeDto>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost?: (params: { 
                    pathParams: { aktivitetId: string,  },
                laeringsutbyttegruppeNyDto: LaeringsutbyttegruppeNyDto,
                options?: any
                }) => Promise<LaeringsutbyttegruppeDto>
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut?: (params: { 
                    pathParams: { aktivitetId: string,  },
                laeringsutbyttegruppeMinimalDto: LaeringsutbyttegruppeMinimalDto,
                options?: any
                }) => Promise<LaeringsutbyttegruppeDto>
            }): PraksisaktivitetVurderingApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisaktivitetAktivitetIdVurderingInnstillingerGet: (operations.praksisaktivitetAktivitetIdVurderingInnstillingerGet || reject("praksisaktivitetAktivitetIdVurderingInnstillingerGet")),
            praksisaktivitetAktivitetIdVurderingInnstillingerPut: (operations.praksisaktivitetAktivitetIdVurderingInnstillingerPut || reject("praksisaktivitetAktivitetIdVurderingInnstillingerPut")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeGet")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdDelete")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdGet")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppeLaeringsutbyttegruppeIdPut")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePost")),
            praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut: (operations.praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut || reject("praksisaktivitetAktivitetIdVurderingLaeringsutbyttegruppePut")),
            };
            }


        /**
        * PraksiskalenderApi - object-oriented interface
        * @export
        * @class PraksiskalenderApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksiskalenderApiInterface {
            /**
            * 
                * @summary Lager et forslag på hvordan studenter som ikke allerede er fordelt kan fordeles på gjenværende plasser
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdAutomatiskfordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<StudentfordelingDto>>;
            /**
            * 
                * @summary Endre bestillinger for praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdBestillingerPut(params: { 
                pathParams: { id: string,  },
                praksisaktivitetBestillingPutDto: PraksisaktivitetBestillingPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Sletter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Slett gitt bestilling med feil og tilhørende besvarelser
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdErrorBestillingBidDelete(params: { 
                pathParams: { id: string, bid: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Slett besvarelsen med feil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdErrorBesvarelseBidDelete(params: { 
                pathParams: { id: string, bid: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter bestilling og besvarelse feil for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdErrorGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisstedMedValideringsfeilDto>>;
            /**
            * 
                * @summary Henter alle studenter som kan fordeles, med nåværende fordelingsregler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdFordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentfordelingMedValgDto>;
            /**
            * 
                * @summary Endre studentfordeling for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdFordelingPut(params: { 
                pathParams: { id: string,  },
                queryParams?: { publiserTilFs?: boolean, publiserTilPsa?: boolean,  },
                studentfordelingPutDto: Array<StudentfordelingPutDto>,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto>;
            /**
            * 
                * @summary Lag delvis kopi av praksisaktivitet med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdKopiPost(params: { 
                pathParams: { id: string,  },
                praksisaktivitetKopiPostDto: PraksisaktivitetKopiPostDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Endre innstillinger for onskeliste for praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdOnskelistePut(params: { 
                pathParams: { id: string,  },
                praksisaktivitetOnskelisteInfoDto: PraksisaktivitetOnskelisteInfoDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Sletter praksisstedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdPraksisstedrolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { praksisstedbrukerId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Legg til praksisstedrolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdPraksisstedrollePost(params: { 
                pathParams: { id: string,  },
                nyPraksisstedbrukerRolleDto: NyPraksisstedbrukerRolleDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Forespørsel om å publisere aktiviteten med studentfordelingene til FS. Dette er bare gjennomførbart om aktiviteten har registrerte feil og den har gitt opp å publisere aktiviten automatisk. Man bør ha behandlet eventuelle dataproblemer i FS, før man prøver synkronisering på nytt. 
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdPublishToFsPost(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Endre praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdPut(params: { 
                pathParams: { id: string,  },
                praksisaktivitetPutDto: PraksisaktivitetPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter alle studenter som kan registreres, med nåværende klassetilhørighet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRegistreringGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentregistreringDto>;
            /**
            * 
                * @summary Send inn studenter og hvilken klasse man registrerer dem på
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRegistreringPut(params: { 
                pathParams: { id: string,  },
                studentregistreringPutWrappedDto: StudentregistreringPutWrappedDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter alle roller for en aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRolleGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<RolleDto>>;
            /**
            * 
                * @summary Sletter studiestedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdStudiestedrolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { studiestedbrukerId: string, type: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Legg til studiested rolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdStudiestedrollePost(params: { 
                pathParams: { id: string,  },
                nyStudiestedbrukerRolleDto: NyStudiestedbrukerRolleDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Lag en ny aktivitet for klasse
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetPost(params: { 
                nyPraksisaktivitetDto: NyPraksisaktivitetDto,
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Hent csv-fil med alle praksisaktiviteter brukeren har tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksiskalenderDownloadGet(params: { 
                queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Alle klasser og aktiviteter som brukeren kan se
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksiskalenderGet(params: { 
                queryParams?: { fromDate: number, toDate?: number,  },
            options?: any
            }): Promise<PraksiskalenderDto>;
            /**
            * 
                * @summary Sletter klassen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisklasseIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Lag en ny klasse
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisklassePost(params: { 
                nyPraksisklasseDto: NyPraksisklasseDto,
            options?: any
            }): Promise<PraksisklasseDto>;
            /**
            * 
                * @summary Henter alle undervisningsenheter (ikke historiske) som matcher emnet, versjonen og institusjonen til en gitt undervisningsenhet. For hver av undervisningsenhetene returneres mulige praksisklasser og aktivitetene som finnes per klasse.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            undervisningsenheterKlasserPraksisaktiviteterGet(params: { 
                queryParams?: { undervisningsenhetId: string,  },
            options?: any
            }): Promise<Array<UndervisningsenhetToPraksisklasseMedAktiviteterDto>>;
            }
        /**
        * PraksiskalenderApi - object-oriented interface
        * @export
        * @class PraksiskalenderApi
        * @extends {BaseAPI}
        */
            export class PraksiskalenderApi extends BaseAPI implements PraksiskalenderApiInterface {
            /**
            * 
                * @summary Lager et forslag på hvordan studenter som ikke allerede er fordelt kan fordeles på gjenværende plasser
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdAutomatiskfordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<StudentfordelingDto>> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/automatiskfordeling", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre bestillinger for praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdBestillingerPut(params: { 
                pathParams: { id: string,  },
            praksisaktivitetBestillingPutDto: PraksisaktivitetBestillingPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/bestillinger", params.pathParams),
        {},
        { body: params.praksisaktivitetBestillingPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Slett gitt bestilling med feil og tilhørende besvarelser
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdErrorBestillingBidDelete(params: { 
                pathParams: { id: string, bid: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/error/bestilling/{bid}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Slett besvarelsen med feil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdErrorBesvarelseBidDelete(params: { 
                pathParams: { id: string, bid: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/error/besvarelse/{bid}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter bestilling og besvarelse feil for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdErrorGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisstedMedValideringsfeilDto>> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/error", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle studenter som kan fordeles, med nåværende fordelingsregler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdFordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentfordelingMedValgDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/fordeling", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre studentfordeling for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdFordelingPut(params: { 
                pathParams: { id: string,  },
                queryParams?: { publiserTilFs?: boolean, publiserTilPsa?: boolean,  },
            studentfordelingPutDto: Array<StudentfordelingPutDto>,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/fordeling", params.pathParams),
        params && params.queryParams,
        { body: params.studentfordelingPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lag delvis kopi av praksisaktivitet med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdKopiPost(params: { 
                pathParams: { id: string,  },
            praksisaktivitetKopiPostDto: PraksisaktivitetKopiPostDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/kopi", params.pathParams),
        {},
        { body: params.praksisaktivitetKopiPostDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre innstillinger for onskeliste for praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdOnskelistePut(params: { 
                pathParams: { id: string,  },
            praksisaktivitetOnskelisteInfoDto: PraksisaktivitetOnskelisteInfoDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/onskeliste", params.pathParams),
        {},
        { body: params.praksisaktivitetOnskelisteInfoDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter praksisstedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdPraksisstedrolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { praksisstedbrukerId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/praksisstedrolle", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legg til praksisstedrolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdPraksisstedrollePost(params: { 
                pathParams: { id: string,  },
            nyPraksisstedbrukerRolleDto: NyPraksisstedbrukerRolleDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/praksisstedrolle", params.pathParams),
        {},
        { body: params.nyPraksisstedbrukerRolleDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Forespørsel om å publisere aktiviteten med studentfordelingene til FS. Dette er bare gjennomførbart om aktiviteten har registrerte feil og den har gitt opp å publisere aktiviten automatisk. Man bør ha behandlet eventuelle dataproblemer i FS, før man prøver synkronisering på nytt. 
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdPublishToFsPost(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/publish-to-fs", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdPut(params: { 
                pathParams: { id: string,  },
            praksisaktivitetPutDto: PraksisaktivitetPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        { body: params.praksisaktivitetPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle studenter som kan registreres, med nåværende klassetilhørighet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRegistreringGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentregistreringDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/registrering", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Send inn studenter og hvilken klasse man registrerer dem på
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRegistreringPut(params: { 
                pathParams: { id: string,  },
            studentregistreringPutWrappedDto: StudentregistreringPutWrappedDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/registrering", params.pathParams),
        {},
        { body: params.studentregistreringPutWrappedDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle roller for en aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRolleGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<RolleDto>> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/rolle", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter studiestedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdStudiestedrolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { studiestedbrukerId: string, type: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/studiestedrolle", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legg til studiested rolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdStudiestedrollePost(params: { 
                pathParams: { id: string,  },
            nyStudiestedbrukerRolleDto: NyStudiestedbrukerRolleDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/studiestedrolle", params.pathParams),
        {},
        { body: params.nyStudiestedbrukerRolleDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lag en ny aktivitet for klasse
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetPost(params: { 
            nyPraksisaktivitetDto: NyPraksisaktivitetDto,
            options?: any
            }): Promise<string> {
            return await this.POST(
        "/praksisaktivitet",
        {},
        { body: params.nyPraksisaktivitetDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent csv-fil med alle praksisaktiviteter brukeren har tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksiskalenderDownloadGet(params: { 
                queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        "/praksiskalender/download",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle klasser og aktiviteter som brukeren kan se
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksiskalenderGet(params: { 
                queryParams?: { fromDate: number, toDate?: number,  },
            options?: any
            }): Promise<PraksiskalenderDto> {
            return await this.GET(
        "/praksiskalender",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter klassen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisklasseIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisklasse/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lag en ny klasse
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisklassePost(params: { 
            nyPraksisklasseDto: NyPraksisklasseDto,
            options?: any
            }): Promise<PraksisklasseDto> {
            return await this.POST(
        "/praksisklasse",
        {},
        { body: params.nyPraksisklasseDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle undervisningsenheter (ikke historiske) som matcher emnet, versjonen og institusjonen til en gitt undervisningsenhet. For hver av undervisningsenhetene returneres mulige praksisklasser og aktivitetene som finnes per klasse.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async undervisningsenheterKlasserPraksisaktiviteterGet(params: { 
                queryParams?: { undervisningsenhetId: string,  },
            options?: any
            }): Promise<Array<UndervisningsenhetToPraksisklasseMedAktiviteterDto>> {
            return await this.GET(
        "/undervisningsenheter/klasser/praksisaktiviteter",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksiskalenderApi(operations: {
            praksisaktivitetIdAutomatiskfordelingGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<StudentfordelingDto>>
            praksisaktivitetIdBestillingerPut?: (params: { 
                    pathParams: { id: string,  },
                praksisaktivitetBestillingPutDto: PraksisaktivitetBestillingPutDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdDelete?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdErrorBestillingBidDelete?: (params: { 
                    pathParams: { id: string, bid: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdErrorBesvarelseBidDelete?: (params: { 
                    pathParams: { id: string, bid: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdErrorGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisstedMedValideringsfeilDto>>
            praksisaktivitetIdFordelingGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudentfordelingMedValgDto>
            praksisaktivitetIdFordelingPut?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { publiserTilFs?: boolean, publiserTilPsa?: boolean,  },
                studentfordelingPutDto: Array<StudentfordelingPutDto>,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktivitetDto>
            praksisaktivitetIdKopiPost?: (params: { 
                    pathParams: { id: string,  },
                praksisaktivitetKopiPostDto: PraksisaktivitetKopiPostDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdOnskelistePut?: (params: { 
                    pathParams: { id: string,  },
                praksisaktivitetOnskelisteInfoDto: PraksisaktivitetOnskelisteInfoDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdPraksisstedrolleDelete?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { praksisstedbrukerId: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdPraksisstedrollePost?: (params: { 
                    pathParams: { id: string,  },
                nyPraksisstedbrukerRolleDto: NyPraksisstedbrukerRolleDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdPublishToFsPost?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisaktivitetPutDto: PraksisaktivitetPutDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdRegistreringGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudentregistreringDto>
            praksisaktivitetIdRegistreringPut?: (params: { 
                    pathParams: { id: string,  },
                studentregistreringPutWrappedDto: StudentregistreringPutWrappedDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdRolleGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<RolleDto>>
            praksisaktivitetIdStudiestedrolleDelete?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { studiestedbrukerId: string, type: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdStudiestedrollePost?: (params: { 
                    pathParams: { id: string,  },
                nyStudiestedbrukerRolleDto: NyStudiestedbrukerRolleDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetPost?: (params: { 
                nyPraksisaktivitetDto: NyPraksisaktivitetDto,
                options?: any
                }) => Promise<string>
            praksiskalenderDownloadGet?: (params: { 
                    queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
                options?: any
                }) => Promise<string>
            praksiskalenderGet?: (params: { 
                    queryParams?: { fromDate: number, toDate?: number,  },
                options?: any
                }) => Promise<PraksiskalenderDto>
            praksisklasseIdDelete?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            praksisklassePost?: (params: { 
                nyPraksisklasseDto: NyPraksisklasseDto,
                options?: any
                }) => Promise<PraksisklasseDto>
            undervisningsenheterKlasserPraksisaktiviteterGet?: (params: { 
                    queryParams?: { undervisningsenhetId: string,  },
                options?: any
                }) => Promise<Array<UndervisningsenhetToPraksisklasseMedAktiviteterDto>>
            }): PraksiskalenderApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisaktivitetIdAutomatiskfordelingGet: (operations.praksisaktivitetIdAutomatiskfordelingGet || reject("praksisaktivitetIdAutomatiskfordelingGet")),
            praksisaktivitetIdBestillingerPut: (operations.praksisaktivitetIdBestillingerPut || reject("praksisaktivitetIdBestillingerPut")),
            praksisaktivitetIdDelete: (operations.praksisaktivitetIdDelete || reject("praksisaktivitetIdDelete")),
            praksisaktivitetIdErrorBestillingBidDelete: (operations.praksisaktivitetIdErrorBestillingBidDelete || reject("praksisaktivitetIdErrorBestillingBidDelete")),
            praksisaktivitetIdErrorBesvarelseBidDelete: (operations.praksisaktivitetIdErrorBesvarelseBidDelete || reject("praksisaktivitetIdErrorBesvarelseBidDelete")),
            praksisaktivitetIdErrorGet: (operations.praksisaktivitetIdErrorGet || reject("praksisaktivitetIdErrorGet")),
            praksisaktivitetIdFordelingGet: (operations.praksisaktivitetIdFordelingGet || reject("praksisaktivitetIdFordelingGet")),
            praksisaktivitetIdFordelingPut: (operations.praksisaktivitetIdFordelingPut || reject("praksisaktivitetIdFordelingPut")),
            praksisaktivitetIdGet: (operations.praksisaktivitetIdGet || reject("praksisaktivitetIdGet")),
            praksisaktivitetIdKopiPost: (operations.praksisaktivitetIdKopiPost || reject("praksisaktivitetIdKopiPost")),
            praksisaktivitetIdOnskelistePut: (operations.praksisaktivitetIdOnskelistePut || reject("praksisaktivitetIdOnskelistePut")),
            praksisaktivitetIdPraksisstedrolleDelete: (operations.praksisaktivitetIdPraksisstedrolleDelete || reject("praksisaktivitetIdPraksisstedrolleDelete")),
            praksisaktivitetIdPraksisstedrollePost: (operations.praksisaktivitetIdPraksisstedrollePost || reject("praksisaktivitetIdPraksisstedrollePost")),
            praksisaktivitetIdPublishToFsPost: (operations.praksisaktivitetIdPublishToFsPost || reject("praksisaktivitetIdPublishToFsPost")),
            praksisaktivitetIdPut: (operations.praksisaktivitetIdPut || reject("praksisaktivitetIdPut")),
            praksisaktivitetIdRegistreringGet: (operations.praksisaktivitetIdRegistreringGet || reject("praksisaktivitetIdRegistreringGet")),
            praksisaktivitetIdRegistreringPut: (operations.praksisaktivitetIdRegistreringPut || reject("praksisaktivitetIdRegistreringPut")),
            praksisaktivitetIdRolleGet: (operations.praksisaktivitetIdRolleGet || reject("praksisaktivitetIdRolleGet")),
            praksisaktivitetIdStudiestedrolleDelete: (operations.praksisaktivitetIdStudiestedrolleDelete || reject("praksisaktivitetIdStudiestedrolleDelete")),
            praksisaktivitetIdStudiestedrollePost: (operations.praksisaktivitetIdStudiestedrollePost || reject("praksisaktivitetIdStudiestedrollePost")),
            praksisaktivitetPost: (operations.praksisaktivitetPost || reject("praksisaktivitetPost")),
            praksiskalenderDownloadGet: (operations.praksiskalenderDownloadGet || reject("praksiskalenderDownloadGet")),
            praksiskalenderGet: (operations.praksiskalenderGet || reject("praksiskalenderGet")),
            praksisklasseIdDelete: (operations.praksisklasseIdDelete || reject("praksisklasseIdDelete")),
            praksisklassePost: (operations.praksisklassePost || reject("praksisklassePost")),
            undervisningsenheterKlasserPraksisaktiviteterGet: (operations.undervisningsenheterKlasserPraksisaktiviteterGet || reject("undervisningsenheterKlasserPraksisaktiviteterGet")),
            };
            }


        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisstedApiInterface {
            /**
            * 
                * @summary Hent avtaleinformasjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerGet(params?: { 
            options?: any
            }): Promise<AvtalerDto>;
            /**
            * 
                * @summary Hent praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisGet(params?: { 
            options?: any
            }): Promise<HalPraksisstedavtalerDto>;
            /**
            * 
                * @summary Vis informasjon om praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            options?: any
            }): Promise<HalPraksisstedavtaleDto>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter knyttet til avtale med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisIdPraksisaktiviteterGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterInfoDto>;
            /**
            * 
                * @summary Oppdatere en ny praksisavtale for tilhørende praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisIdPut(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
                praksisstedavtalePostDto: PraksisstedavtalePostDto,
            options?: any
            }): Promise<HalPraksisstedavtaleDto>;
            /**
            * 
                * @summary Opprette en ny praksisavtale for tilhørende praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisPost(params: { 
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
                praksisstedavtalePostDto: PraksisstedavtalePostDto,
            options?: any
            }): Promise<HalPraksisstedavtaleDto>;
            /**
            * 
                * @summary Run a duplicate check to see if it find matching praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisSokOverlappendeavtalerPost(params: { 
                overlappendePraksisstedavtalesokRequestDto: OverlappendePraksisstedavtalesokRequestDto,
            options?: any
            }): Promise<OverlappendePraksisstedavtalesokResponseDto>;
            /**
            * 
                * @summary Finn praksissted i enhetsregisteret
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            enhetsregPraksisstedOrgnrGet(params: { 
                pathParams: { orgnr: number,  },
            options?: any
            }): Promise<EnhetsregEnhetDto>;
            /**
            * 
                * @summary Hent eksisterende praksissteder på org. nummer
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            fsPraksisstedGet(params: { 
                queryParams?: { orgnr: number,  },
            options?: any
            }): Promise<AlpPraksisstedGetDto>;
            /**
            * 
                * @summary Opprett praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            fsPraksisstedPost(params: { 
                alpPraksisstedPostDto: AlpPraksisstedPostDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent praksissted typer tilgjengelig
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            fsPraksisstedtypeGet(params?: { 
            options?: any
            }): Promise<AlpPraksisstedtyperGetDto>;
            /**
            * 
                * @summary Hent mulige praksissteder man kan invitere til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            inviterPraksisstedbrukerGet(params: { 
                queryParams?: { id: string,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>>;
            /**
            * 
                * @summary Inviter ny PSA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            inviterPraksisstedbrukerPost(params: { 
                nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent eksisterende praksissteder med navn, adresse og postnr på praksisstednavn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            matchingPraksisstederGet(params: { 
                queryParams?: { navn: string,  },
            options?: any
            }): Promise<Array<MatchingPraksisstedDto>>;
            /**
            * 
                * @summary Henter alle praksissteder som har kapasitet og avtaler tilknyttet gitt aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet(params: { 
                pathParams: { aktivitetsId: string,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>>;
            /**
            * 
                * @summary Hent en praksisstedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedbrukerprofilDto>;
            /**
            * 
                * @summary Lagre profil for praksisstedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
                praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary hent alle praksissteder med avtaler og info om admin brukere
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederGet(params: { 
                queryParams?: { praksisstedId?: string,  },
            options?: any
            }): Promise<Array<PraksisstedDto>>;
            /**
            * 
                * @summary Hent praksissteder, basert på praksisstednodenenes orgnr eller navn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederMedHierarkiGet(params: { 
                queryParams?: { orgnr?: number, navn?: string,  },
            options?: any
            }): Promise<Array<MinimalPraksisstedMedHierarkiDto>>;
            /**
            * 
                * @summary Hent et praksissteder, basert på praksissted-nodenene sine orgnr
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederOrgnrGet(params: { 
                pathParams: { orgnr: number,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>>;
            /**
            * 
                * @summary Henter alle praksisstedbrukere tilknyttet praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederPraksisstedIdBrukereGet(params: { 
                pathParams: { praksisstedId: string,  },
            options?: any
            }): Promise<Array<PraksisstedbrukerDto>>;
            /**
            * 
                * @summary Slett bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildeBildeIdDelete(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildeBildeIdGet(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Legg inn bilde til praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildePost(params: { 
                pathParams: { id: string,  },
                body: string,
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto>;
            /**
            * 
                * @summary Oppdater informasjon om praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdInfoPut(params: { 
                pathParams: { id: string,  },
                praksisstedInfoPutDto: PraksisstedInfoPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent praksisstedprofil sin kontaktinfo, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdKontaktinfoPublicGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto>;
            /**
            * 
                * @summary Lagre praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdPut(params: { 
                pathParams: { id: string,  },
                praksisstedprofilPutDto: PraksisstedprofilPutDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApi
        * @extends {BaseAPI}
        */
            export class PraksisstedApi extends BaseAPI implements PraksisstedApiInterface {
            /**
            * 
                * @summary Hent avtaleinformasjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerGet(params?: { 
            options?: any
            }): Promise<AvtalerDto> {
            return await this.GET(
        "/avtaler/",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisGet(params?: { 
            options?: any
            }): Promise<HalPraksisstedavtalerDto> {
            return await this.GET(
        "/avtaler/praksis",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Vis informasjon om praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            options?: any
            }): Promise<HalPraksisstedavtaleDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{id}", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter knyttet til avtale med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisIdPraksisaktiviteterGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterInfoDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{id}/praksisaktiviteter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Oppdatere en ny praksisavtale for tilhørende praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisIdPut(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            praksisstedavtalePostDto: PraksisstedavtalePostDto,
            options?: any
            }): Promise<HalPraksisstedavtaleDto> {
            return await this.PUT(
        this.path("/avtaler/praksis/{id}", params.pathParams),
        params && params.queryParams,
        { body: params.praksisstedavtalePostDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Opprette en ny praksisavtale for tilhørende praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisPost(params: { 
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            praksisstedavtalePostDto: PraksisstedavtalePostDto,
            options?: any
            }): Promise<HalPraksisstedavtaleDto> {
            return await this.POST(
        "/avtaler/praksis",
        params && params.queryParams,
        { body: params.praksisstedavtalePostDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Run a duplicate check to see if it find matching praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisSokOverlappendeavtalerPost(params: { 
            overlappendePraksisstedavtalesokRequestDto: OverlappendePraksisstedavtalesokRequestDto,
            options?: any
            }): Promise<OverlappendePraksisstedavtalesokResponseDto> {
            return await this.POST(
        "/avtaler/praksis/sok/overlappendeavtaler",
        {},
        { body: params.overlappendePraksisstedavtalesokRequestDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Finn praksissted i enhetsregisteret
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async enhetsregPraksisstedOrgnrGet(params: { 
                pathParams: { orgnr: number,  },
            options?: any
            }): Promise<EnhetsregEnhetDto> {
            return await this.GET(
        this.path("/enhetsreg/praksissted/{orgnr}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent eksisterende praksissteder på org. nummer
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async fsPraksisstedGet(params: { 
                queryParams?: { orgnr: number,  },
            options?: any
            }): Promise<AlpPraksisstedGetDto> {
            return await this.GET(
        "/fs/praksissted",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Opprett praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async fsPraksisstedPost(params: { 
            alpPraksisstedPostDto: AlpPraksisstedPostDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/fs/praksissted",
        {},
        { body: params.alpPraksisstedPostDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent praksissted typer tilgjengelig
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async fsPraksisstedtypeGet(params?: { 
            options?: any
            }): Promise<AlpPraksisstedtyperGetDto> {
            return await this.GET(
        "/fs/praksisstedtype",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent mulige praksissteder man kan invitere til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async inviterPraksisstedbrukerGet(params: { 
                queryParams?: { id: string,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>> {
            return await this.GET(
        "/inviterPraksisstedbruker",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Inviter ny PSA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async inviterPraksisstedbrukerPost(params: { 
            nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/inviterPraksisstedbruker",
        {},
        { body: params.nyPraksisstedbrukerInvitasjonDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent eksisterende praksissteder med navn, adresse og postnr på praksisstednavn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async matchingPraksisstederGet(params: { 
                queryParams?: { navn: string,  },
            options?: any
            }): Promise<Array<MatchingPraksisstedDto>> {
            return await this.GET(
        "/matchingPraksissteder",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksissteder som har kapasitet og avtaler tilknyttet gitt aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet(params: { 
                pathParams: { aktivitetsId: string,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>> {
            return await this.GET(
        this.path("/praksisaktiviteter/{aktivitetsId}/avtaler/praksissteder", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en praksisstedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedbrukerprofilDto> {
            return await this.GET(
        this.path("/praksisstedbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagre profil for praksisstedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
            praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedbrukerprofil/{id}", params.pathParams),
        {},
        { body: params.praksisstedbrukerprofilPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary hent alle praksissteder med avtaler og info om admin brukere
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederGet(params: { 
                queryParams?: { praksisstedId?: string,  },
            options?: any
            }): Promise<Array<PraksisstedDto>> {
            return await this.GET(
        "/praksissteder",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent praksissteder, basert på praksisstednodenenes orgnr eller navn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederMedHierarkiGet(params: { 
                queryParams?: { orgnr?: number, navn?: string,  },
            options?: any
            }): Promise<Array<MinimalPraksisstedMedHierarkiDto>> {
            return await this.GET(
        "/praksisstederMedHierarki",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent et praksissteder, basert på praksissted-nodenene sine orgnr
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederOrgnrGet(params: { 
                pathParams: { orgnr: number,  },
            options?: any
            }): Promise<Array<MuligePraksisstedDto>> {
            return await this.GET(
        this.path("/praksissteder/{orgnr}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisstedbrukere tilknyttet praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederPraksisstedIdBrukereGet(params: { 
                pathParams: { praksisstedId: string,  },
            options?: any
            }): Promise<Array<PraksisstedbrukerDto>> {
            return await this.GET(
        this.path("/praksissteder/{praksisstedId}/brukere", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Slett bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildeBildeIdDelete(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisstedprofil/{id}/bilde/{bildeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildeBildeIdGet(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}/bilde/{bildeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legg inn bilde til praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildePost(params: { 
                pathParams: { id: string,  },
            body: string,
            options?: any
            }): Promise<string> {
            return await this.POST(
        this.path("/praksisstedprofil/{id}/bilde", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Oppdater informasjon om praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdInfoPut(params: { 
                pathParams: { id: string,  },
            praksisstedInfoPutDto: PraksisstedInfoPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedprofil/{id}/info", params.pathParams),
        {},
        { body: params.praksisstedInfoPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent praksisstedprofil sin kontaktinfo, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdKontaktinfoPublicGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}/kontaktinfo/public", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagre praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdPut(params: { 
                pathParams: { id: string,  },
            praksisstedprofilPutDto: PraksisstedprofilPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedprofil/{id}", params.pathParams),
        {},
        { body: params.praksisstedprofilPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockPraksisstedApi(operations: {
            avtalerGet?: (params?: { 
                options?: any
                }) => Promise<AvtalerDto>
            avtalerPraksisGet?: (params?: { 
                options?: any
                }) => Promise<HalPraksisstedavtalerDto>
            avtalerPraksisIdGet?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { view?: PraksisstedavtaleViewDto,  },
                options?: any
                }) => Promise<HalPraksisstedavtaleDto>
            avtalerPraksisIdPraksisaktiviteterGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktiviteterInfoDto>
            avtalerPraksisIdPut?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { view?: PraksisstedavtaleViewDto,  },
                praksisstedavtalePostDto: PraksisstedavtalePostDto,
                options?: any
                }) => Promise<HalPraksisstedavtaleDto>
            avtalerPraksisPost?: (params: { 
                    queryParams?: { view?: PraksisstedavtaleViewDto,  },
                praksisstedavtalePostDto: PraksisstedavtalePostDto,
                options?: any
                }) => Promise<HalPraksisstedavtaleDto>
            avtalerPraksisSokOverlappendeavtalerPost?: (params: { 
                overlappendePraksisstedavtalesokRequestDto: OverlappendePraksisstedavtalesokRequestDto,
                options?: any
                }) => Promise<OverlappendePraksisstedavtalesokResponseDto>
            enhetsregPraksisstedOrgnrGet?: (params: { 
                    pathParams: { orgnr: number,  },
                options?: any
                }) => Promise<EnhetsregEnhetDto>
            fsPraksisstedGet?: (params: { 
                    queryParams?: { orgnr: number,  },
                options?: any
                }) => Promise<AlpPraksisstedGetDto>
            fsPraksisstedPost?: (params: { 
                alpPraksisstedPostDto: AlpPraksisstedPostDto,
                options?: any
                }) => Promise<void>
            fsPraksisstedtypeGet?: (params?: { 
                options?: any
                }) => Promise<AlpPraksisstedtyperGetDto>
            inviterPraksisstedbrukerGet?: (params: { 
                    queryParams?: { id: string,  },
                options?: any
                }) => Promise<Array<MuligePraksisstedDto>>
            inviterPraksisstedbrukerPost?: (params: { 
                nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
                options?: any
                }) => Promise<void>
            matchingPraksisstederGet?: (params: { 
                    queryParams?: { navn: string,  },
                options?: any
                }) => Promise<Array<MatchingPraksisstedDto>>
            praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet?: (params: { 
                    pathParams: { aktivitetsId: string,  },
                options?: any
                }) => Promise<Array<MuligePraksisstedDto>>
            praksisstedbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedbrukerprofilDto>
            praksisstedbrukerprofilIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
                options?: any
                }) => Promise<void>
            praksisstederGet?: (params: { 
                    queryParams?: { praksisstedId?: string,  },
                options?: any
                }) => Promise<Array<PraksisstedDto>>
            praksisstederMedHierarkiGet?: (params: { 
                    queryParams?: { orgnr?: number, navn?: string,  },
                options?: any
                }) => Promise<Array<MinimalPraksisstedMedHierarkiDto>>
            praksisstederOrgnrGet?: (params: { 
                    pathParams: { orgnr: number,  },
                options?: any
                }) => Promise<Array<MuligePraksisstedDto>>
            praksisstederPraksisstedIdBrukereGet?: (params: { 
                    pathParams: { praksisstedId: string,  },
                options?: any
                }) => Promise<Array<PraksisstedbrukerDto>>
            praksisstedprofilIdBildeBildeIdDelete?: (params: { 
                    pathParams: { id: string, bildeId: string,  },
                options?: any
                }) => Promise<void>
            praksisstedprofilIdBildeBildeIdGet?: (params: { 
                    pathParams: { id: string, bildeId: string,  },
                options?: any
                }) => Promise<string>
            praksisstedprofilIdBildePost?: (params: { 
                    pathParams: { id: string,  },
                body: string,
                options?: any
                }) => Promise<string>
            praksisstedprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedprofilDto>
            praksisstedprofilIdInfoPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedInfoPutDto: PraksisstedInfoPutDto,
                options?: any
                }) => Promise<void>
            praksisstedprofilIdKontaktinfoPublicGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedprofilDto>
            praksisstedprofilIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedprofilPutDto: PraksisstedprofilPutDto,
                options?: any
                }) => Promise<void>
            }): PraksisstedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            avtalerGet: (operations.avtalerGet || reject("avtalerGet")),
            avtalerPraksisGet: (operations.avtalerPraksisGet || reject("avtalerPraksisGet")),
            avtalerPraksisIdGet: (operations.avtalerPraksisIdGet || reject("avtalerPraksisIdGet")),
            avtalerPraksisIdPraksisaktiviteterGet: (operations.avtalerPraksisIdPraksisaktiviteterGet || reject("avtalerPraksisIdPraksisaktiviteterGet")),
            avtalerPraksisIdPut: (operations.avtalerPraksisIdPut || reject("avtalerPraksisIdPut")),
            avtalerPraksisPost: (operations.avtalerPraksisPost || reject("avtalerPraksisPost")),
            avtalerPraksisSokOverlappendeavtalerPost: (operations.avtalerPraksisSokOverlappendeavtalerPost || reject("avtalerPraksisSokOverlappendeavtalerPost")),
            enhetsregPraksisstedOrgnrGet: (operations.enhetsregPraksisstedOrgnrGet || reject("enhetsregPraksisstedOrgnrGet")),
            fsPraksisstedGet: (operations.fsPraksisstedGet || reject("fsPraksisstedGet")),
            fsPraksisstedPost: (operations.fsPraksisstedPost || reject("fsPraksisstedPost")),
            fsPraksisstedtypeGet: (operations.fsPraksisstedtypeGet || reject("fsPraksisstedtypeGet")),
            inviterPraksisstedbrukerGet: (operations.inviterPraksisstedbrukerGet || reject("inviterPraksisstedbrukerGet")),
            inviterPraksisstedbrukerPost: (operations.inviterPraksisstedbrukerPost || reject("inviterPraksisstedbrukerPost")),
            matchingPraksisstederGet: (operations.matchingPraksisstederGet || reject("matchingPraksisstederGet")),
            praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet: (operations.praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet || reject("praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet")),
            praksisstedbrukerprofilIdGet: (operations.praksisstedbrukerprofilIdGet || reject("praksisstedbrukerprofilIdGet")),
            praksisstedbrukerprofilIdPut: (operations.praksisstedbrukerprofilIdPut || reject("praksisstedbrukerprofilIdPut")),
            praksisstederGet: (operations.praksisstederGet || reject("praksisstederGet")),
            praksisstederMedHierarkiGet: (operations.praksisstederMedHierarkiGet || reject("praksisstederMedHierarkiGet")),
            praksisstederOrgnrGet: (operations.praksisstederOrgnrGet || reject("praksisstederOrgnrGet")),
            praksisstederPraksisstedIdBrukereGet: (operations.praksisstederPraksisstedIdBrukereGet || reject("praksisstederPraksisstedIdBrukereGet")),
            praksisstedprofilIdBildeBildeIdDelete: (operations.praksisstedprofilIdBildeBildeIdDelete || reject("praksisstedprofilIdBildeBildeIdDelete")),
            praksisstedprofilIdBildeBildeIdGet: (operations.praksisstedprofilIdBildeBildeIdGet || reject("praksisstedprofilIdBildeBildeIdGet")),
            praksisstedprofilIdBildePost: (operations.praksisstedprofilIdBildePost || reject("praksisstedprofilIdBildePost")),
            praksisstedprofilIdGet: (operations.praksisstedprofilIdGet || reject("praksisstedprofilIdGet")),
            praksisstedprofilIdInfoPut: (operations.praksisstedprofilIdInfoPut || reject("praksisstedprofilIdInfoPut")),
            praksisstedprofilIdKontaktinfoPublicGet: (operations.praksisstedprofilIdKontaktinfoPublicGet || reject("praksisstedprofilIdKontaktinfoPublicGet")),
            praksisstedprofilIdPut: (operations.praksisstedprofilIdPut || reject("praksisstedprofilIdPut")),
            };
            }


        /**
        * PraksistypeApi - object-oriented interface
        * @export
        * @class PraksistypeApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksistypeApiInterface {
            /**
            * 
                * @summary Sletter aktivitetskrav med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            aktivitetskravIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Endre aktivitetskravet sitt navn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            aktivitetskravIdNavnPut(params: { 
                pathParams: { id: string,  },
                body: string,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Alle praksissteder som kan oppfylle kravet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            aktivitetskravIdStederGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisstederForAktivitetskravDto>>;
            /**
            * 
                * @summary Endre hvilke praksissteder som oppfyller et krav
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            aktivitetskravIdStederPut(params: { 
                pathParams: { id: string,  },
                requestBody: Array<string>,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Praksistype med aktivitetskravene under denne
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            praksistypeKodeGet(params: { 
                pathParams: { kode: string,  },
            options?: any
            }): Promise<PraksistypeMedAktivitetskravDto>;
            /**
            * 
                * @summary Lag et nytt aktivitetskrav som man legger under denne praksistypen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            praksistypeKodePost(params: { 
                pathParams: { kode: string,  },
                body: string,
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Alle praksistyper min institusjon har en avtale som omfatter, med eventuelle aktivitetskrav
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            praksistyperGet(params?: { 
            options?: any
            }): Promise<Array<PraksistypeMedAktivitetskravDto>>;
            /**
            * 
                * @summary Alle praksistyper min institusjon har en avtale med som jeg har SKRIV-tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            praksistyperMedEmnerGet(params?: { 
            options?: any
            }): Promise<Array<PraksistypeMedEmnerDto>>;
            }
        /**
        * PraksistypeApi - object-oriented interface
        * @export
        * @class PraksistypeApi
        * @extends {BaseAPI}
        */
            export class PraksistypeApi extends BaseAPI implements PraksistypeApiInterface {
            /**
            * 
                * @summary Sletter aktivitetskrav med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async aktivitetskravIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/aktivitetskrav/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre aktivitetskravet sitt navn
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async aktivitetskravIdNavnPut(params: { 
                pathParams: { id: string,  },
            body: string,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/aktivitetskrav/{id}/navn", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle praksissteder som kan oppfylle kravet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async aktivitetskravIdStederGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisstederForAktivitetskravDto>> {
            return await this.GET(
        this.path("/aktivitetskrav/{id}/steder", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre hvilke praksissteder som oppfyller et krav
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async aktivitetskravIdStederPut(params: { 
                pathParams: { id: string,  },
            requestBody: Array<string>,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/aktivitetskrav/{id}/steder", params.pathParams),
        {},
        { body: params.requestBody, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Praksistype med aktivitetskravene under denne
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async praksistypeKodeGet(params: { 
                pathParams: { kode: string,  },
            options?: any
            }): Promise<PraksistypeMedAktivitetskravDto> {
            return await this.GET(
        this.path("/praksistype/{kode}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lag et nytt aktivitetskrav som man legger under denne praksistypen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async praksistypeKodePost(params: { 
                pathParams: { kode: string,  },
            body: string,
            options?: any
            }): Promise<string> {
            return await this.POST(
        this.path("/praksistype/{kode}", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle praksistyper min institusjon har en avtale som omfatter, med eventuelle aktivitetskrav
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async praksistyperGet(params?: { 
            options?: any
            }): Promise<Array<PraksistypeMedAktivitetskravDto>> {
            return await this.GET(
        "/praksistyper",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle praksistyper min institusjon har en avtale med som jeg har SKRIV-tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksistypeApi
            */
            public async praksistyperMedEmnerGet(params?: { 
            options?: any
            }): Promise<Array<PraksistypeMedEmnerDto>> {
            return await this.GET(
        "/praksistyperMedEmner",
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksistypeApi(operations: {
            aktivitetskravIdDelete?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            aktivitetskravIdNavnPut?: (params: { 
                    pathParams: { id: string,  },
                body: string,
                options?: any
                }) => Promise<void>
            aktivitetskravIdStederGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisstederForAktivitetskravDto>>
            aktivitetskravIdStederPut?: (params: { 
                    pathParams: { id: string,  },
                requestBody: Array<string>,
                options?: any
                }) => Promise<void>
            praksistypeKodeGet?: (params: { 
                    pathParams: { kode: string,  },
                options?: any
                }) => Promise<PraksistypeMedAktivitetskravDto>
            praksistypeKodePost?: (params: { 
                    pathParams: { kode: string,  },
                body: string,
                options?: any
                }) => Promise<string>
            praksistyperGet?: (params?: { 
                options?: any
                }) => Promise<Array<PraksistypeMedAktivitetskravDto>>
            praksistyperMedEmnerGet?: (params?: { 
                options?: any
                }) => Promise<Array<PraksistypeMedEmnerDto>>
            }): PraksistypeApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            aktivitetskravIdDelete: (operations.aktivitetskravIdDelete || reject("aktivitetskravIdDelete")),
            aktivitetskravIdNavnPut: (operations.aktivitetskravIdNavnPut || reject("aktivitetskravIdNavnPut")),
            aktivitetskravIdStederGet: (operations.aktivitetskravIdStederGet || reject("aktivitetskravIdStederGet")),
            aktivitetskravIdStederPut: (operations.aktivitetskravIdStederPut || reject("aktivitetskravIdStederPut")),
            praksistypeKodeGet: (operations.praksistypeKodeGet || reject("praksistypeKodeGet")),
            praksistypeKodePost: (operations.praksistypeKodePost || reject("praksistypeKodePost")),
            praksistyperGet: (operations.praksistyperGet || reject("praksistyperGet")),
            praksistyperMedEmnerGet: (operations.praksistyperMedEmnerGet || reject("praksistyperMedEmnerGet")),
            };
            }


        /**
        * StudiestedApi - object-oriented interface
        * @export
        * @class StudiestedApiInterface
        * @extends {BaseAPI}
        */
        export interface StudiestedApiInterface {
            /**
            * 
                * @summary Hent brukere som kan inviteres
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            inviterStudiestedbrukerGet(params?: { 
            options?: any
            }): Promise<InviterStudiestedbrukerDto>;
            /**
            * 
                * @summary Inviter ny UHA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            inviterStudiestedbrukerPost(params: { 
                nyStudiestedbrukerInvitasjonDto: NyStudiestedbrukerInvitasjonDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent mulige studiesteder man kan invitere til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            muligeStudiestederGet(params?: { 
            options?: any
            }): Promise<Array<MuligeStudiestedDto>>;
            /**
            * 
                * @summary Hent en student med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studentbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentbrukerprofilDto>;
            /**
            * 
                * @summary henter info om et studiesteds plassering i hierarkiet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedMedHierarkiIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<MinimalStudiestedDto>;
            /**
            * 
                * @summary Sletter studiebruker på ditt studiested
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedbrukerIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Alle studiestedbrukere på ditt (eller gitt av id) studiested, deres høyeste tilgangsrolle og deres høyeste tilgangsnivå
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedbrukereGet(params: { 
                queryParams?: { studiestedId?: string,  },
            options?: any
            }): Promise<Array<StudiestedbrukerDto>>;
            /**
            * 
                * @summary Hent en studiestedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudiestedbrukerprofilDto>;
            /**
            * 
                * @summary Lagre profil for studiestedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
                studiestedbrukerprofilPutDto: StudiestedbrukerprofilPutDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * StudiestedApi - object-oriented interface
        * @export
        * @class StudiestedApi
        * @extends {BaseAPI}
        */
            export class StudiestedApi extends BaseAPI implements StudiestedApiInterface {
            /**
            * 
                * @summary Hent brukere som kan inviteres
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async inviterStudiestedbrukerGet(params?: { 
            options?: any
            }): Promise<InviterStudiestedbrukerDto> {
            return await this.GET(
        "/inviterStudiestedbruker",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Inviter ny UHA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async inviterStudiestedbrukerPost(params: { 
            nyStudiestedbrukerInvitasjonDto: NyStudiestedbrukerInvitasjonDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/inviterStudiestedbruker",
        {},
        { body: params.nyStudiestedbrukerInvitasjonDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent mulige studiesteder man kan invitere til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async muligeStudiestederGet(params?: { 
            options?: any
            }): Promise<Array<MuligeStudiestedDto>> {
            return await this.GET(
        "/muligeStudiesteder",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en student med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studentbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentbrukerprofilDto> {
            return await this.GET(
        this.path("/studentbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary henter info om et studiesteds plassering i hierarkiet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedMedHierarkiIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<MinimalStudiestedDto> {
            return await this.GET(
        this.path("/studiestedMedHierarki/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter studiebruker på ditt studiested
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedbrukerIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/studiestedbruker/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle studiestedbrukere på ditt (eller gitt av id) studiested, deres høyeste tilgangsrolle og deres høyeste tilgangsnivå
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedbrukereGet(params: { 
                queryParams?: { studiestedId?: string,  },
            options?: any
            }): Promise<Array<StudiestedbrukerDto>> {
            return await this.GET(
        "/studiestedbrukere",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en studiestedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudiestedbrukerprofilDto> {
            return await this.GET(
        this.path("/studiestedbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagre profil for studiestedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
            studiestedbrukerprofilPutDto: StudiestedbrukerprofilPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/studiestedbrukerprofil/{id}", params.pathParams),
        {},
        { body: params.studiestedbrukerprofilPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockStudiestedApi(operations: {
            inviterStudiestedbrukerGet?: (params?: { 
                options?: any
                }) => Promise<InviterStudiestedbrukerDto>
            inviterStudiestedbrukerPost?: (params: { 
                nyStudiestedbrukerInvitasjonDto: NyStudiestedbrukerInvitasjonDto,
                options?: any
                }) => Promise<void>
            muligeStudiestederGet?: (params?: { 
                options?: any
                }) => Promise<Array<MuligeStudiestedDto>>
            studentbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudentbrukerprofilDto>
            studiestedMedHierarkiIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<MinimalStudiestedDto>
            studiestedbrukerIdDelete?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            studiestedbrukereGet?: (params: { 
                    queryParams?: { studiestedId?: string,  },
                options?: any
                }) => Promise<Array<StudiestedbrukerDto>>
            studiestedbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudiestedbrukerprofilDto>
            studiestedbrukerprofilIdPut?: (params: { 
                    pathParams: { id: string,  },
                studiestedbrukerprofilPutDto: StudiestedbrukerprofilPutDto,
                options?: any
                }) => Promise<void>
            }): StudiestedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            inviterStudiestedbrukerGet: (operations.inviterStudiestedbrukerGet || reject("inviterStudiestedbrukerGet")),
            inviterStudiestedbrukerPost: (operations.inviterStudiestedbrukerPost || reject("inviterStudiestedbrukerPost")),
            muligeStudiestederGet: (operations.muligeStudiestederGet || reject("muligeStudiestederGet")),
            studentbrukerprofilIdGet: (operations.studentbrukerprofilIdGet || reject("studentbrukerprofilIdGet")),
            studiestedMedHierarkiIdGet: (operations.studiestedMedHierarkiIdGet || reject("studiestedMedHierarkiIdGet")),
            studiestedbrukerIdDelete: (operations.studiestedbrukerIdDelete || reject("studiestedbrukerIdDelete")),
            studiestedbrukereGet: (operations.studiestedbrukereGet || reject("studiestedbrukereGet")),
            studiestedbrukerprofilIdGet: (operations.studiestedbrukerprofilIdGet || reject("studiestedbrukerprofilIdGet")),
            studiestedbrukerprofilIdPut: (operations.studiestedbrukerprofilIdPut || reject("studiestedbrukerprofilIdPut")),
            };
            }


        /**
        * VurderingApi - object-oriented interface
        * @export
        * @class VurderingApiInterface
        * @extends {BaseAPI}
        */
        export interface VurderingApiInterface {
            /**
            * 
                * @summary Henter liste av praksisaktiviteter hvor brukeren kan delta på vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingApi
            */
            vurderingAktiviteterGet(params?: { 
            options?: any
            }): Promise<MinimalAktiviteterDto>;
            }
        /**
        * VurderingApi - object-oriented interface
        * @export
        * @class VurderingApi
        * @extends {BaseAPI}
        */
            export class VurderingApi extends BaseAPI implements VurderingApiInterface {
            /**
            * 
                * @summary Henter liste av praksisaktiviteter hvor brukeren kan delta på vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingApi
            */
            public async vurderingAktiviteterGet(params?: { 
            options?: any
            }): Promise<MinimalAktiviteterDto> {
            return await this.GET(
        "/vurdering/aktiviteter",
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockVurderingApi(operations: {
            vurderingAktiviteterGet?: (params?: { 
                options?: any
                }) => Promise<MinimalAktiviteterDto>
            }): VurderingApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            vurderingAktiviteterGet: (operations.vurderingAktiviteterGet || reject("vurderingAktiviteterGet")),
            };
            }


        /**
        * VurderingStudentApi - object-oriented interface
        * @export
        * @class VurderingStudentApiInterface
        * @extends {BaseAPI}
        */
        export interface VurderingStudentApiInterface {
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingAktivitetIdMidtveisStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto>;
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingAktivitetIdSluttStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto>;
            /**
            * 
                * @summary Henter alle læringsutbytter med kommentarer fra vurderingsroller for en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingStudentVurderingIdKommentarGet(params: { 
                pathParams: { studentVurderingId: string,  },
            options?: any
            }): Promise<VurderingKommentarerDto>;
            /**
            * 
                * @summary Kommenterer læringsutbytte på en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingStudentVurderingIdKommentarPost(params: { 
                pathParams: { studentVurderingId: string,  },
                laeringsutbytteKommenterDto: LaeringsutbytteKommenterDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Endrer kommentar på læringsutbytte for en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingStudentVurderingIdKommentarPut(params: { 
                pathParams: { studentVurderingId: string,  },
                laeringsutbytteKommentarRedigerDto: LaeringsutbytteKommentarRedigerDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingVurderingStatusIdOppsummeringGet(params: { 
                pathParams: { vurderingStatusId: string,  },
            options?: any
            }): Promise<VurderingOppsummeringDto>;
            /**
            * 
                * @summary Lagrer vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingVurderingStatusIdOppsummeringPut(params: { 
                pathParams: { vurderingStatusId: string,  },
                vurderingOppsummeringDto: VurderingOppsummeringDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * VurderingStudentApi - object-oriented interface
        * @export
        * @class VurderingStudentApi
        * @extends {BaseAPI}
        */
            export class VurderingStudentApi extends BaseAPI implements VurderingStudentApiInterface {
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingAktivitetIdMidtveisStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto> {
            return await this.GET(
        this.path("/vurdering/{aktivitetId}/midtveis/studenter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingAktivitetIdSluttStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto> {
            return await this.GET(
        this.path("/vurdering/{aktivitetId}/slutt/studenter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle læringsutbytter med kommentarer fra vurderingsroller for en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingStudentVurderingIdKommentarGet(params: { 
                pathParams: { studentVurderingId: string,  },
            options?: any
            }): Promise<VurderingKommentarerDto> {
            return await this.GET(
        this.path("/vurdering/{studentVurderingId}/kommentar/", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Kommenterer læringsutbytte på en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingStudentVurderingIdKommentarPost(params: { 
                pathParams: { studentVurderingId: string,  },
            laeringsutbytteKommenterDto: LaeringsutbytteKommenterDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/vurdering/{studentVurderingId}/kommentar/", params.pathParams),
        {},
        { body: params.laeringsutbytteKommenterDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endrer kommentar på læringsutbytte for en student vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingStudentVurderingIdKommentarPut(params: { 
                pathParams: { studentVurderingId: string,  },
            laeringsutbytteKommentarRedigerDto: LaeringsutbytteKommentarRedigerDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/vurdering/{studentVurderingId}/kommentar/", params.pathParams),
        {},
        { body: params.laeringsutbytteKommentarRedigerDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingVurderingStatusIdOppsummeringGet(params: { 
                pathParams: { vurderingStatusId: string,  },
            options?: any
            }): Promise<VurderingOppsummeringDto> {
            return await this.GET(
        this.path("/vurdering/{vurderingStatusId}/oppsummering", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagrer vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingVurderingStatusIdOppsummeringPut(params: { 
                pathParams: { vurderingStatusId: string,  },
            vurderingOppsummeringDto: VurderingOppsummeringDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/vurdering/{vurderingStatusId}/oppsummering", params.pathParams),
        {},
        { body: params.vurderingOppsummeringDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockVurderingStudentApi(operations: {
            vurderingAktivitetIdMidtveisStudenterGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<StudenterForVurderingDto>
            vurderingAktivitetIdSluttStudenterGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<StudenterForVurderingDto>
            vurderingStudentVurderingIdKommentarGet?: (params: { 
                    pathParams: { studentVurderingId: string,  },
                options?: any
                }) => Promise<VurderingKommentarerDto>
            vurderingStudentVurderingIdKommentarPost?: (params: { 
                    pathParams: { studentVurderingId: string,  },
                laeringsutbytteKommenterDto: LaeringsutbytteKommenterDto,
                options?: any
                }) => Promise<void>
            vurderingStudentVurderingIdKommentarPut?: (params: { 
                    pathParams: { studentVurderingId: string,  },
                laeringsutbytteKommentarRedigerDto: LaeringsutbytteKommentarRedigerDto,
                options?: any
                }) => Promise<void>
            vurderingVurderingStatusIdOppsummeringGet?: (params: { 
                    pathParams: { vurderingStatusId: string,  },
                options?: any
                }) => Promise<VurderingOppsummeringDto>
            vurderingVurderingStatusIdOppsummeringPut?: (params: { 
                    pathParams: { vurderingStatusId: string,  },
                vurderingOppsummeringDto: VurderingOppsummeringDto,
                options?: any
                }) => Promise<void>
            }): VurderingStudentApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            vurderingAktivitetIdMidtveisStudenterGet: (operations.vurderingAktivitetIdMidtveisStudenterGet || reject("vurderingAktivitetIdMidtveisStudenterGet")),
            vurderingAktivitetIdSluttStudenterGet: (operations.vurderingAktivitetIdSluttStudenterGet || reject("vurderingAktivitetIdSluttStudenterGet")),
            vurderingStudentVurderingIdKommentarGet: (operations.vurderingStudentVurderingIdKommentarGet || reject("vurderingStudentVurderingIdKommentarGet")),
            vurderingStudentVurderingIdKommentarPost: (operations.vurderingStudentVurderingIdKommentarPost || reject("vurderingStudentVurderingIdKommentarPost")),
            vurderingStudentVurderingIdKommentarPut: (operations.vurderingStudentVurderingIdKommentarPut || reject("vurderingStudentVurderingIdKommentarPut")),
            vurderingVurderingStatusIdOppsummeringGet: (operations.vurderingVurderingStatusIdOppsummeringGet || reject("vurderingVurderingStatusIdOppsummeringGet")),
            vurderingVurderingStatusIdOppsummeringPut: (operations.vurderingVurderingStatusIdOppsummeringPut || reject("vurderingVurderingStatusIdOppsummeringPut")),
            };
            }



export class Random {
    seed: number;
    constructor(seed: number) {
        this.seed = seed % 2147483647;
        if (this.seed <= 0) this.seed += 2147483646;
    }
    next(): number {
        this.seed = this.seed * 16807 % 2147483647;
        return this.seed;
    }
    nextFloat(): number {
        return (this.next() - 1) / 2147483646;
    }
    nextInt(limit: number): number {
        return this.next() % limit;
    }
    pickOne<T>(options: Array<T>): T {
        return options[this.nextInt(options.length)];
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = this.nextInt(16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    nextBoolean() {
        return this.nextInt(2) == 0;
    }
}

type Factory<T> = {
    [P in keyof T]?: ((sampleData: TestSampleData) => T[P])|T[P];
};
type EnumFactory<T> = ((sampleData: TestSampleData) => T)|T;
export interface SampleModelFactories {
    AbstractSignatarDto?: Factory<AbstractSignatarDto> | ((testData: TestSampleData) => AbstractSignatarDto);
    AktivitetskravDto?: Factory<AktivitetskravDto> | ((testData: TestSampleData) => AktivitetskravDto);
    AlpKommuneDto?: Factory<AlpKommuneDto> | ((testData: TestSampleData) => AlpKommuneDto);
    AlpLandDto?: Factory<AlpLandDto> | ((testData: TestSampleData) => AlpLandDto);
    AlpPraksisstedGetDto?: Factory<AlpPraksisstedGetDto> | ((testData: TestSampleData) => AlpPraksisstedGetDto);
    AlpPraksisstedMedNivaaDto?: Factory<AlpPraksisstedMedNivaaDto> | ((testData: TestSampleData) => AlpPraksisstedMedNivaaDto);
    AlpPraksisstedPostDto?: Factory<AlpPraksisstedPostDto> | ((testData: TestSampleData) => AlpPraksisstedPostDto);
    AlpPraksisstedtyperGetDto?: Factory<AlpPraksisstedtyperGetDto> | ((testData: TestSampleData) => AlpPraksisstedtyperGetDto);
    AvtalerDto?: Factory<AvtalerDto> | ((testData: TestSampleData) => AvtalerDto);
    AvtalestatusDto?: Factory<AvtalestatusDto> | ((testData: TestSampleData) => AvtalestatusDto);
    AvtalestederMedMuligeOmfattedePraksisstedDto?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto> | ((testData: TestSampleData) => AvtalestederMedMuligeOmfattedePraksisstedDto);
    AvtalestederMedMuligeOmfattedePraksisstedPostDto?: Factory<AvtalestederMedMuligeOmfattedePraksisstedPostDto> | ((testData: TestSampleData) => AvtalestederMedMuligeOmfattedePraksisstedPostDto);
    AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto> | ((testData: TestSampleData) => AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto);
    BrukerinfoDto?: Factory<BrukerinfoDto> | ((testData: TestSampleData) => BrukerinfoDto);
    BrukerinnstillingerDto?: Factory<BrukerinnstillingerDto> | ((testData: TestSampleData) => BrukerinnstillingerDto);
    BrukerrollerDto?: Factory<BrukerrollerDto> | ((testData: TestSampleData) => BrukerrollerDto);
    BrukerrollerPSDto?: Factory<BrukerrollerPSDto> | ((testData: TestSampleData) => BrukerrollerPSDto);
    EierAvtalestedMedMuligeOmfattedeStudiestedDto?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto> | ((testData: TestSampleData) => EierAvtalestedMedMuligeOmfattedeStudiestedDto);
    EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto> | ((testData: TestSampleData) => EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto);
    EierAvtalestedMedMuligeOmfattedeStudiestedPostDto?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedPostDto> | ((testData: TestSampleData) => EierAvtalestedMedMuligeOmfattedeStudiestedPostDto);
    EksternSignatarDto?: Factory<EksternSignatarDto> | ((testData: TestSampleData) => EksternSignatarDto);
    EmneDto?: Factory<EmneDto> | ((testData: TestSampleData) => EmneDto);
    EnhetsregEnhetAdresseDto?: Factory<EnhetsregEnhetAdresseDto> | ((testData: TestSampleData) => EnhetsregEnhetAdresseDto);
    EnhetsregEnhetDto?: Factory<EnhetsregEnhetDto> | ((testData: TestSampleData) => EnhetsregEnhetDto);
    FSAktivitetfeilDto?: Factory<FSAktivitetfeilDto> | ((testData: TestSampleData) => FSAktivitetfeilDto);
    FSAktivitetstatusDto?: Factory<FSAktivitetstatusDto> | ((testData: TestSampleData) => FSAktivitetstatusDto);
    FSAktivitetstatustypeDto?: Factory<FSAktivitetstatustypeDto> | ((testData: TestSampleData) => FSAktivitetstatustypeDto);
    FSFeilDto?: Factory<FSFeilDto> | ((testData: TestSampleData) => FSFeilDto);
    FSFeillisteDto?: Factory<FSFeillisteDto> | ((testData: TestSampleData) => FSFeillisteDto);
    FSFeiltypeDto?: Factory<FSFeiltypeDto> | ((testData: TestSampleData) => FSFeiltypeDto);
    FSSyncStatusDto?: Factory<FSSyncStatusDto> | ((testData: TestSampleData) => FSSyncStatusDto);
    FSSyncStatusPerTypeDto?: Factory<FSSyncStatusPerTypeDto> | ((testData: TestSampleData) => FSSyncStatusPerTypeDto);
    FSSyncStatuserDto?: Factory<FSSyncStatuserDto> | ((testData: TestSampleData) => FSSyncStatuserDto);
    FSSyncTypeDto?: Factory<FSSyncTypeDto> | ((testData: TestSampleData) => FSSyncTypeDto);
    FeilmeldingDto?: Factory<FeilmeldingDto> | ((testData: TestSampleData) => FeilmeldingDto);
    HalPraksisavtaleVedleggMinimalListDto?: Factory<HalPraksisavtaleVedleggMinimalListDto> | ((testData: TestSampleData) => HalPraksisavtaleVedleggMinimalListDto);
    HalPraksisstedavtaleDto?: Factory<HalPraksisstedavtaleDto> | ((testData: TestSampleData) => HalPraksisstedavtaleDto);
    HalPraksisstedavtaleOneOf1Dto?: Factory<HalPraksisstedavtaleOneOf1Dto> | ((testData: TestSampleData) => HalPraksisstedavtaleOneOf1Dto);
    HalPraksisstedavtaleOneOfDto?: Factory<HalPraksisstedavtaleOneOfDto> | ((testData: TestSampleData) => HalPraksisstedavtaleOneOfDto);
    HalPraksisstedavtalerDto?: Factory<HalPraksisstedavtalerDto> | ((testData: TestSampleData) => HalPraksisstedavtalerDto);
    InviterStudiestedbrukerDto?: Factory<InviterStudiestedbrukerDto> | ((testData: TestSampleData) => InviterStudiestedbrukerDto);
    LaeringsutbytteDto?: Factory<LaeringsutbytteDto> | ((testData: TestSampleData) => LaeringsutbytteDto);
    LaeringsutbytteKommentarDto?: Factory<LaeringsutbytteKommentarDto> | ((testData: TestSampleData) => LaeringsutbytteKommentarDto);
    LaeringsutbytteKommentarRedigerDto?: Factory<LaeringsutbytteKommentarRedigerDto> | ((testData: TestSampleData) => LaeringsutbytteKommentarRedigerDto);
    LaeringsutbytteKommenterDto?: Factory<LaeringsutbytteKommenterDto> | ((testData: TestSampleData) => LaeringsutbytteKommenterDto);
    LaeringsutbytteMedRollersKommentarDto?: Factory<LaeringsutbytteMedRollersKommentarDto> | ((testData: TestSampleData) => LaeringsutbytteMedRollersKommentarDto);
    LaeringsutbyttegruppeDto?: Factory<LaeringsutbyttegruppeDto> | ((testData: TestSampleData) => LaeringsutbyttegruppeDto);
    LaeringsutbyttegruppeEnumDto?: Factory<LaeringsutbyttegruppeEnumDto> | ((testData: TestSampleData) => LaeringsutbyttegruppeEnumDto);
    LaeringsutbyttegruppeMinimalDto?: Factory<LaeringsutbyttegruppeMinimalDto> | ((testData: TestSampleData) => LaeringsutbyttegruppeMinimalDto);
    LaeringsutbyttegruppeNyDto?: Factory<LaeringsutbyttegruppeNyDto> | ((testData: TestSampleData) => LaeringsutbyttegruppeNyDto);
    MatchingPraksisstedDto?: Factory<MatchingPraksisstedDto> | ((testData: TestSampleData) => MatchingPraksisstedDto);
    MinimalAktivitetInfoDto?: Factory<MinimalAktivitetInfoDto> | ((testData: TestSampleData) => MinimalAktivitetInfoDto);
    MinimalAktiviteterDto?: Factory<MinimalAktiviteterDto> | ((testData: TestSampleData) => MinimalAktiviteterDto);
    MinimalMinimalStudiestedDto?: Factory<MinimalMinimalStudiestedDto> | ((testData: TestSampleData) => MinimalMinimalStudiestedDto);
    MinimalPraksisstedDto?: Factory<MinimalPraksisstedDto> | ((testData: TestSampleData) => MinimalPraksisstedDto);
    MinimalPraksisstedMedHierarkiDto?: Factory<MinimalPraksisstedMedHierarkiDto> | ((testData: TestSampleData) => MinimalPraksisstedMedHierarkiDto);
    MinimalPraksisstedMedHierarkiNoderDto?: Factory<MinimalPraksisstedMedHierarkiNoderDto> | ((testData: TestSampleData) => MinimalPraksisstedMedHierarkiNoderDto);
    MinimalStudiestedDto?: Factory<MinimalStudiestedDto> | ((testData: TestSampleData) => MinimalStudiestedDto);
    MinimalStudiestedNoderDto?: Factory<MinimalStudiestedNoderDto> | ((testData: TestSampleData) => MinimalStudiestedNoderDto);
    MuligePraksisstedDto?: Factory<MuligePraksisstedDto> | ((testData: TestSampleData) => MuligePraksisstedDto);
    MuligeStudiestedDto?: Factory<MuligeStudiestedDto> | ((testData: TestSampleData) => MuligeStudiestedDto);
    MuligeStudiestedbrukereDto?: Factory<MuligeStudiestedbrukereDto> | ((testData: TestSampleData) => MuligeStudiestedbrukereDto);
    MultiSignatarerDto?: Factory<MultiSignatarerDto> | ((testData: TestSampleData) => MultiSignatarerDto);
    NyPraksisaktivitetDto?: Factory<NyPraksisaktivitetDto> | ((testData: TestSampleData) => NyPraksisaktivitetDto);
    NyPraksisklasseDto?: Factory<NyPraksisklasseDto> | ((testData: TestSampleData) => NyPraksisklasseDto);
    NyPraksisstedbrukerInvitasjonDto?: Factory<NyPraksisstedbrukerInvitasjonDto> | ((testData: TestSampleData) => NyPraksisstedbrukerInvitasjonDto);
    NyPraksisstedbrukerRolleDto?: Factory<NyPraksisstedbrukerRolleDto> | ((testData: TestSampleData) => NyPraksisstedbrukerRolleDto);
    NyStudiestedbrukerInvitasjonDto?: Factory<NyStudiestedbrukerInvitasjonDto> | ((testData: TestSampleData) => NyStudiestedbrukerInvitasjonDto);
    NyStudiestedbrukerRolleDto?: Factory<NyStudiestedbrukerRolleDto> | ((testData: TestSampleData) => NyStudiestedbrukerRolleDto);
    OverlappendePraksisstedavtalesokRequestDto?: Factory<OverlappendePraksisstedavtalesokRequestDto> | ((testData: TestSampleData) => OverlappendePraksisstedavtalesokRequestDto);
    OverlappendePraksisstedavtalesokResponseDto?: Factory<OverlappendePraksisstedavtalesokResponseDto> | ((testData: TestSampleData) => OverlappendePraksisstedavtalesokResponseDto);
    PeriodeDto?: Factory<PeriodeDto> | ((testData: TestSampleData) => PeriodeDto);
    PersonDto?: Factory<PersonDto> | ((testData: TestSampleData) => PersonDto);
    PraksisDto?: Factory<PraksisDto> | ((testData: TestSampleData) => PraksisDto);
    PraksisaktivitetAvtalerDto?: Factory<PraksisaktivitetAvtalerDto> | ((testData: TestSampleData) => PraksisaktivitetAvtalerDto);
    PraksisaktivitetBestillingPutDto?: Factory<PraksisaktivitetBestillingPutDto> | ((testData: TestSampleData) => PraksisaktivitetBestillingPutDto);
    PraksisaktivitetDto?: Factory<PraksisaktivitetDto> | ((testData: TestSampleData) => PraksisaktivitetDto);
    PraksisaktivitetEndretDto?: Factory<PraksisaktivitetEndretDto> | ((testData: TestSampleData) => PraksisaktivitetEndretDto);
    PraksisaktivitetInfoDetaljertPsDto?: Factory<PraksisaktivitetInfoDetaljertPsDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDetaljertPsDto);
    PraksisaktivitetInfoDetaljertUhDto?: Factory<PraksisaktivitetInfoDetaljertUhDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDetaljertUhDto);
    PraksisaktivitetInfoDto?: Factory<PraksisaktivitetInfoDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDto);
    PraksisaktivitetKopiEgenskaperDto?: Factory<PraksisaktivitetKopiEgenskaperDto> | ((testData: TestSampleData) => PraksisaktivitetKopiEgenskaperDto);
    PraksisaktivitetKopiPostDto?: Factory<PraksisaktivitetKopiPostDto> | ((testData: TestSampleData) => PraksisaktivitetKopiPostDto);
    PraksisaktivitetOnskelisteInfoDto?: Factory<PraksisaktivitetOnskelisteInfoDto> | ((testData: TestSampleData) => PraksisaktivitetOnskelisteInfoDto);
    PraksisaktivitetPutBestillingDto?: Factory<PraksisaktivitetPutBestillingDto> | ((testData: TestSampleData) => PraksisaktivitetPutBestillingDto);
    PraksisaktivitetPutDto?: Factory<PraksisaktivitetPutDto> | ((testData: TestSampleData) => PraksisaktivitetPutDto);
    PraksisaktivitetPutKapasitetDto?: Factory<PraksisaktivitetPutKapasitetDto> | ((testData: TestSampleData) => PraksisaktivitetPutKapasitetDto);
    PraksisaktivitetStatusDto?: Factory<PraksisaktivitetStatusDto> | ((testData: TestSampleData) => PraksisaktivitetStatusDto);
    PraksisaktiviteterDto?: Factory<PraksisaktiviteterDto> | ((testData: TestSampleData) => PraksisaktiviteterDto);
    PraksisaktiviteterInfoDto?: Factory<PraksisaktiviteterInfoDto> | ((testData: TestSampleData) => PraksisaktiviteterInfoDto);
    PraksisavtaleIdToPraksisstedIderDto?: Factory<PraksisavtaleIdToPraksisstedIderDto> | ((testData: TestSampleData) => PraksisavtaleIdToPraksisstedIderDto);
    PraksisavtaleStedBestillingspunktTypeDto?: Factory<PraksisavtaleStedBestillingspunktTypeDto> | ((testData: TestSampleData) => PraksisavtaleStedBestillingspunktTypeDto);
    PraksisavtaleStedDto?: Factory<PraksisavtaleStedDto> | ((testData: TestSampleData) => PraksisavtaleStedDto);
    PraksisavtaleValideringfeiltypeDto?: Factory<PraksisavtaleValideringfeiltypeDto> | ((testData: TestSampleData) => PraksisavtaleValideringfeiltypeDto);
    PraksisavtaleValideringsfeilDto?: Factory<PraksisavtaleValideringsfeilDto> | ((testData: TestSampleData) => PraksisavtaleValideringsfeilDto);
    PraksisavtaleVedleggDto?: Factory<PraksisavtaleVedleggDto> | ((testData: TestSampleData) => PraksisavtaleVedleggDto);
    PraksisavtaleVedleggMinimalDto?: Factory<PraksisavtaleVedleggMinimalDto> | ((testData: TestSampleData) => PraksisavtaleVedleggMinimalDto);
    PraksisavtaleVedleggPostDto?: Factory<PraksisavtaleVedleggPostDto> | ((testData: TestSampleData) => PraksisavtaleVedleggPostDto);
    PraksisavtaleVedleggTypeDto?: Factory<PraksisavtaleVedleggTypeDto> | ((testData: TestSampleData) => PraksisavtaleVedleggTypeDto);
    PraksisavtalestedValideringfeilDto?: Factory<PraksisavtalestedValideringfeilDto> | ((testData: TestSampleData) => PraksisavtalestedValideringfeilDto);
    PraksisavtalestedValideringfeiltypeDto?: Factory<PraksisavtalestedValideringfeiltypeDto> | ((testData: TestSampleData) => PraksisavtalestedValideringfeiltypeDto);
    PraksiskalenderAktivitetDto?: Factory<PraksiskalenderAktivitetDto> | ((testData: TestSampleData) => PraksiskalenderAktivitetDto);
    PraksiskalenderDto?: Factory<PraksiskalenderDto> | ((testData: TestSampleData) => PraksiskalenderDto);
    PraksisklasseDto?: Factory<PraksisklasseDto> | ((testData: TestSampleData) => PraksisklasseDto);
    PraksisklasseMedAktiviteterDto?: Factory<PraksisklasseMedAktiviteterDto> | ((testData: TestSampleData) => PraksisklasseMedAktiviteterDto);
    PraksisklasserPrEmneDto?: Factory<PraksisklasserPrEmneDto> | ((testData: TestSampleData) => PraksisklasserPrEmneDto);
    PraksisplassTilFordelingDto?: Factory<PraksisplassTilFordelingDto> | ((testData: TestSampleData) => PraksisplassTilFordelingDto);
    PraksisstedByAvtaleIdDto?: Factory<PraksisstedByAvtaleIdDto> | ((testData: TestSampleData) => PraksisstedByAvtaleIdDto);
    PraksisstedDto?: Factory<PraksisstedDto> | ((testData: TestSampleData) => PraksisstedDto);
    PraksisstedInfoPutDto?: Factory<PraksisstedInfoPutDto> | ((testData: TestSampleData) => PraksisstedInfoPutDto);
    PraksisstedMedValideringsfeilDto?: Factory<PraksisstedMedValideringsfeilDto> | ((testData: TestSampleData) => PraksisstedMedValideringsfeilDto);
    PraksisstedRollerDto?: Factory<PraksisstedRollerDto> | ((testData: TestSampleData) => PraksisstedRollerDto);
    PraksisstedTilFordelingDto?: Factory<PraksisstedTilFordelingDto> | ((testData: TestSampleData) => PraksisstedTilFordelingDto);
    PraksisstedTilgangerDto?: Factory<PraksisstedTilgangerDto> | ((testData: TestSampleData) => PraksisstedTilgangerDto);
    PraksisstedUndernodeDto?: Factory<PraksisstedUndernodeDto> | ((testData: TestSampleData) => PraksisstedUndernodeDto);
    PraksisstedavtaleAllOfDto?: Factory<PraksisstedavtaleAllOfDto> | ((testData: TestSampleData) => PraksisstedavtaleAllOfDto);
    PraksisstedavtaleCommonDto?: Factory<PraksisstedavtaleCommonDto> | ((testData: TestSampleData) => PraksisstedavtaleCommonDto);
    PraksisstedavtaleDto?: Factory<PraksisstedavtaleDto> | ((testData: TestSampleData) => PraksisstedavtaleDto);
    PraksisstedavtaleMedStedForelderHierarkiAllOfDto?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto> | ((testData: TestSampleData) => PraksisstedavtaleMedStedForelderHierarkiAllOfDto);
    PraksisstedavtaleMedStedForelderHierarkiDto?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto> | ((testData: TestSampleData) => PraksisstedavtaleMedStedForelderHierarkiDto);
    PraksisstedavtalePostDto?: Factory<PraksisstedavtalePostDto> | ((testData: TestSampleData) => PraksisstedavtalePostDto);
    PraksisstedavtaleViewDto?: Factory<PraksisstedavtaleViewDto> | ((testData: TestSampleData) => PraksisstedavtaleViewDto);
    PraksisstedavtalerDto?: Factory<PraksisstedavtalerDto> | ((testData: TestSampleData) => PraksisstedavtalerDto);
    PraksisstedbrukerDto?: Factory<PraksisstedbrukerDto> | ((testData: TestSampleData) => PraksisstedbrukerDto);
    PraksisstedbrukerSignatarDto?: Factory<PraksisstedbrukerSignatarDto> | ((testData: TestSampleData) => PraksisstedbrukerSignatarDto);
    PraksisstedbrukerprofilDto?: Factory<PraksisstedbrukerprofilDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilDto);
    PraksisstedbrukerprofilKanRedigereDto?: Factory<PraksisstedbrukerprofilKanRedigereDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilKanRedigereDto);
    PraksisstedbrukerprofilPutDto?: Factory<PraksisstedbrukerprofilPutDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilPutDto);
    PraksisstedbrukerprofilPutTilgangerInnerDto?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilPutTilgangerInnerDto);
    PraksisstederForAktivitetskravDto?: Factory<PraksisstederForAktivitetskravDto> | ((testData: TestSampleData) => PraksisstederForAktivitetskravDto);
    PraksisstedprofilAdresseDto?: Factory<PraksisstedprofilAdresseDto> | ((testData: TestSampleData) => PraksisstedprofilAdresseDto);
    PraksisstedprofilDto?: Factory<PraksisstedprofilDto> | ((testData: TestSampleData) => PraksisstedprofilDto);
    PraksisstedprofilNoderDto?: Factory<PraksisstedprofilNoderDto> | ((testData: TestSampleData) => PraksisstedprofilNoderDto);
    PraksisstedprofilPutDto?: Factory<PraksisstedprofilPutDto> | ((testData: TestSampleData) => PraksisstedprofilPutDto);
    PraksisstedtypeDto?: Factory<PraksisstedtypeDto> | ((testData: TestSampleData) => PraksisstedtypeDto);
    PraksistypeDto?: Factory<PraksistypeDto> | ((testData: TestSampleData) => PraksistypeDto);
    PraksistypeMedAktivitetskravDto?: Factory<PraksistypeMedAktivitetskravDto> | ((testData: TestSampleData) => PraksistypeMedAktivitetskravDto);
    PraksistypeMedEmnerDto?: Factory<PraksistypeMedEmnerDto> | ((testData: TestSampleData) => PraksistypeMedEmnerDto);
    RegistreringsStatusDto?: Factory<RegistreringsStatusDto> | ((testData: TestSampleData) => RegistreringsStatusDto);
    RolleDto?: Factory<RolleDto> | ((testData: TestSampleData) => RolleDto);
    RolleTypeDto?: Factory<RolleTypeDto> | ((testData: TestSampleData) => RolleTypeDto);
    SaksansvarligDto?: Factory<SaksansvarligDto> | ((testData: TestSampleData) => SaksansvarligDto);
    StudentVurderingDto?: Factory<StudentVurderingDto> | ((testData: TestSampleData) => StudentVurderingDto);
    StudentbrukerDto?: Factory<StudentbrukerDto> | ((testData: TestSampleData) => StudentbrukerDto);
    StudentbrukerprofilDto?: Factory<StudentbrukerprofilDto> | ((testData: TestSampleData) => StudentbrukerprofilDto);
    StudenterForVurderingDto?: Factory<StudenterForVurderingDto> | ((testData: TestSampleData) => StudenterForVurderingDto);
    StudenterMedKlasseDto?: Factory<StudenterMedKlasseDto> | ((testData: TestSampleData) => StudenterMedKlasseDto);
    StudentfordelingDto?: Factory<StudentfordelingDto> | ((testData: TestSampleData) => StudentfordelingDto);
    StudentfordelingMedValgDto?: Factory<StudentfordelingMedValgDto> | ((testData: TestSampleData) => StudentfordelingMedValgDto);
    StudentfordelingPutDto?: Factory<StudentfordelingPutDto> | ((testData: TestSampleData) => StudentfordelingPutDto);
    StudentregistreringDto?: Factory<StudentregistreringDto> | ((testData: TestSampleData) => StudentregistreringDto);
    StudentregistreringPutDto?: Factory<StudentregistreringPutDto> | ((testData: TestSampleData) => StudentregistreringPutDto);
    StudentregistreringPutWrappedDto?: Factory<StudentregistreringPutWrappedDto> | ((testData: TestSampleData) => StudentregistreringPutWrappedDto);
    StudiestedDto?: Factory<StudiestedDto> | ((testData: TestSampleData) => StudiestedDto);
    StudiestedRollerDto?: Factory<StudiestedRollerDto> | ((testData: TestSampleData) => StudiestedRollerDto);
    StudiestedTilgangerDto?: Factory<StudiestedTilgangerDto> | ((testData: TestSampleData) => StudiestedTilgangerDto);
    StudiestedbrukerDto?: Factory<StudiestedbrukerDto> | ((testData: TestSampleData) => StudiestedbrukerDto);
    StudiestedbrukerSignatarDto?: Factory<StudiestedbrukerSignatarDto> | ((testData: TestSampleData) => StudiestedbrukerSignatarDto);
    StudiestedbrukerprofilDto?: Factory<StudiestedbrukerprofilDto> | ((testData: TestSampleData) => StudiestedbrukerprofilDto);
    StudiestedbrukerprofilPutDto?: Factory<StudiestedbrukerprofilPutDto> | ((testData: TestSampleData) => StudiestedbrukerprofilPutDto);
    StudiestedbrukerprofilPutTilgangerInnerDto?: Factory<StudiestedbrukerprofilPutTilgangerInnerDto> | ((testData: TestSampleData) => StudiestedbrukerprofilPutTilgangerInnerDto);
    UndervisningsenhetPeriodeDto?: Factory<UndervisningsenhetPeriodeDto> | ((testData: TestSampleData) => UndervisningsenhetPeriodeDto);
    UndervisningsenhetToPraksisklasseMedAktiviteterDto?: Factory<UndervisningsenhetToPraksisklasseMedAktiviteterDto> | ((testData: TestSampleData) => UndervisningsenhetToPraksisklasseMedAktiviteterDto);
    VurderingKommentarerDto?: Factory<VurderingKommentarerDto> | ((testData: TestSampleData) => VurderingKommentarerDto);
    VurderingOppsummeringDto?: Factory<VurderingOppsummeringDto> | ((testData: TestSampleData) => VurderingOppsummeringDto);
    VurderingStudentDto?: Factory<VurderingStudentDto> | ((testData: TestSampleData) => VurderingStudentDto);
    VurderingsinnstillingerDto?: Factory<VurderingsinnstillingerDto> | ((testData: TestSampleData) => VurderingsinnstillingerDto);
    VurderingskriterieDto?: Factory<VurderingskriterieDto> | ((testData: TestSampleData) => VurderingskriterieDto);
    VurderingsrollerDto?: Factory<VurderingsrollerDto> | ((testData: TestSampleData) => VurderingsrollerDto);
    VurderingstyperDto?: Factory<VurderingstyperDto> | ((testData: TestSampleData) => VurderingstyperDto);
}
export interface SamplePropertyValues {
    [key: string]: (sampleData: TestSampleData) => any;
}

export interface RandomGenerator {
    nextFloat: () => number;
    nextInt: (limit: number) => number;
    nextBoolean: () => boolean;
    pickOne: <T>(options: Array<T>) => T;
    uuidv4: ()  => string;
    randomEmail: () => string;
    randomPastDateTime: (now: Date) => Date;
    generate: (modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean) => any;
}

export interface TestData {
    seed?: number;
    sampleModelProperties?: SampleModelFactories;
    samplePropertyValues?: SamplePropertyValues;
}
export class TestSampleData implements RandomGenerator {
    random: Random;
    sampleModelProperties: any;
    samplePropertyValues: SamplePropertyValues;
    constructor(testData: TestData) {
        this.random = new Random(testData.seed || 100);
        this.sampleModelProperties = testData.sampleModelProperties || {};
        this.samplePropertyValues = testData.samplePropertyValues || {};
    }
    nextFloat() { return this.random.nextFloat(); }
    nextInt(limit: number) { return this.random.nextInt(limit); }
    nextBoolean() { return this.random.nextBoolean(); }
    pickOne<T>(options: Array<T>) { return this.random.pickOne(options); }
    uuidv4() { return this.random.uuidv4(); }
    randomEmail() {
        return this.pickOne(["james", "mary", "john", "patricia", "robert", "jennifer", "michael", "linda"]) +
            "." + this.pickOne(["smith", "williams", "johnson", "jones", "brown", "davis", "miller", "wilson"]) +
            "@" + this.pickOne(["a", "b", "c", "d", "e"]) + ".example." + this.pickOne(["net", "com", "org"]);
    }
    randomPastDateTime(now: Date) {
        return new Date((now.getTime() - this.nextInt(4*7*24*60*60*1000)));
    }
    generate(modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean): any {
        if (this.sampleModelProperties[modelClass]) {
            const propertyFactory: Factory<any> = this.sampleModelProperties[modelClass][modelVar];
            if (propertyFactory && typeof propertyFactory === "function") {
                return propertyFactory(this);
            } else if (propertyFactory) {
                return propertyFactory;
            }
        }
        if (this.samplePropertyValues[modelVar]) {
            return this.samplePropertyValues[modelVar](this);
        }
        if (example && example !== "null") return example;
        if (dataType === "Array<string>") {
            return Array.from({length: this.arrayLength("Array<string>")}).map((i) => "foo " + i);
        }
        if (dataType.startsWith("Array<")) {
            return this.sample(dataType);
        }
        if (modelVar.endsWith("Id") || modelVar === "id") {
            return this.uuidv4();
        }
        if (dataType === "boolean") {
            return this.nextBoolean();
        }
        if (dataType === "number") {
            return this.nextInt(100);
        }
        const key = `sample${dataType}` as keyof TestSampleData;
        if( typeof this[key] === "function"){
            return this[key]();
        }
        return "foo";
    }
    arrayLength(modelClass: string) {
        return this.nextInt(3) + 1;
    }
    sample(modelName: string): any {
        switch(modelName) {
            case "AbstractSignatarDto": return this.sampleAbstractSignatarDto({});
            case "Array<AbstractSignatarDto>": return this.sampleArrayAbstractSignatarDto({});
            case "AktivitetskravDto": return this.sampleAktivitetskravDto({});
            case "Array<AktivitetskravDto>": return this.sampleArrayAktivitetskravDto({});
            case "AlpKommuneDto": return this.sampleAlpKommuneDto({});
            case "Array<AlpKommuneDto>": return this.sampleArrayAlpKommuneDto({});
            case "AlpLandDto": return this.sampleAlpLandDto({});
            case "Array<AlpLandDto>": return this.sampleArrayAlpLandDto({});
            case "AlpPraksisstedGetDto": return this.sampleAlpPraksisstedGetDto({});
            case "Array<AlpPraksisstedGetDto>": return this.sampleArrayAlpPraksisstedGetDto({});
            case "AlpPraksisstedMedNivaaDto": return this.sampleAlpPraksisstedMedNivaaDto({});
            case "Array<AlpPraksisstedMedNivaaDto>": return this.sampleArrayAlpPraksisstedMedNivaaDto({});
            case "AlpPraksisstedPostDto": return this.sampleAlpPraksisstedPostDto({});
            case "Array<AlpPraksisstedPostDto>": return this.sampleArrayAlpPraksisstedPostDto({});
            case "AlpPraksisstedtyperGetDto": return this.sampleAlpPraksisstedtyperGetDto({});
            case "Array<AlpPraksisstedtyperGetDto>": return this.sampleArrayAlpPraksisstedtyperGetDto({});
            case "AvtalerDto": return this.sampleAvtalerDto({});
            case "Array<AvtalerDto>": return this.sampleArrayAvtalerDto({});
            case "AvtalestatusDto": return this.sampleAvtalestatusDto();
            case "Array<AvtalestatusDto>": return this.sampleArrayAvtalestatusDto();
            case "AvtalestederMedMuligeOmfattedePraksisstedDto": return this.sampleAvtalestederMedMuligeOmfattedePraksisstedDto({});
            case "Array<AvtalestederMedMuligeOmfattedePraksisstedDto>": return this.sampleArrayAvtalestederMedMuligeOmfattedePraksisstedDto({});
            case "AvtalestederMedMuligeOmfattedePraksisstedPostDto": return this.sampleAvtalestederMedMuligeOmfattedePraksisstedPostDto({});
            case "Array<AvtalestederMedMuligeOmfattedePraksisstedPostDto>": return this.sampleArrayAvtalestederMedMuligeOmfattedePraksisstedPostDto({});
            case "AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto": return this.sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto({});
            case "Array<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>": return this.sampleArrayAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto({});
            case "BrukerinfoDto": return this.sampleBrukerinfoDto({});
            case "Array<BrukerinfoDto>": return this.sampleArrayBrukerinfoDto({});
            case "BrukerinnstillingerDto": return this.sampleBrukerinnstillingerDto({});
            case "Array<BrukerinnstillingerDto>": return this.sampleArrayBrukerinnstillingerDto({});
            case "BrukerrollerDto": return this.sampleBrukerrollerDto();
            case "Array<BrukerrollerDto>": return this.sampleArrayBrukerrollerDto();
            case "BrukerrollerPSDto": return this.sampleBrukerrollerPSDto();
            case "Array<BrukerrollerPSDto>": return this.sampleArrayBrukerrollerPSDto();
            case "EierAvtalestedMedMuligeOmfattedeStudiestedDto": return this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto({});
            case "Array<EierAvtalestedMedMuligeOmfattedeStudiestedDto>": return this.sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedDto({});
            case "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto": return this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto({});
            case "Array<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>": return this.sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto({});
            case "EierAvtalestedMedMuligeOmfattedeStudiestedPostDto": return this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedPostDto({});
            case "Array<EierAvtalestedMedMuligeOmfattedeStudiestedPostDto>": return this.sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedPostDto({});
            case "EksternSignatarDto": return this.sampleEksternSignatarDto({});
            case "Array<EksternSignatarDto>": return this.sampleArrayEksternSignatarDto({});
            case "EmneDto": return this.sampleEmneDto({});
            case "Array<EmneDto>": return this.sampleArrayEmneDto({});
            case "EnhetsregEnhetAdresseDto": return this.sampleEnhetsregEnhetAdresseDto({});
            case "Array<EnhetsregEnhetAdresseDto>": return this.sampleArrayEnhetsregEnhetAdresseDto({});
            case "EnhetsregEnhetDto": return this.sampleEnhetsregEnhetDto({});
            case "Array<EnhetsregEnhetDto>": return this.sampleArrayEnhetsregEnhetDto({});
            case "FSAktivitetfeilDto": return this.sampleFSAktivitetfeilDto({});
            case "Array<FSAktivitetfeilDto>": return this.sampleArrayFSAktivitetfeilDto({});
            case "FSAktivitetstatusDto": return this.sampleFSAktivitetstatusDto({});
            case "Array<FSAktivitetstatusDto>": return this.sampleArrayFSAktivitetstatusDto({});
            case "FSAktivitetstatustypeDto": return this.sampleFSAktivitetstatustypeDto();
            case "Array<FSAktivitetstatustypeDto>": return this.sampleArrayFSAktivitetstatustypeDto();
            case "FSFeilDto": return this.sampleFSFeilDto({});
            case "Array<FSFeilDto>": return this.sampleArrayFSFeilDto({});
            case "FSFeillisteDto": return this.sampleFSFeillisteDto({});
            case "Array<FSFeillisteDto>": return this.sampleArrayFSFeillisteDto({});
            case "FSFeiltypeDto": return this.sampleFSFeiltypeDto();
            case "Array<FSFeiltypeDto>": return this.sampleArrayFSFeiltypeDto();
            case "FSSyncStatusDto": return this.sampleFSSyncStatusDto();
            case "Array<FSSyncStatusDto>": return this.sampleArrayFSSyncStatusDto();
            case "FSSyncStatusPerTypeDto": return this.sampleFSSyncStatusPerTypeDto({});
            case "Array<FSSyncStatusPerTypeDto>": return this.sampleArrayFSSyncStatusPerTypeDto({});
            case "FSSyncStatuserDto": return this.sampleFSSyncStatuserDto({});
            case "Array<FSSyncStatuserDto>": return this.sampleArrayFSSyncStatuserDto({});
            case "FSSyncTypeDto": return this.sampleFSSyncTypeDto();
            case "Array<FSSyncTypeDto>": return this.sampleArrayFSSyncTypeDto();
            case "FeilmeldingDto": return this.sampleFeilmeldingDto({});
            case "Array<FeilmeldingDto>": return this.sampleArrayFeilmeldingDto({});
            case "HalPraksisavtaleVedleggMinimalListDto": return this.sampleHalPraksisavtaleVedleggMinimalListDto({});
            case "Array<HalPraksisavtaleVedleggMinimalListDto>": return this.sampleArrayHalPraksisavtaleVedleggMinimalListDto({});
            case "HalPraksisstedavtaleDto": return this.sampleHalPraksisstedavtaleDto({});
            case "Array<HalPraksisstedavtaleDto>": return this.sampleArrayHalPraksisstedavtaleDto({});
            case "HalPraksisstedavtaleOneOf1Dto": return this.sampleHalPraksisstedavtaleOneOf1Dto({});
            case "Array<HalPraksisstedavtaleOneOf1Dto>": return this.sampleArrayHalPraksisstedavtaleOneOf1Dto({});
            case "HalPraksisstedavtaleOneOfDto": return this.sampleHalPraksisstedavtaleOneOfDto({});
            case "Array<HalPraksisstedavtaleOneOfDto>": return this.sampleArrayHalPraksisstedavtaleOneOfDto({});
            case "HalPraksisstedavtalerDto": return this.sampleHalPraksisstedavtalerDto({});
            case "Array<HalPraksisstedavtalerDto>": return this.sampleArrayHalPraksisstedavtalerDto({});
            case "InviterStudiestedbrukerDto": return this.sampleInviterStudiestedbrukerDto({});
            case "Array<InviterStudiestedbrukerDto>": return this.sampleArrayInviterStudiestedbrukerDto({});
            case "LaeringsutbytteDto": return this.sampleLaeringsutbytteDto({});
            case "Array<LaeringsutbytteDto>": return this.sampleArrayLaeringsutbytteDto({});
            case "LaeringsutbytteKommentarDto": return this.sampleLaeringsutbytteKommentarDto({});
            case "Array<LaeringsutbytteKommentarDto>": return this.sampleArrayLaeringsutbytteKommentarDto({});
            case "LaeringsutbytteKommentarRedigerDto": return this.sampleLaeringsutbytteKommentarRedigerDto({});
            case "Array<LaeringsutbytteKommentarRedigerDto>": return this.sampleArrayLaeringsutbytteKommentarRedigerDto({});
            case "LaeringsutbytteKommenterDto": return this.sampleLaeringsutbytteKommenterDto({});
            case "Array<LaeringsutbytteKommenterDto>": return this.sampleArrayLaeringsutbytteKommenterDto({});
            case "LaeringsutbytteMedRollersKommentarDto": return this.sampleLaeringsutbytteMedRollersKommentarDto({});
            case "Array<LaeringsutbytteMedRollersKommentarDto>": return this.sampleArrayLaeringsutbytteMedRollersKommentarDto({});
            case "LaeringsutbyttegruppeDto": return this.sampleLaeringsutbyttegruppeDto({});
            case "Array<LaeringsutbyttegruppeDto>": return this.sampleArrayLaeringsutbyttegruppeDto({});
            case "LaeringsutbyttegruppeEnumDto": return this.sampleLaeringsutbyttegruppeEnumDto();
            case "Array<LaeringsutbyttegruppeEnumDto>": return this.sampleArrayLaeringsutbyttegruppeEnumDto();
            case "LaeringsutbyttegruppeMinimalDto": return this.sampleLaeringsutbyttegruppeMinimalDto({});
            case "Array<LaeringsutbyttegruppeMinimalDto>": return this.sampleArrayLaeringsutbyttegruppeMinimalDto({});
            case "LaeringsutbyttegruppeNyDto": return this.sampleLaeringsutbyttegruppeNyDto({});
            case "Array<LaeringsutbyttegruppeNyDto>": return this.sampleArrayLaeringsutbyttegruppeNyDto({});
            case "MatchingPraksisstedDto": return this.sampleMatchingPraksisstedDto({});
            case "Array<MatchingPraksisstedDto>": return this.sampleArrayMatchingPraksisstedDto({});
            case "MinimalAktivitetInfoDto": return this.sampleMinimalAktivitetInfoDto({});
            case "Array<MinimalAktivitetInfoDto>": return this.sampleArrayMinimalAktivitetInfoDto({});
            case "MinimalAktiviteterDto": return this.sampleMinimalAktiviteterDto({});
            case "Array<MinimalAktiviteterDto>": return this.sampleArrayMinimalAktiviteterDto({});
            case "MinimalMinimalStudiestedDto": return this.sampleMinimalMinimalStudiestedDto({});
            case "Array<MinimalMinimalStudiestedDto>": return this.sampleArrayMinimalMinimalStudiestedDto({});
            case "MinimalPraksisstedDto": return this.sampleMinimalPraksisstedDto({});
            case "Array<MinimalPraksisstedDto>": return this.sampleArrayMinimalPraksisstedDto({});
            case "MinimalPraksisstedMedHierarkiDto": return this.sampleMinimalPraksisstedMedHierarkiDto({});
            case "Array<MinimalPraksisstedMedHierarkiDto>": return this.sampleArrayMinimalPraksisstedMedHierarkiDto({});
            case "MinimalPraksisstedMedHierarkiNoderDto": return this.sampleMinimalPraksisstedMedHierarkiNoderDto({});
            case "Array<MinimalPraksisstedMedHierarkiNoderDto>": return this.sampleArrayMinimalPraksisstedMedHierarkiNoderDto({});
            case "MinimalStudiestedDto": return this.sampleMinimalStudiestedDto({});
            case "Array<MinimalStudiestedDto>": return this.sampleArrayMinimalStudiestedDto({});
            case "MinimalStudiestedNoderDto": return this.sampleMinimalStudiestedNoderDto({});
            case "Array<MinimalStudiestedNoderDto>": return this.sampleArrayMinimalStudiestedNoderDto({});
            case "MuligePraksisstedDto": return this.sampleMuligePraksisstedDto({});
            case "Array<MuligePraksisstedDto>": return this.sampleArrayMuligePraksisstedDto({});
            case "MuligeStudiestedDto": return this.sampleMuligeStudiestedDto({});
            case "Array<MuligeStudiestedDto>": return this.sampleArrayMuligeStudiestedDto({});
            case "MuligeStudiestedbrukereDto": return this.sampleMuligeStudiestedbrukereDto({});
            case "Array<MuligeStudiestedbrukereDto>": return this.sampleArrayMuligeStudiestedbrukereDto({});
            case "MultiSignatarerDto": return this.sampleMultiSignatarerDto({});
            case "Array<MultiSignatarerDto>": return this.sampleArrayMultiSignatarerDto({});
            case "NyPraksisaktivitetDto": return this.sampleNyPraksisaktivitetDto({});
            case "Array<NyPraksisaktivitetDto>": return this.sampleArrayNyPraksisaktivitetDto({});
            case "NyPraksisklasseDto": return this.sampleNyPraksisklasseDto({});
            case "Array<NyPraksisklasseDto>": return this.sampleArrayNyPraksisklasseDto({});
            case "NyPraksisstedbrukerInvitasjonDto": return this.sampleNyPraksisstedbrukerInvitasjonDto({});
            case "Array<NyPraksisstedbrukerInvitasjonDto>": return this.sampleArrayNyPraksisstedbrukerInvitasjonDto({});
            case "NyPraksisstedbrukerRolleDto": return this.sampleNyPraksisstedbrukerRolleDto({});
            case "Array<NyPraksisstedbrukerRolleDto>": return this.sampleArrayNyPraksisstedbrukerRolleDto({});
            case "NyStudiestedbrukerInvitasjonDto": return this.sampleNyStudiestedbrukerInvitasjonDto({});
            case "Array<NyStudiestedbrukerInvitasjonDto>": return this.sampleArrayNyStudiestedbrukerInvitasjonDto({});
            case "NyStudiestedbrukerRolleDto": return this.sampleNyStudiestedbrukerRolleDto({});
            case "Array<NyStudiestedbrukerRolleDto>": return this.sampleArrayNyStudiestedbrukerRolleDto({});
            case "OverlappendePraksisstedavtalesokRequestDto": return this.sampleOverlappendePraksisstedavtalesokRequestDto({});
            case "Array<OverlappendePraksisstedavtalesokRequestDto>": return this.sampleArrayOverlappendePraksisstedavtalesokRequestDto({});
            case "OverlappendePraksisstedavtalesokResponseDto": return this.sampleOverlappendePraksisstedavtalesokResponseDto({});
            case "Array<OverlappendePraksisstedavtalesokResponseDto>": return this.sampleArrayOverlappendePraksisstedavtalesokResponseDto({});
            case "PeriodeDto": return this.samplePeriodeDto({});
            case "Array<PeriodeDto>": return this.sampleArrayPeriodeDto({});
            case "PersonDto": return this.samplePersonDto({});
            case "Array<PersonDto>": return this.sampleArrayPersonDto({});
            case "PraksisDto": return this.samplePraksisDto({});
            case "Array<PraksisDto>": return this.sampleArrayPraksisDto({});
            case "PraksisaktivitetAvtalerDto": return this.samplePraksisaktivitetAvtalerDto({});
            case "Array<PraksisaktivitetAvtalerDto>": return this.sampleArrayPraksisaktivitetAvtalerDto({});
            case "PraksisaktivitetBestillingPutDto": return this.samplePraksisaktivitetBestillingPutDto({});
            case "Array<PraksisaktivitetBestillingPutDto>": return this.sampleArrayPraksisaktivitetBestillingPutDto({});
            case "PraksisaktivitetDto": return this.samplePraksisaktivitetDto({});
            case "Array<PraksisaktivitetDto>": return this.sampleArrayPraksisaktivitetDto({});
            case "PraksisaktivitetEndretDto": return this.samplePraksisaktivitetEndretDto({});
            case "Array<PraksisaktivitetEndretDto>": return this.sampleArrayPraksisaktivitetEndretDto({});
            case "PraksisaktivitetInfoDetaljertPsDto": return this.samplePraksisaktivitetInfoDetaljertPsDto({});
            case "Array<PraksisaktivitetInfoDetaljertPsDto>": return this.sampleArrayPraksisaktivitetInfoDetaljertPsDto({});
            case "PraksisaktivitetInfoDetaljertUhDto": return this.samplePraksisaktivitetInfoDetaljertUhDto({});
            case "Array<PraksisaktivitetInfoDetaljertUhDto>": return this.sampleArrayPraksisaktivitetInfoDetaljertUhDto({});
            case "PraksisaktivitetInfoDto": return this.samplePraksisaktivitetInfoDto({});
            case "Array<PraksisaktivitetInfoDto>": return this.sampleArrayPraksisaktivitetInfoDto({});
            case "PraksisaktivitetKopiEgenskaperDto": return this.samplePraksisaktivitetKopiEgenskaperDto({});
            case "Array<PraksisaktivitetKopiEgenskaperDto>": return this.sampleArrayPraksisaktivitetKopiEgenskaperDto({});
            case "PraksisaktivitetKopiPostDto": return this.samplePraksisaktivitetKopiPostDto({});
            case "Array<PraksisaktivitetKopiPostDto>": return this.sampleArrayPraksisaktivitetKopiPostDto({});
            case "PraksisaktivitetOnskelisteInfoDto": return this.samplePraksisaktivitetOnskelisteInfoDto({});
            case "Array<PraksisaktivitetOnskelisteInfoDto>": return this.sampleArrayPraksisaktivitetOnskelisteInfoDto({});
            case "PraksisaktivitetPutBestillingDto": return this.samplePraksisaktivitetPutBestillingDto({});
            case "Array<PraksisaktivitetPutBestillingDto>": return this.sampleArrayPraksisaktivitetPutBestillingDto({});
            case "PraksisaktivitetPutDto": return this.samplePraksisaktivitetPutDto({});
            case "Array<PraksisaktivitetPutDto>": return this.sampleArrayPraksisaktivitetPutDto({});
            case "PraksisaktivitetPutKapasitetDto": return this.samplePraksisaktivitetPutKapasitetDto({});
            case "Array<PraksisaktivitetPutKapasitetDto>": return this.sampleArrayPraksisaktivitetPutKapasitetDto({});
            case "PraksisaktivitetStatusDto": return this.samplePraksisaktivitetStatusDto();
            case "Array<PraksisaktivitetStatusDto>": return this.sampleArrayPraksisaktivitetStatusDto();
            case "PraksisaktiviteterDto": return this.samplePraksisaktiviteterDto({});
            case "Array<PraksisaktiviteterDto>": return this.sampleArrayPraksisaktiviteterDto({});
            case "PraksisaktiviteterInfoDto": return this.samplePraksisaktiviteterInfoDto({});
            case "Array<PraksisaktiviteterInfoDto>": return this.sampleArrayPraksisaktiviteterInfoDto({});
            case "PraksisavtaleIdToPraksisstedIderDto": return this.samplePraksisavtaleIdToPraksisstedIderDto({});
            case "Array<PraksisavtaleIdToPraksisstedIderDto>": return this.sampleArrayPraksisavtaleIdToPraksisstedIderDto({});
            case "PraksisavtaleStedBestillingspunktTypeDto": return this.samplePraksisavtaleStedBestillingspunktTypeDto();
            case "Array<PraksisavtaleStedBestillingspunktTypeDto>": return this.sampleArrayPraksisavtaleStedBestillingspunktTypeDto();
            case "PraksisavtaleStedDto": return this.samplePraksisavtaleStedDto({});
            case "Array<PraksisavtaleStedDto>": return this.sampleArrayPraksisavtaleStedDto({});
            case "PraksisavtaleValideringfeiltypeDto": return this.samplePraksisavtaleValideringfeiltypeDto();
            case "Array<PraksisavtaleValideringfeiltypeDto>": return this.sampleArrayPraksisavtaleValideringfeiltypeDto();
            case "PraksisavtaleValideringsfeilDto": return this.samplePraksisavtaleValideringsfeilDto({});
            case "Array<PraksisavtaleValideringsfeilDto>": return this.sampleArrayPraksisavtaleValideringsfeilDto({});
            case "PraksisavtaleVedleggDto": return this.samplePraksisavtaleVedleggDto({});
            case "Array<PraksisavtaleVedleggDto>": return this.sampleArrayPraksisavtaleVedleggDto({});
            case "PraksisavtaleVedleggMinimalDto": return this.samplePraksisavtaleVedleggMinimalDto({});
            case "Array<PraksisavtaleVedleggMinimalDto>": return this.sampleArrayPraksisavtaleVedleggMinimalDto({});
            case "PraksisavtaleVedleggPostDto": return this.samplePraksisavtaleVedleggPostDto({});
            case "Array<PraksisavtaleVedleggPostDto>": return this.sampleArrayPraksisavtaleVedleggPostDto({});
            case "PraksisavtaleVedleggTypeDto": return this.samplePraksisavtaleVedleggTypeDto();
            case "Array<PraksisavtaleVedleggTypeDto>": return this.sampleArrayPraksisavtaleVedleggTypeDto();
            case "PraksisavtalestedValideringfeilDto": return this.samplePraksisavtalestedValideringfeilDto({});
            case "Array<PraksisavtalestedValideringfeilDto>": return this.sampleArrayPraksisavtalestedValideringfeilDto({});
            case "PraksisavtalestedValideringfeiltypeDto": return this.samplePraksisavtalestedValideringfeiltypeDto();
            case "Array<PraksisavtalestedValideringfeiltypeDto>": return this.sampleArrayPraksisavtalestedValideringfeiltypeDto();
            case "PraksiskalenderAktivitetDto": return this.samplePraksiskalenderAktivitetDto({});
            case "Array<PraksiskalenderAktivitetDto>": return this.sampleArrayPraksiskalenderAktivitetDto({});
            case "PraksiskalenderDto": return this.samplePraksiskalenderDto({});
            case "Array<PraksiskalenderDto>": return this.sampleArrayPraksiskalenderDto({});
            case "PraksisklasseDto": return this.samplePraksisklasseDto({});
            case "Array<PraksisklasseDto>": return this.sampleArrayPraksisklasseDto({});
            case "PraksisklasseMedAktiviteterDto": return this.samplePraksisklasseMedAktiviteterDto({});
            case "Array<PraksisklasseMedAktiviteterDto>": return this.sampleArrayPraksisklasseMedAktiviteterDto({});
            case "PraksisklasserPrEmneDto": return this.samplePraksisklasserPrEmneDto({});
            case "Array<PraksisklasserPrEmneDto>": return this.sampleArrayPraksisklasserPrEmneDto({});
            case "PraksisplassTilFordelingDto": return this.samplePraksisplassTilFordelingDto({});
            case "Array<PraksisplassTilFordelingDto>": return this.sampleArrayPraksisplassTilFordelingDto({});
            case "PraksisstedByAvtaleIdDto": return this.samplePraksisstedByAvtaleIdDto({});
            case "Array<PraksisstedByAvtaleIdDto>": return this.sampleArrayPraksisstedByAvtaleIdDto({});
            case "PraksisstedDto": return this.samplePraksisstedDto({});
            case "Array<PraksisstedDto>": return this.sampleArrayPraksisstedDto({});
            case "PraksisstedInfoPutDto": return this.samplePraksisstedInfoPutDto({});
            case "Array<PraksisstedInfoPutDto>": return this.sampleArrayPraksisstedInfoPutDto({});
            case "PraksisstedMedValideringsfeilDto": return this.samplePraksisstedMedValideringsfeilDto({});
            case "Array<PraksisstedMedValideringsfeilDto>": return this.sampleArrayPraksisstedMedValideringsfeilDto({});
            case "PraksisstedRollerDto": return this.samplePraksisstedRollerDto();
            case "Array<PraksisstedRollerDto>": return this.sampleArrayPraksisstedRollerDto();
            case "PraksisstedTilFordelingDto": return this.samplePraksisstedTilFordelingDto({});
            case "Array<PraksisstedTilFordelingDto>": return this.sampleArrayPraksisstedTilFordelingDto({});
            case "PraksisstedTilgangerDto": return this.samplePraksisstedTilgangerDto({});
            case "Array<PraksisstedTilgangerDto>": return this.sampleArrayPraksisstedTilgangerDto({});
            case "PraksisstedUndernodeDto": return this.samplePraksisstedUndernodeDto({});
            case "Array<PraksisstedUndernodeDto>": return this.sampleArrayPraksisstedUndernodeDto({});
            case "PraksisstedavtaleAllOfDto": return this.samplePraksisstedavtaleAllOfDto({});
            case "Array<PraksisstedavtaleAllOfDto>": return this.sampleArrayPraksisstedavtaleAllOfDto({});
            case "PraksisstedavtaleCommonDto": return this.samplePraksisstedavtaleCommonDto({});
            case "Array<PraksisstedavtaleCommonDto>": return this.sampleArrayPraksisstedavtaleCommonDto({});
            case "PraksisstedavtaleDto": return this.samplePraksisstedavtaleDto({});
            case "Array<PraksisstedavtaleDto>": return this.sampleArrayPraksisstedavtaleDto({});
            case "PraksisstedavtaleMedStedForelderHierarkiAllOfDto": return this.samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto({});
            case "Array<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>": return this.sampleArrayPraksisstedavtaleMedStedForelderHierarkiAllOfDto({});
            case "PraksisstedavtaleMedStedForelderHierarkiDto": return this.samplePraksisstedavtaleMedStedForelderHierarkiDto({});
            case "Array<PraksisstedavtaleMedStedForelderHierarkiDto>": return this.sampleArrayPraksisstedavtaleMedStedForelderHierarkiDto({});
            case "PraksisstedavtalePostDto": return this.samplePraksisstedavtalePostDto({});
            case "Array<PraksisstedavtalePostDto>": return this.sampleArrayPraksisstedavtalePostDto({});
            case "PraksisstedavtaleViewDto": return this.samplePraksisstedavtaleViewDto();
            case "Array<PraksisstedavtaleViewDto>": return this.sampleArrayPraksisstedavtaleViewDto();
            case "PraksisstedavtalerDto": return this.samplePraksisstedavtalerDto({});
            case "Array<PraksisstedavtalerDto>": return this.sampleArrayPraksisstedavtalerDto({});
            case "PraksisstedbrukerDto": return this.samplePraksisstedbrukerDto({});
            case "Array<PraksisstedbrukerDto>": return this.sampleArrayPraksisstedbrukerDto({});
            case "PraksisstedbrukerSignatarDto": return this.samplePraksisstedbrukerSignatarDto({});
            case "Array<PraksisstedbrukerSignatarDto>": return this.sampleArrayPraksisstedbrukerSignatarDto({});
            case "PraksisstedbrukerprofilDto": return this.samplePraksisstedbrukerprofilDto({});
            case "Array<PraksisstedbrukerprofilDto>": return this.sampleArrayPraksisstedbrukerprofilDto({});
            case "PraksisstedbrukerprofilKanRedigereDto": return this.samplePraksisstedbrukerprofilKanRedigereDto();
            case "Array<PraksisstedbrukerprofilKanRedigereDto>": return this.sampleArrayPraksisstedbrukerprofilKanRedigereDto();
            case "PraksisstedbrukerprofilPutDto": return this.samplePraksisstedbrukerprofilPutDto({});
            case "Array<PraksisstedbrukerprofilPutDto>": return this.sampleArrayPraksisstedbrukerprofilPutDto({});
            case "PraksisstedbrukerprofilPutTilgangerInnerDto": return this.samplePraksisstedbrukerprofilPutTilgangerInnerDto({});
            case "Array<PraksisstedbrukerprofilPutTilgangerInnerDto>": return this.sampleArrayPraksisstedbrukerprofilPutTilgangerInnerDto({});
            case "PraksisstederForAktivitetskravDto": return this.samplePraksisstederForAktivitetskravDto({});
            case "Array<PraksisstederForAktivitetskravDto>": return this.sampleArrayPraksisstederForAktivitetskravDto({});
            case "PraksisstedprofilAdresseDto": return this.samplePraksisstedprofilAdresseDto({});
            case "Array<PraksisstedprofilAdresseDto>": return this.sampleArrayPraksisstedprofilAdresseDto({});
            case "PraksisstedprofilDto": return this.samplePraksisstedprofilDto({});
            case "Array<PraksisstedprofilDto>": return this.sampleArrayPraksisstedprofilDto({});
            case "PraksisstedprofilNoderDto": return this.samplePraksisstedprofilNoderDto({});
            case "Array<PraksisstedprofilNoderDto>": return this.sampleArrayPraksisstedprofilNoderDto({});
            case "PraksisstedprofilPutDto": return this.samplePraksisstedprofilPutDto({});
            case "Array<PraksisstedprofilPutDto>": return this.sampleArrayPraksisstedprofilPutDto({});
            case "PraksisstedtypeDto": return this.samplePraksisstedtypeDto({});
            case "Array<PraksisstedtypeDto>": return this.sampleArrayPraksisstedtypeDto({});
            case "PraksistypeDto": return this.samplePraksistypeDto({});
            case "Array<PraksistypeDto>": return this.sampleArrayPraksistypeDto({});
            case "PraksistypeMedAktivitetskravDto": return this.samplePraksistypeMedAktivitetskravDto({});
            case "Array<PraksistypeMedAktivitetskravDto>": return this.sampleArrayPraksistypeMedAktivitetskravDto({});
            case "PraksistypeMedEmnerDto": return this.samplePraksistypeMedEmnerDto({});
            case "Array<PraksistypeMedEmnerDto>": return this.sampleArrayPraksistypeMedEmnerDto({});
            case "RegistreringsStatusDto": return this.sampleRegistreringsStatusDto();
            case "Array<RegistreringsStatusDto>": return this.sampleArrayRegistreringsStatusDto();
            case "RolleDto": return this.sampleRolleDto({});
            case "Array<RolleDto>": return this.sampleArrayRolleDto({});
            case "RolleTypeDto": return this.sampleRolleTypeDto({});
            case "Array<RolleTypeDto>": return this.sampleArrayRolleTypeDto({});
            case "SaksansvarligDto": return this.sampleSaksansvarligDto({});
            case "Array<SaksansvarligDto>": return this.sampleArraySaksansvarligDto({});
            case "StudentVurderingDto": return this.sampleStudentVurderingDto({});
            case "Array<StudentVurderingDto>": return this.sampleArrayStudentVurderingDto({});
            case "StudentbrukerDto": return this.sampleStudentbrukerDto({});
            case "Array<StudentbrukerDto>": return this.sampleArrayStudentbrukerDto({});
            case "StudentbrukerprofilDto": return this.sampleStudentbrukerprofilDto({});
            case "Array<StudentbrukerprofilDto>": return this.sampleArrayStudentbrukerprofilDto({});
            case "StudenterForVurderingDto": return this.sampleStudenterForVurderingDto({});
            case "Array<StudenterForVurderingDto>": return this.sampleArrayStudenterForVurderingDto({});
            case "StudenterMedKlasseDto": return this.sampleStudenterMedKlasseDto({});
            case "Array<StudenterMedKlasseDto>": return this.sampleArrayStudenterMedKlasseDto({});
            case "StudentfordelingDto": return this.sampleStudentfordelingDto({});
            case "Array<StudentfordelingDto>": return this.sampleArrayStudentfordelingDto({});
            case "StudentfordelingMedValgDto": return this.sampleStudentfordelingMedValgDto({});
            case "Array<StudentfordelingMedValgDto>": return this.sampleArrayStudentfordelingMedValgDto({});
            case "StudentfordelingPutDto": return this.sampleStudentfordelingPutDto({});
            case "Array<StudentfordelingPutDto>": return this.sampleArrayStudentfordelingPutDto({});
            case "StudentregistreringDto": return this.sampleStudentregistreringDto({});
            case "Array<StudentregistreringDto>": return this.sampleArrayStudentregistreringDto({});
            case "StudentregistreringPutDto": return this.sampleStudentregistreringPutDto({});
            case "Array<StudentregistreringPutDto>": return this.sampleArrayStudentregistreringPutDto({});
            case "StudentregistreringPutWrappedDto": return this.sampleStudentregistreringPutWrappedDto({});
            case "Array<StudentregistreringPutWrappedDto>": return this.sampleArrayStudentregistreringPutWrappedDto({});
            case "StudiestedDto": return this.sampleStudiestedDto({});
            case "Array<StudiestedDto>": return this.sampleArrayStudiestedDto({});
            case "StudiestedRollerDto": return this.sampleStudiestedRollerDto();
            case "Array<StudiestedRollerDto>": return this.sampleArrayStudiestedRollerDto();
            case "StudiestedTilgangerDto": return this.sampleStudiestedTilgangerDto({});
            case "Array<StudiestedTilgangerDto>": return this.sampleArrayStudiestedTilgangerDto({});
            case "StudiestedbrukerDto": return this.sampleStudiestedbrukerDto({});
            case "Array<StudiestedbrukerDto>": return this.sampleArrayStudiestedbrukerDto({});
            case "StudiestedbrukerSignatarDto": return this.sampleStudiestedbrukerSignatarDto({});
            case "Array<StudiestedbrukerSignatarDto>": return this.sampleArrayStudiestedbrukerSignatarDto({});
            case "StudiestedbrukerprofilDto": return this.sampleStudiestedbrukerprofilDto({});
            case "Array<StudiestedbrukerprofilDto>": return this.sampleArrayStudiestedbrukerprofilDto({});
            case "StudiestedbrukerprofilPutDto": return this.sampleStudiestedbrukerprofilPutDto({});
            case "Array<StudiestedbrukerprofilPutDto>": return this.sampleArrayStudiestedbrukerprofilPutDto({});
            case "StudiestedbrukerprofilPutTilgangerInnerDto": return this.sampleStudiestedbrukerprofilPutTilgangerInnerDto({});
            case "Array<StudiestedbrukerprofilPutTilgangerInnerDto>": return this.sampleArrayStudiestedbrukerprofilPutTilgangerInnerDto({});
            case "UndervisningsenhetPeriodeDto": return this.sampleUndervisningsenhetPeriodeDto({});
            case "Array<UndervisningsenhetPeriodeDto>": return this.sampleArrayUndervisningsenhetPeriodeDto({});
            case "UndervisningsenhetToPraksisklasseMedAktiviteterDto": return this.sampleUndervisningsenhetToPraksisklasseMedAktiviteterDto({});
            case "Array<UndervisningsenhetToPraksisklasseMedAktiviteterDto>": return this.sampleArrayUndervisningsenhetToPraksisklasseMedAktiviteterDto({});
            case "VurderingKommentarerDto": return this.sampleVurderingKommentarerDto({});
            case "Array<VurderingKommentarerDto>": return this.sampleArrayVurderingKommentarerDto({});
            case "VurderingOppsummeringDto": return this.sampleVurderingOppsummeringDto({});
            case "Array<VurderingOppsummeringDto>": return this.sampleArrayVurderingOppsummeringDto({});
            case "VurderingStudentDto": return this.sampleVurderingStudentDto({});
            case "Array<VurderingStudentDto>": return this.sampleArrayVurderingStudentDto({});
            case "VurderingsinnstillingerDto": return this.sampleVurderingsinnstillingerDto({});
            case "Array<VurderingsinnstillingerDto>": return this.sampleArrayVurderingsinnstillingerDto({});
            case "VurderingskriterieDto": return this.sampleVurderingskriterieDto({});
            case "Array<VurderingskriterieDto>": return this.sampleArrayVurderingskriterieDto({});
            case "VurderingsrollerDto": return this.sampleVurderingsrollerDto({});
            case "Array<VurderingsrollerDto>": return this.sampleArrayVurderingsrollerDto({});
            case "VurderingstyperDto": return this.sampleVurderingstyperDto({});
            case "Array<VurderingstyperDto>": return this.sampleArrayVurderingstyperDto({});
            default: throw new Error("Unknown type "+ modelName);
        }
    }
    sampleAbstractSignatarDto(template?: Factory<AbstractSignatarDto>): AbstractSignatarDto {
        if (typeof this.sampleModelProperties["AbstractSignatarDto"] === "function") {
            return this.sampleModelProperties["AbstractSignatarDto"](this);
        }

        return {
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("AbstractSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("AbstractSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("AbstractSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("AbstractSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayAbstractSignatarDto(template?: Factory<AbstractSignatarDto>, length?: number): Array<AbstractSignatarDto> {
        return Array.from({length: length || this.arrayLength("AbstractSignatarDto")}).map(() => this.sampleAbstractSignatarDto(template));
    }
    sampleAktivitetskravDto(template?: Factory<AktivitetskravDto>): AktivitetskravDto {
        if (typeof this.sampleModelProperties["AktivitetskravDto"] === "function") {
            return this.sampleModelProperties["AktivitetskravDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("AktivitetskravDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("AktivitetskravDto", "navn", "string", "Kommunal helsetjeneste", false),
            sistEndret: template && template.sistEndret ? (typeof template.sistEndret === "function" ? (template.sistEndret as Function)(this) : template.sistEndret): this.generate("AktivitetskravDto", "sistEndret", "number", "1580143106014", false),
            antallSteder: template && template.antallSteder ? (typeof template.antallSteder === "function" ? (template.antallSteder as Function)(this) : template.antallSteder): this.generate("AktivitetskravDto", "antallSteder", "number", "20", false),
        };
    }
    sampleArrayAktivitetskravDto(template?: Factory<AktivitetskravDto>, length?: number): Array<AktivitetskravDto> {
        return Array.from({length: length || this.arrayLength("AktivitetskravDto")}).map(() => this.sampleAktivitetskravDto(template));
    }
    sampleAlpKommuneDto(template?: Factory<AlpKommuneDto>): AlpKommuneDto {
        if (typeof this.sampleModelProperties["AlpKommuneDto"] === "function") {
            return this.sampleModelProperties["AlpKommuneDto"](this);
        }

        return {
            fylkesnr: template && template.fylkesnr ? (typeof template.fylkesnr === "function" ? (template.fylkesnr as Function)(this) : template.fylkesnr): this.generate("AlpKommuneDto", "fylkesnr", "number", "0", false),
            kommunenavn: template && template.kommunenavn ? (typeof template.kommunenavn === "function" ? (template.kommunenavn as Function)(this) : template.kommunenavn): this.generate("AlpKommuneDto", "kommunenavn", "string", "Drammen", false),
            kommunenr: template && template.kommunenr ? (typeof template.kommunenr === "function" ? (template.kommunenr as Function)(this) : template.kommunenr): this.generate("AlpKommuneDto", "kommunenr", "number", "0", false),
        };
    }
    sampleArrayAlpKommuneDto(template?: Factory<AlpKommuneDto>, length?: number): Array<AlpKommuneDto> {
        return Array.from({length: length || this.arrayLength("AlpKommuneDto")}).map(() => this.sampleAlpKommuneDto(template));
    }
    sampleAlpLandDto(template?: Factory<AlpLandDto>): AlpLandDto {
        if (typeof this.sampleModelProperties["AlpLandDto"] === "function") {
            return this.sampleModelProperties["AlpLandDto"](this);
        }

        return {
            landnr: template && template.landnr ? (typeof template.landnr === "function" ? (template.landnr as Function)(this) : template.landnr): this.generate("AlpLandDto", "landnr", "number", "0", false),
            landnavnNorsk: template && template.landnavnNorsk ? (typeof template.landnavnNorsk === "function" ? (template.landnavnNorsk as Function)(this) : template.landnavnNorsk): this.generate("AlpLandDto", "landnavnNorsk", "string", "Norge", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("AlpLandDto", "telefonlandnr", "string", "47", false),
        };
    }
    sampleArrayAlpLandDto(template?: Factory<AlpLandDto>, length?: number): Array<AlpLandDto> {
        return Array.from({length: length || this.arrayLength("AlpLandDto")}).map(() => this.sampleAlpLandDto(template));
    }
    sampleAlpPraksisstedGetDto(template?: Factory<AlpPraksisstedGetDto>): AlpPraksisstedGetDto {
        if (typeof this.sampleModelProperties["AlpPraksisstedGetDto"] === "function") {
            return this.sampleModelProperties["AlpPraksisstedGetDto"](this);
        }

        return {
            praksissteder: template && template.praksissteder ? (typeof template.praksissteder === "function" ? (template.praksissteder as Function)(this) : template.praksissteder): this.generate("AlpPraksisstedGetDto", "praksissteder", "Array<AlpPraksisstedMedNivaaDto>", "null", false),
            land: template && template.land ? (typeof template.land === "function" ? (template.land as Function)(this) : template.land): this.generate("AlpPraksisstedGetDto", "land", "Array<AlpLandDto>", "null", false),
            kommuner: template && template.kommuner ? (typeof template.kommuner === "function" ? (template.kommuner as Function)(this) : template.kommuner): this.generate("AlpPraksisstedGetDto", "kommuner", "Array<AlpKommuneDto>", "null", false),
        };
    }
    sampleArrayAlpPraksisstedGetDto(template?: Factory<AlpPraksisstedGetDto>, length?: number): Array<AlpPraksisstedGetDto> {
        return Array.from({length: length || this.arrayLength("AlpPraksisstedGetDto")}).map(() => this.sampleAlpPraksisstedGetDto(template));
    }
    sampleAlpPraksisstedMedNivaaDto(template?: Factory<AlpPraksisstedMedNivaaDto>): AlpPraksisstedMedNivaaDto {
        if (typeof this.sampleModelProperties["AlpPraksisstedMedNivaaDto"] === "function") {
            return this.sampleModelProperties["AlpPraksisstedMedNivaaDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("AlpPraksisstedMedNivaaDto", "id", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            praksisstedkode: template && template.praksisstedkode ? (typeof template.praksisstedkode === "function" ? (template.praksisstedkode as Function)(this) : template.praksisstedkode): this.generate("AlpPraksisstedMedNivaaDto", "praksisstedkode", "string", "LDS-HELE-0000", false),
            praksisstednavnBokmal: template && template.praksisstednavnBokmal ? (typeof template.praksisstednavnBokmal === "function" ? (template.praksisstednavnBokmal as Function)(this) : template.praksisstednavnBokmal): this.generate("AlpPraksisstedMedNivaaDto", "praksisstednavnBokmal", "string", "Lovisenberg sykehus", false),
            level: template && template.level ? (typeof template.level === "function" ? (template.level as Function)(this) : template.level): this.generate("AlpPraksisstedMedNivaaDto", "level", "number", "1", false),
        };
    }
    sampleArrayAlpPraksisstedMedNivaaDto(template?: Factory<AlpPraksisstedMedNivaaDto>, length?: number): Array<AlpPraksisstedMedNivaaDto> {
        return Array.from({length: length || this.arrayLength("AlpPraksisstedMedNivaaDto")}).map(() => this.sampleAlpPraksisstedMedNivaaDto(template));
    }
    sampleAlpPraksisstedPostDto(template?: Factory<AlpPraksisstedPostDto>): AlpPraksisstedPostDto {
        if (typeof this.sampleModelProperties["AlpPraksisstedPostDto"] === "function") {
            return this.sampleModelProperties["AlpPraksisstedPostDto"](this);
        }

        return {
            praksisstedkodeEier: template && template.praksisstedkodeEier ? (typeof template.praksisstedkodeEier === "function" ? (template.praksisstedkodeEier as Function)(this) : template.praksisstedkodeEier): this.generate("AlpPraksisstedPostDto", "praksisstedkodeEier", "string", "LDS-HELE-0000", false),
            praksisstednavnBokmal: template && template.praksisstednavnBokmal ? (typeof template.praksisstednavnBokmal === "function" ? (template.praksisstednavnBokmal as Function)(this) : template.praksisstednavnBokmal): this.generate("AlpPraksisstedPostDto", "praksisstednavnBokmal", "string", "Lovisenberg sykehus", false),
            praksisstednavnNynorsk: template && template.praksisstednavnNynorsk ? (typeof template.praksisstednavnNynorsk === "function" ? (template.praksisstednavnNynorsk as Function)(this) : template.praksisstednavnNynorsk): this.generate("AlpPraksisstedPostDto", "praksisstednavnNynorsk", "string", "Lovisenberg sykehus", false),
            praksisstednavnEngelsk: template && template.praksisstednavnEngelsk ? (typeof template.praksisstednavnEngelsk === "function" ? (template.praksisstednavnEngelsk as Function)(this) : template.praksisstednavnEngelsk): this.generate("AlpPraksisstedPostDto", "praksisstednavnEngelsk", "string", "Lovisenberg sykehus", false),
            praksisstedtyper: template && template.praksisstedtyper ? (typeof template.praksisstedtyper === "function" ? (template.praksisstedtyper as Function)(this) : template.praksisstedtyper): this.generate("AlpPraksisstedPostDto", "praksisstedtyper", "Array<PraksisstedtypeDto>", "null", false),
            adrlin1: template && template.adrlin1 ? (typeof template.adrlin1 === "function" ? (template.adrlin1 as Function)(this) : template.adrlin1): this.generate("AlpPraksisstedPostDto", "adrlin1", "string", "", false),
            adrlin2: template && template.adrlin2 ? (typeof template.adrlin2 === "function" ? (template.adrlin2 as Function)(this) : template.adrlin2): this.generate("AlpPraksisstedPostDto", "adrlin2", "string", "Testgata 7", false),
            adrlin3: template && template.adrlin3 ? (typeof template.adrlin3 === "function" ? (template.adrlin3 as Function)(this) : template.adrlin3): this.generate("AlpPraksisstedPostDto", "adrlin3", "string", "0337 OSLO", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("AlpPraksisstedPostDto", "postnr", "string", "0337", false),
            adresseland: template && template.adresseland ? (typeof template.adresseland === "function" ? (template.adresseland as Function)(this) : template.adresseland): this.generate("AlpPraksisstedPostDto", "adresseland", "string", "", false),
            landnr: template && template.landnr ? (typeof template.landnr === "function" ? (template.landnr as Function)(this) : template.landnr): this.generate("AlpPraksisstedPostDto", "landnr", "number", "null", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("AlpPraksisstedPostDto", "telefonlandnr", "string", "47", false),
            telefonnr: template && template.telefonnr ? (typeof template.telefonnr === "function" ? (template.telefonnr as Function)(this) : template.telefonnr): this.generate("AlpPraksisstedPostDto", "telefonnr", "string", "12345678", false),
            emailadresse: template && template.emailadresse ? (typeof template.emailadresse === "function" ? (template.emailadresse as Function)(this) : template.emailadresse): this.generate("AlpPraksisstedPostDto", "emailadresse", "string", "email@post.no", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("AlpPraksisstedPostDto", "orgnr", "number", "123213421424", false),
            kommunenr: template && template.kommunenr ? (typeof template.kommunenr === "function" ? (template.kommunenr as Function)(this) : template.kommunenr): this.generate("AlpPraksisstedPostDto", "kommunenr", "number", "1", false),
            fylkesnr: template && template.fylkesnr ? (typeof template.fylkesnr === "function" ? (template.fylkesnr as Function)(this) : template.fylkesnr): this.generate("AlpPraksisstedPostDto", "fylkesnr", "number", "1", false),
            url: template && template.url ? (typeof template.url === "function" ? (template.url as Function)(this) : template.url): this.generate("AlpPraksisstedPostDto", "url", "string", "https://test.no", false),
            datoFra: template && template.datoFra ? (typeof template.datoFra === "function" ? (template.datoFra as Function)(this) : template.datoFra): this.generate("AlpPraksisstedPostDto", "datoFra", "number", "1580143106014", false),
        };
    }
    sampleArrayAlpPraksisstedPostDto(template?: Factory<AlpPraksisstedPostDto>, length?: number): Array<AlpPraksisstedPostDto> {
        return Array.from({length: length || this.arrayLength("AlpPraksisstedPostDto")}).map(() => this.sampleAlpPraksisstedPostDto(template));
    }
    sampleAlpPraksisstedtyperGetDto(template?: Factory<AlpPraksisstedtyperGetDto>): AlpPraksisstedtyperGetDto {
        if (typeof this.sampleModelProperties["AlpPraksisstedtyperGetDto"] === "function") {
            return this.sampleModelProperties["AlpPraksisstedtyperGetDto"](this);
        }

        return {
            praksisstedertype: template && template.praksisstedertype ? (typeof template.praksisstedertype === "function" ? (template.praksisstedertype as Function)(this) : template.praksisstedertype): this.generate("AlpPraksisstedtyperGetDto", "praksisstedertype", "Array<PraksisstedtypeDto>", "null", false),
        };
    }
    sampleArrayAlpPraksisstedtyperGetDto(template?: Factory<AlpPraksisstedtyperGetDto>, length?: number): Array<AlpPraksisstedtyperGetDto> {
        return Array.from({length: length || this.arrayLength("AlpPraksisstedtyperGetDto")}).map(() => this.sampleAlpPraksisstedtyperGetDto(template));
    }
    sampleAvtalerDto(template?: Factory<AvtalerDto>): AvtalerDto {
        if (typeof this.sampleModelProperties["AvtalerDto"] === "function") {
            return this.sampleModelProperties["AvtalerDto"](this);
        }

        return {
            muligestudiesteder: template && template.muligestudiesteder ? (typeof template.muligestudiesteder === "function" ? (template.muligestudiesteder as Function)(this) : template.muligestudiesteder): this.generate("AvtalerDto", "muligestudiesteder", "Array<MuligeStudiestedDto>", "null", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("AvtalerDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
        };
    }
    sampleArrayAvtalerDto(template?: Factory<AvtalerDto>, length?: number): Array<AvtalerDto> {
        return Array.from({length: length || this.arrayLength("AvtalerDto")}).map(() => this.sampleAvtalerDto(template));
    }
    sampleAvtalestatusDto(template?: EnumFactory<AvtalestatusDto>): AvtalestatusDto {
        if (typeof this.sampleModelProperties["AvtalestatusDto"] === "function") {
            return this.sampleModelProperties["AvtalestatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                AvtalestatusDto.IkkeAktiv,
                AvtalestatusDto.Aktiv,
                AvtalestatusDto.SendtTilSignering,
                AvtalestatusDto.InnhenterOpplysninger,
                AvtalestatusDto.Kansellert,
                AvtalestatusDto.Avsluttet,
                AvtalestatusDto.Utkast,
                AvtalestatusDto.Feil
        ]);
    }
    sampleArrayAvtalestatusDto(template?: EnumFactory<AvtalestatusDto>, length?: number): Array<AvtalestatusDto> {
        return Array.from({length: length || this.arrayLength("AvtalestatusDto")}).map(() => this.sampleAvtalestatusDto());
    }
    sampleAvtalestederMedMuligeOmfattedePraksisstedDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto>): AvtalestederMedMuligeOmfattedePraksisstedDto {
        if (typeof this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedDto"] === "function") {
            return this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("AvtalestederMedMuligeOmfattedePraksisstedDto", "avtalestedforelder", "MinimalPraksisstedDto", "null", false),
            omfattetPraksisstedsteder: template && template.omfattetPraksisstedsteder ? (typeof template.omfattetPraksisstedsteder === "function" ? (template.omfattetPraksisstedsteder as Function)(this) : template.omfattetPraksisstedsteder): this.generate("AvtalestederMedMuligeOmfattedePraksisstedDto", "omfattetPraksisstedsteder", "Array<MinimalPraksisstedDto>", "null", false),
        };
    }
    sampleArrayAvtalestederMedMuligeOmfattedePraksisstedDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto>, length?: number): Array<AvtalestederMedMuligeOmfattedePraksisstedDto> {
        return Array.from({length: length || this.arrayLength("AvtalestederMedMuligeOmfattedePraksisstedDto")}).map(() => this.sampleAvtalestederMedMuligeOmfattedePraksisstedDto(template));
    }
    sampleAvtalestederMedMuligeOmfattedePraksisstedPostDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedPostDto>): AvtalestederMedMuligeOmfattedePraksisstedPostDto {
        if (typeof this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedPostDto"] === "function") {
            return this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedPostDto"](this);
        }

        return {
            avtalestedforelderId: template && template.avtalestedforelderId ? (typeof template.avtalestedforelderId === "function" ? (template.avtalestedforelderId as Function)(this) : template.avtalestedforelderId): this.generate("AvtalestederMedMuligeOmfattedePraksisstedPostDto", "avtalestedforelderId", "string", "21dc105c-6561-11eb-8644-9f865e679678", false),
            omfattetPraksisstedstedIder: template && template.omfattetPraksisstedstedIder ? (typeof template.omfattetPraksisstedstedIder === "function" ? (template.omfattetPraksisstedstedIder as Function)(this) : template.omfattetPraksisstedstedIder): this.generate("AvtalestederMedMuligeOmfattedePraksisstedPostDto", "omfattetPraksisstedstedIder", "Array<string>", "null", false),
        };
    }
    sampleArrayAvtalestederMedMuligeOmfattedePraksisstedPostDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedPostDto>, length?: number): Array<AvtalestederMedMuligeOmfattedePraksisstedPostDto> {
        return Array.from({length: length || this.arrayLength("AvtalestederMedMuligeOmfattedePraksisstedPostDto")}).map(() => this.sampleAvtalestederMedMuligeOmfattedePraksisstedPostDto(template));
    }
    sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>): AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto", "avtalestedforelder", "MinimalPraksisstedMedHierarkiDto", "null", false),
            omfattetPraksisstedsteder: template && template.omfattetPraksisstedsteder ? (typeof template.omfattetPraksisstedsteder === "function" ? (template.omfattetPraksisstedsteder as Function)(this) : template.omfattetPraksisstedsteder): this.generate("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto", "omfattetPraksisstedsteder", "Array<MinimalPraksisstedDto>", "null", false),
        };
    }
    sampleArrayAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>, length?: number): Array<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto")}).map(() => this.sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template));
    }
    sampleBrukerinfoDto(template?: Factory<BrukerinfoDto>): BrukerinfoDto {
        if (typeof this.sampleModelProperties["BrukerinfoDto"] === "function") {
            return this.sampleModelProperties["BrukerinfoDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerinfoDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerinfoDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerinfoDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerinfoDto", "epost", "string", "null", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("BrukerinfoDto", "telefonnummer", "string", "null", false),
            innstillinger: template && template.innstillinger ? (typeof template.innstillinger === "function" ? (template.innstillinger as Function)(this) : template.innstillinger): this.generate("BrukerinfoDto", "innstillinger", "BrukerinnstillingerDto", "null", false),
            toppNivaaAdmin: template && template.toppNivaaAdmin ? (typeof template.toppNivaaAdmin === "function" ? (template.toppNivaaAdmin as Function)(this) : template.toppNivaaAdmin): this.generate("BrukerinfoDto", "toppNivaaAdmin", "boolean", "null", false),
            hoeyesteRettighet: template && template.hoeyesteRettighet ? (typeof template.hoeyesteRettighet === "function" ? (template.hoeyesteRettighet as Function)(this) : template.hoeyesteRettighet): this.generate("BrukerinfoDto", "hoeyesteRettighet", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayBrukerinfoDto(template?: Factory<BrukerinfoDto>, length?: number): Array<BrukerinfoDto> {
        return Array.from({length: length || this.arrayLength("BrukerinfoDto")}).map(() => this.sampleBrukerinfoDto(template));
    }
    sampleBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>): BrukerinnstillingerDto {
        if (typeof this.sampleModelProperties["BrukerinnstillingerDto"] === "function") {
            return this.sampleModelProperties["BrukerinnstillingerDto"](this);
        }

        return {
            spraakvalg: template && template.spraakvalg ? (typeof template.spraakvalg === "function" ? (template.spraakvalg as Function)(this) : template.spraakvalg): this.generate("BrukerinnstillingerDto", "spraakvalg", "string", "no", false),
            harGodtattBetingelser: template && template.harGodtattBetingelser ? (typeof template.harGodtattBetingelser === "function" ? (template.harGodtattBetingelser as Function)(this) : template.harGodtattBetingelser): this.generate("BrukerinnstillingerDto", "harGodtattBetingelser", "boolean", "null", false),
        };
    }
    sampleArrayBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>, length?: number): Array<BrukerinnstillingerDto> {
        return Array.from({length: length || this.arrayLength("BrukerinnstillingerDto")}).map(() => this.sampleBrukerinnstillingerDto(template));
    }
    sampleBrukerrollerDto(template?: EnumFactory<BrukerrollerDto>): BrukerrollerDto {
        if (typeof this.sampleModelProperties["BrukerrollerDto"] === "function") {
            return this.sampleModelProperties["BrukerrollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerrollerDto.Administrator,
                BrukerrollerDto.Registrererettighet,
                BrukerrollerDto.Skriverettighet,
                BrukerrollerDto.Leserettighet
        ]);
    }
    sampleArrayBrukerrollerDto(template?: EnumFactory<BrukerrollerDto>, length?: number): Array<BrukerrollerDto> {
        return Array.from({length: length || this.arrayLength("BrukerrollerDto")}).map(() => this.sampleBrukerrollerDto());
    }
    sampleBrukerrollerPSDto(template?: EnumFactory<BrukerrollerPSDto>): BrukerrollerPSDto {
        if (typeof this.sampleModelProperties["BrukerrollerPSDto"] === "function") {
            return this.sampleModelProperties["BrukerrollerPSDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerrollerPSDto.Administrator,
                BrukerrollerPSDto.Skriverettighet,
                BrukerrollerPSDto.Leserettighet
        ]);
    }
    sampleArrayBrukerrollerPSDto(template?: EnumFactory<BrukerrollerPSDto>, length?: number): Array<BrukerrollerPSDto> {
        return Array.from({length: length || this.arrayLength("BrukerrollerPSDto")}).map(() => this.sampleBrukerrollerPSDto());
    }
    sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto>): EierAvtalestedMedMuligeOmfattedeStudiestedDto {
        if (typeof this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedDto"] === "function") {
            return this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedDto", "avtalestedforelder", "MinimalMinimalStudiestedDto", "null", false),
            omfattetStudiesteder: template && template.omfattetStudiesteder ? (typeof template.omfattetStudiesteder === "function" ? (template.omfattetStudiesteder as Function)(this) : template.omfattetStudiesteder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedDto", "omfattetStudiesteder", "Array<MinimalMinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto>, length?: number): Array<EierAvtalestedMedMuligeOmfattedeStudiestedDto> {
        return Array.from({length: length || this.arrayLength("EierAvtalestedMedMuligeOmfattedeStudiestedDto")}).map(() => this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto(template));
    }
    sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>): EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "avtalestedforelder", "MinimalStudiestedDto", "null", false),
            omfattetStudiesteder: template && template.omfattetStudiesteder ? (typeof template.omfattetStudiesteder === "function" ? (template.omfattetStudiesteder as Function)(this) : template.omfattetStudiesteder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "omfattetStudiesteder", "Array<MinimalMinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>, length?: number): Array<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto")}).map(() => this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template));
    }
    sampleEierAvtalestedMedMuligeOmfattedeStudiestedPostDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedPostDto>): EierAvtalestedMedMuligeOmfattedeStudiestedPostDto {
        if (typeof this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedPostDto"] === "function") {
            return this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedPostDto"](this);
        }

        return {
            avtalestedforelderId: template && template.avtalestedforelderId ? (typeof template.avtalestedforelderId === "function" ? (template.avtalestedforelderId as Function)(this) : template.avtalestedforelderId): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedPostDto", "avtalestedforelderId", "string", "21dc105c-6561-11eb-8644-9f865e679678", false),
            omfattetStudiestedIder: template && template.omfattetStudiestedIder ? (typeof template.omfattetStudiestedIder === "function" ? (template.omfattetStudiestedIder as Function)(this) : template.omfattetStudiestedIder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedPostDto", "omfattetStudiestedIder", "Array<string>", "null", false),
        };
    }
    sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedPostDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedPostDto>, length?: number): Array<EierAvtalestedMedMuligeOmfattedeStudiestedPostDto> {
        return Array.from({length: length || this.arrayLength("EierAvtalestedMedMuligeOmfattedeStudiestedPostDto")}).map(() => this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedPostDto(template));
    }
    sampleEksternSignatarDto(template?: Factory<EksternSignatarDto>): EksternSignatarDto {
        if (typeof this.sampleModelProperties["EksternSignatarDto"] === "function") {
            return this.sampleModelProperties["EksternSignatarDto"](this);
        }

        return {
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("EksternSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("EksternSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("EksternSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("EksternSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayEksternSignatarDto(template?: Factory<EksternSignatarDto>, length?: number): Array<EksternSignatarDto> {
        return Array.from({length: length || this.arrayLength("EksternSignatarDto")}).map(() => this.sampleEksternSignatarDto(template));
    }
    sampleEmneDto(template?: Factory<EmneDto>): EmneDto {
        if (typeof this.sampleModelProperties["EmneDto"] === "function") {
            return this.sampleModelProperties["EmneDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("EmneDto", "kode", "string", "SYBAPRA1", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("EmneDto", "navn", "string", "Praksisstudier i sykepleie", false),
        };
    }
    sampleArrayEmneDto(template?: Factory<EmneDto>, length?: number): Array<EmneDto> {
        return Array.from({length: length || this.arrayLength("EmneDto")}).map(() => this.sampleEmneDto(template));
    }
    sampleEnhetsregEnhetAdresseDto(template?: Factory<EnhetsregEnhetAdresseDto>): EnhetsregEnhetAdresseDto {
        if (typeof this.sampleModelProperties["EnhetsregEnhetAdresseDto"] === "function") {
            return this.sampleModelProperties["EnhetsregEnhetAdresseDto"](this);
        }

        return {
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("EnhetsregEnhetAdresseDto", "adresse", "string", "Portveien 2", false),
            postnummer: template && template.postnummer ? (typeof template.postnummer === "function" ? (template.postnummer as Function)(this) : template.postnummer): this.generate("EnhetsregEnhetAdresseDto", "postnummer", "string", "7014", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("EnhetsregEnhetAdresseDto", "poststed", "string", "Trondheim", false),
            kommune: template && template.kommune ? (typeof template.kommune === "function" ? (template.kommune as Function)(this) : template.kommune): this.generate("EnhetsregEnhetAdresseDto", "kommune", "string", "Trondheim", false),
            land: template && template.land ? (typeof template.land === "function" ? (template.land as Function)(this) : template.land): this.generate("EnhetsregEnhetAdresseDto", "land", "string", "Norge", false),
        };
    }
    sampleArrayEnhetsregEnhetAdresseDto(template?: Factory<EnhetsregEnhetAdresseDto>, length?: number): Array<EnhetsregEnhetAdresseDto> {
        return Array.from({length: length || this.arrayLength("EnhetsregEnhetAdresseDto")}).map(() => this.sampleEnhetsregEnhetAdresseDto(template));
    }
    sampleEnhetsregEnhetDto(template?: Factory<EnhetsregEnhetDto>): EnhetsregEnhetDto {
        if (typeof this.sampleModelProperties["EnhetsregEnhetDto"] === "function") {
            return this.sampleModelProperties["EnhetsregEnhetDto"](this);
        }

        return {
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("EnhetsregEnhetDto", "navn", "string", "Huset med det rare i", false),
            forretningsadresse: template && template.forretningsadresse ? (typeof template.forretningsadresse === "function" ? (template.forretningsadresse as Function)(this) : template.forretningsadresse): this.generate("EnhetsregEnhetDto", "forretningsadresse", "EnhetsregEnhetAdresseDto", "null", false),
            hjemmeside: template && template.hjemmeside ? (typeof template.hjemmeside === "function" ? (template.hjemmeside as Function)(this) : template.hjemmeside): this.generate("EnhetsregEnhetDto", "hjemmeside", "string", "https://www.sikt.no/", false),
            maalform: template && template.maalform ? (typeof template.maalform === "function" ? (template.maalform as Function)(this) : template.maalform): this.generate("EnhetsregEnhetDto", "maalform", "string", "Bokmål", false),
        };
    }
    sampleArrayEnhetsregEnhetDto(template?: Factory<EnhetsregEnhetDto>, length?: number): Array<EnhetsregEnhetDto> {
        return Array.from({length: length || this.arrayLength("EnhetsregEnhetDto")}).map(() => this.sampleEnhetsregEnhetDto(template));
    }
    sampleFSAktivitetfeilDto(template?: Factory<FSAktivitetfeilDto>): FSAktivitetfeilDto {
        if (typeof this.sampleModelProperties["FSAktivitetfeilDto"] === "function") {
            return this.sampleModelProperties["FSAktivitetfeilDto"](this);
        }

        return {
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("FSAktivitetfeilDto", "praksisstedId", "string", "null", false),
            praksisstedkode: template && template.praksisstedkode ? (typeof template.praksisstedkode === "function" ? (template.praksisstedkode as Function)(this) : template.praksisstedkode): this.generate("FSAktivitetfeilDto", "praksisstedkode", "string", "1234", false),
            praksisstednavn: template && template.praksisstednavn ? (typeof template.praksisstednavn === "function" ? (template.praksisstednavn as Function)(this) : template.praksisstednavn): this.generate("FSAktivitetfeilDto", "praksisstednavn", "string", "Praksisstedet", false),
            feiltype: template && template.feiltype ? (typeof template.feiltype === "function" ? (template.feiltype as Function)(this) : template.feiltype): this.generate("FSAktivitetfeilDto", "feiltype", "FSFeiltypeDto", "null", false),
            feilmelding: template && template.feilmelding ? (typeof template.feilmelding === "function" ? (template.feilmelding as Function)(this) : template.feilmelding): this.generate("FSAktivitetfeilDto", "feilmelding", "FeilmeldingDto", "null", false),
        };
    }
    sampleArrayFSAktivitetfeilDto(template?: Factory<FSAktivitetfeilDto>, length?: number): Array<FSAktivitetfeilDto> {
        return Array.from({length: length || this.arrayLength("FSAktivitetfeilDto")}).map(() => this.sampleFSAktivitetfeilDto(template));
    }
    sampleFSAktivitetstatusDto(template?: Factory<FSAktivitetstatusDto>): FSAktivitetstatusDto {
        if (typeof this.sampleModelProperties["FSAktivitetstatusDto"] === "function") {
            return this.sampleModelProperties["FSAktivitetstatusDto"](this);
        }

        return {
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("FSAktivitetstatusDto", "status", "FSAktivitetstatustypeDto", "null", false),
            feil: template && template.feil ? (typeof template.feil === "function" ? (template.feil as Function)(this) : template.feil): this.generate("FSAktivitetstatusDto", "feil", "Array<FSAktivitetfeilDto>", "null", false),
            sistePubliseringTilFS: template && template.sistePubliseringTilFS ? (typeof template.sistePubliseringTilFS === "function" ? (template.sistePubliseringTilFS as Function)(this) : template.sistePubliseringTilFS): this.generate("FSAktivitetstatusDto", "sistePubliseringTilFS", "string", "2017-07-21T17:32:28Z", false),
        };
    }
    sampleArrayFSAktivitetstatusDto(template?: Factory<FSAktivitetstatusDto>, length?: number): Array<FSAktivitetstatusDto> {
        return Array.from({length: length || this.arrayLength("FSAktivitetstatusDto")}).map(() => this.sampleFSAktivitetstatusDto(template));
    }
    sampleFSAktivitetstatustypeDto(template?: EnumFactory<FSAktivitetstatustypeDto>): FSAktivitetstatustypeDto {
        if (typeof this.sampleModelProperties["FSAktivitetstatustypeDto"] === "function") {
            return this.sampleModelProperties["FSAktivitetstatustypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                FSAktivitetstatustypeDto.IngenFeil,
                FSAktivitetstatustypeDto.FeilVedPublisering,
                FSAktivitetstatustypeDto.UkjentFeil
        ]);
    }
    sampleArrayFSAktivitetstatustypeDto(template?: EnumFactory<FSAktivitetstatustypeDto>, length?: number): Array<FSAktivitetstatustypeDto> {
        return Array.from({length: length || this.arrayLength("FSAktivitetstatustypeDto")}).map(() => this.sampleFSAktivitetstatustypeDto());
    }
    sampleFSFeilDto(template?: Factory<FSFeilDto>): FSFeilDto {
        if (typeof this.sampleModelProperties["FSFeilDto"] === "function") {
            return this.sampleModelProperties["FSFeilDto"](this);
        }

        return {
            feiltype: template && template.feiltype ? (typeof template.feiltype === "function" ? (template.feiltype as Function)(this) : template.feiltype): this.generate("FSFeilDto", "feiltype", "FSFeiltypeDto", "null", false),
            feilmelding: template && template.feilmelding ? (typeof template.feilmelding === "function" ? (template.feilmelding as Function)(this) : template.feilmelding): this.generate("FSFeilDto", "feilmelding", "FeilmeldingDto", "null", false),
        };
    }
    sampleArrayFSFeilDto(template?: Factory<FSFeilDto>, length?: number): Array<FSFeilDto> {
        return Array.from({length: length || this.arrayLength("FSFeilDto")}).map(() => this.sampleFSFeilDto(template));
    }
    sampleFSFeillisteDto(template?: Factory<FSFeillisteDto>): FSFeillisteDto {
        if (typeof this.sampleModelProperties["FSFeillisteDto"] === "function") {
            return this.sampleModelProperties["FSFeillisteDto"](this);
        }

        return {
            feil: template && template.feil ? (typeof template.feil === "function" ? (template.feil as Function)(this) : template.feil): this.generate("FSFeillisteDto", "feil", "Array<FSFeilDto>", "null", false),
        };
    }
    sampleArrayFSFeillisteDto(template?: Factory<FSFeillisteDto>, length?: number): Array<FSFeillisteDto> {
        return Array.from({length: length || this.arrayLength("FSFeillisteDto")}).map(() => this.sampleFSFeillisteDto(template));
    }
    sampleFSFeiltypeDto(template?: EnumFactory<FSFeiltypeDto>): FSFeiltypeDto {
        if (typeof this.sampleModelProperties["FSFeiltypeDto"] === "function") {
            return this.sampleModelProperties["FSFeiltypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                FSFeiltypeDto.Aktivitetfeil,
                FSFeiltypeDto.UkjentFeil
        ]);
    }
    sampleArrayFSFeiltypeDto(template?: EnumFactory<FSFeiltypeDto>, length?: number): Array<FSFeiltypeDto> {
        return Array.from({length: length || this.arrayLength("FSFeiltypeDto")}).map(() => this.sampleFSFeiltypeDto());
    }
    sampleFSSyncStatusDto(template?: EnumFactory<FSSyncStatusDto>): FSSyncStatusDto {
        if (typeof this.sampleModelProperties["FSSyncStatusDto"] === "function") {
            return this.sampleModelProperties["FSSyncStatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                FSSyncStatusDto.Ok,
                FSSyncStatusDto.FeiletSisteDogn,
                FSSyncStatusDto.Feilet
        ]);
    }
    sampleArrayFSSyncStatusDto(template?: EnumFactory<FSSyncStatusDto>, length?: number): Array<FSSyncStatusDto> {
        return Array.from({length: length || this.arrayLength("FSSyncStatusDto")}).map(() => this.sampleFSSyncStatusDto());
    }
    sampleFSSyncStatusPerTypeDto(template?: Factory<FSSyncStatusPerTypeDto>): FSSyncStatusPerTypeDto {
        if (typeof this.sampleModelProperties["FSSyncStatusPerTypeDto"] === "function") {
            return this.sampleModelProperties["FSSyncStatusPerTypeDto"](this);
        }

        return {
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("FSSyncStatusPerTypeDto", "type", "FSSyncTypeDto", "null", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("FSSyncStatusPerTypeDto", "status", "FSSyncStatusDto", "null", false),
            sisteVellykket: template && template.sisteVellykket ? (typeof template.sisteVellykket === "function" ? (template.sisteVellykket as Function)(this) : template.sisteVellykket): this.generate("FSSyncStatusPerTypeDto", "sisteVellykket", "string", "2017-07-21T17:32:28Z", false),
            nesteKjoring: template && template.nesteKjoring ? (typeof template.nesteKjoring === "function" ? (template.nesteKjoring as Function)(this) : template.nesteKjoring): this.generate("FSSyncStatusPerTypeDto", "nesteKjoring", "string", "2017-07-21T17:32:28Z", false),
        };
    }
    sampleArrayFSSyncStatusPerTypeDto(template?: Factory<FSSyncStatusPerTypeDto>, length?: number): Array<FSSyncStatusPerTypeDto> {
        return Array.from({length: length || this.arrayLength("FSSyncStatusPerTypeDto")}).map(() => this.sampleFSSyncStatusPerTypeDto(template));
    }
    sampleFSSyncStatuserDto(template?: Factory<FSSyncStatuserDto>): FSSyncStatuserDto {
        if (typeof this.sampleModelProperties["FSSyncStatuserDto"] === "function") {
            return this.sampleModelProperties["FSSyncStatuserDto"](this);
        }

        return {
            syncStatus: template && template.syncStatus ? (typeof template.syncStatus === "function" ? (template.syncStatus as Function)(this) : template.syncStatus): this.generate("FSSyncStatuserDto", "syncStatus", "Array<FSSyncStatusPerTypeDto>", "null", false),
        };
    }
    sampleArrayFSSyncStatuserDto(template?: Factory<FSSyncStatuserDto>, length?: number): Array<FSSyncStatuserDto> {
        return Array.from({length: length || this.arrayLength("FSSyncStatuserDto")}).map(() => this.sampleFSSyncStatuserDto(template));
    }
    sampleFSSyncTypeDto(template?: EnumFactory<FSSyncTypeDto>): FSSyncTypeDto {
        if (typeof this.sampleModelProperties["FSSyncTypeDto"] === "function") {
            return this.sampleModelProperties["FSSyncTypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                FSSyncTypeDto.Institusjon,
                FSSyncTypeDto.Emne,
                FSSyncTypeDto.Praksisavtale,
                FSSyncTypeDto.Praksissted,
                FSSyncTypeDto.Praksistype,
                FSSyncTypeDto.Student,
                FSSyncTypeDto.Studiested,
                FSSyncTypeDto.Undervisningsenhet
        ]);
    }
    sampleArrayFSSyncTypeDto(template?: EnumFactory<FSSyncTypeDto>, length?: number): Array<FSSyncTypeDto> {
        return Array.from({length: length || this.arrayLength("FSSyncTypeDto")}).map(() => this.sampleFSSyncTypeDto());
    }
    sampleFeilmeldingDto(template?: Factory<FeilmeldingDto>): FeilmeldingDto {
        if (typeof this.sampleModelProperties["FeilmeldingDto"] === "function") {
            return this.sampleModelProperties["FeilmeldingDto"](this);
        }

        return {
            feilmeldingId: template && template.feilmeldingId ? (typeof template.feilmeldingId === "function" ? (template.feilmeldingId as Function)(this) : template.feilmeldingId): this.generate("FeilmeldingDto", "feilmeldingId", "string", "computed-hash-from-api", false),
            message: template && template.message ? (typeof template.message === "function" ? (template.message as Function)(this) : template.message): this.generate("FeilmeldingDto", "message", "string", "Feil ved henting av info fra FS", false),
        };
    }
    sampleArrayFeilmeldingDto(template?: Factory<FeilmeldingDto>, length?: number): Array<FeilmeldingDto> {
        return Array.from({length: length || this.arrayLength("FeilmeldingDto")}).map(() => this.sampleFeilmeldingDto(template));
    }
    sampleHalPraksisavtaleVedleggMinimalListDto(template?: Factory<HalPraksisavtaleVedleggMinimalListDto>): HalPraksisavtaleVedleggMinimalListDto {
        if (typeof this.sampleModelProperties["HalPraksisavtaleVedleggMinimalListDto"] === "function") {
            return this.sampleModelProperties["HalPraksisavtaleVedleggMinimalListDto"](this);
        }

        return {
            items: template && template.items ? (typeof template.items === "function" ? (template.items as Function)(this) : template.items): this.generate("HalPraksisavtaleVedleggMinimalListDto", "items", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
        };
    }
    sampleArrayHalPraksisavtaleVedleggMinimalListDto(template?: Factory<HalPraksisavtaleVedleggMinimalListDto>, length?: number): Array<HalPraksisavtaleVedleggMinimalListDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisavtaleVedleggMinimalListDto")}).map(() => this.sampleHalPraksisavtaleVedleggMinimalListDto(template));
    }
    sampleHalPraksisstedavtaleDto(template?: Factory<HalPraksisstedavtaleDto>): HalPraksisstedavtaleDto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtaleDto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtaleDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("HalPraksisstedavtaleDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("HalPraksisstedavtaleDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("HalPraksisstedavtaleDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("HalPraksisstedavtaleDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("HalPraksisstedavtaleDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("HalPraksisstedavtaleDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("HalPraksisstedavtaleDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("HalPraksisstedavtaleDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("HalPraksisstedavtaleDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("HalPraksisstedavtaleDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("HalPraksisstedavtaleDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("HalPraksisstedavtaleDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("HalPraksisstedavtaleDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("HalPraksisstedavtaleDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("HalPraksisstedavtaleDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("HalPraksisstedavtaleDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("HalPraksisstedavtaleDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("HalPraksisstedavtaleDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtaleDto(template?: Factory<HalPraksisstedavtaleDto>, length?: number): Array<HalPraksisstedavtaleDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtaleDto")}).map(() => this.sampleHalPraksisstedavtaleDto(template));
    }
    sampleHalPraksisstedavtaleOneOf1Dto(template?: Factory<HalPraksisstedavtaleOneOf1Dto>): HalPraksisstedavtaleOneOf1Dto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtaleOneOf1Dto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtaleOneOf1Dto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("HalPraksisstedavtaleOneOf1Dto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("HalPraksisstedavtaleOneOf1Dto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("HalPraksisstedavtaleOneOf1Dto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("HalPraksisstedavtaleOneOf1Dto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("HalPraksisstedavtaleOneOf1Dto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("HalPraksisstedavtaleOneOf1Dto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("HalPraksisstedavtaleOneOf1Dto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("HalPraksisstedavtaleOneOf1Dto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("HalPraksisstedavtaleOneOf1Dto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtaleOneOf1Dto(template?: Factory<HalPraksisstedavtaleOneOf1Dto>, length?: number): Array<HalPraksisstedavtaleOneOf1Dto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtaleOneOf1Dto")}).map(() => this.sampleHalPraksisstedavtaleOneOf1Dto(template));
    }
    sampleHalPraksisstedavtaleOneOfDto(template?: Factory<HalPraksisstedavtaleOneOfDto>): HalPraksisstedavtaleOneOfDto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtaleOneOfDto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtaleOneOfDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("HalPraksisstedavtaleOneOfDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("HalPraksisstedavtaleOneOfDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("HalPraksisstedavtaleOneOfDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("HalPraksisstedavtaleOneOfDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("HalPraksisstedavtaleOneOfDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("HalPraksisstedavtaleOneOfDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("HalPraksisstedavtaleOneOfDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("HalPraksisstedavtaleOneOfDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("HalPraksisstedavtaleOneOfDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("HalPraksisstedavtaleOneOfDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("HalPraksisstedavtaleOneOfDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("HalPraksisstedavtaleOneOfDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("HalPraksisstedavtaleOneOfDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtaleOneOfDto(template?: Factory<HalPraksisstedavtaleOneOfDto>, length?: number): Array<HalPraksisstedavtaleOneOfDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtaleOneOfDto")}).map(() => this.sampleHalPraksisstedavtaleOneOfDto(template));
    }
    sampleHalPraksisstedavtalerDto(template?: Factory<HalPraksisstedavtalerDto>): HalPraksisstedavtalerDto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtalerDto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtalerDto"](this);
        }

        return {
            avtaler: template && template.avtaler ? (typeof template.avtaler === "function" ? (template.avtaler as Function)(this) : template.avtaler): this.generate("HalPraksisstedavtalerDto", "avtaler", "Array<PraksisstedavtaleDto>", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtalerDto(template?: Factory<HalPraksisstedavtalerDto>, length?: number): Array<HalPraksisstedavtalerDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtalerDto")}).map(() => this.sampleHalPraksisstedavtalerDto(template));
    }
    sampleInviterStudiestedbrukerDto(template?: Factory<InviterStudiestedbrukerDto>): InviterStudiestedbrukerDto {
        if (typeof this.sampleModelProperties["InviterStudiestedbrukerDto"] === "function") {
            return this.sampleModelProperties["InviterStudiestedbrukerDto"](this);
        }

        return {
            muligeBrukere: template && template.muligeBrukere ? (typeof template.muligeBrukere === "function" ? (template.muligeBrukere as Function)(this) : template.muligeBrukere): this.generate("InviterStudiestedbrukerDto", "muligeBrukere", "Array<MuligeStudiestedbrukereDto>", "null", false),
            muligeSteder: template && template.muligeSteder ? (typeof template.muligeSteder === "function" ? (template.muligeSteder as Function)(this) : template.muligeSteder): this.generate("InviterStudiestedbrukerDto", "muligeSteder", "Array<MuligeStudiestedDto>", "null", false),
        };
    }
    sampleArrayInviterStudiestedbrukerDto(template?: Factory<InviterStudiestedbrukerDto>, length?: number): Array<InviterStudiestedbrukerDto> {
        return Array.from({length: length || this.arrayLength("InviterStudiestedbrukerDto")}).map(() => this.sampleInviterStudiestedbrukerDto(template));
    }
    sampleLaeringsutbytteDto(template?: Factory<LaeringsutbytteDto>): LaeringsutbytteDto {
        if (typeof this.sampleModelProperties["LaeringsutbytteDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbytteDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("LaeringsutbytteDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("LaeringsutbytteDto", "navn", "string", "Kunnskap", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("LaeringsutbytteDto", "beskrivelse", "string", "null", false),
            vurderingskriterier: template && template.vurderingskriterier ? (typeof template.vurderingskriterier === "function" ? (template.vurderingskriterier as Function)(this) : template.vurderingskriterier): this.generate("LaeringsutbytteDto", "vurderingskriterier", "Array<VurderingskriterieDto>", "null", false),
        };
    }
    sampleArrayLaeringsutbytteDto(template?: Factory<LaeringsutbytteDto>, length?: number): Array<LaeringsutbytteDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbytteDto")}).map(() => this.sampleLaeringsutbytteDto(template));
    }
    sampleLaeringsutbytteKommentarDto(template?: Factory<LaeringsutbytteKommentarDto>): LaeringsutbytteKommentarDto {
        if (typeof this.sampleModelProperties["LaeringsutbytteKommentarDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbytteKommentarDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("LaeringsutbytteKommentarDto", "id", "string", "b18c99a1-4fc5-40fe-9c8c-23b331543572", false),
            studentVurderingId: template && template.studentVurderingId ? (typeof template.studentVurderingId === "function" ? (template.studentVurderingId as Function)(this) : template.studentVurderingId): this.generate("LaeringsutbytteKommentarDto", "studentVurderingId", "string", "d0a66c40-941c-42e4-abe2-b31ab05379e3", false),
            laeringsutbytteId: template && template.laeringsutbytteId ? (typeof template.laeringsutbytteId === "function" ? (template.laeringsutbytteId as Function)(this) : template.laeringsutbytteId): this.generate("LaeringsutbytteKommentarDto", "laeringsutbytteId", "string", "9251b7fc-011d-11ed-a72e-03e4c1502862", false),
            tekst: template && template.tekst ? (typeof template.tekst === "function" ? (template.tekst as Function)(this) : template.tekst): this.generate("LaeringsutbytteKommentarDto", "tekst", "string", "Du er flink. MEN husk å fylle ut pasientlisten i etterkant av et møte, ellers er du finito friendo.", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("LaeringsutbytteKommentarDto", "delt", "boolean", "false", false),
            sistEndret: template && template.sistEndret ? (typeof template.sistEndret === "function" ? (template.sistEndret as Function)(this) : template.sistEndret): this.generate("LaeringsutbytteKommentarDto", "sistEndret", "string", "2017-07-21T17:32:28Z", false),
            kommentatorNavn: template && template.kommentatorNavn ? (typeof template.kommentatorNavn === "function" ? (template.kommentatorNavn as Function)(this) : template.kommentatorNavn): this.generate("LaeringsutbytteKommentarDto", "kommentatorNavn", "string", "Mysil Bergsprekken", false),
        };
    }
    sampleArrayLaeringsutbytteKommentarDto(template?: Factory<LaeringsutbytteKommentarDto>, length?: number): Array<LaeringsutbytteKommentarDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbytteKommentarDto")}).map(() => this.sampleLaeringsutbytteKommentarDto(template));
    }
    sampleLaeringsutbytteKommentarRedigerDto(template?: Factory<LaeringsutbytteKommentarRedigerDto>): LaeringsutbytteKommentarRedigerDto {
        if (typeof this.sampleModelProperties["LaeringsutbytteKommentarRedigerDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbytteKommentarRedigerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("LaeringsutbytteKommentarRedigerDto", "id", "string", "b18c99a1-4fc5-40fe-9c8c-23b331543572", false),
            laeringsutbytteId: template && template.laeringsutbytteId ? (typeof template.laeringsutbytteId === "function" ? (template.laeringsutbytteId as Function)(this) : template.laeringsutbytteId): this.generate("LaeringsutbytteKommentarRedigerDto", "laeringsutbytteId", "string", "9251b7fc-011d-11ed-a72e-03e4c1502862", false),
            tekst: template && template.tekst ? (typeof template.tekst === "function" ? (template.tekst as Function)(this) : template.tekst): this.generate("LaeringsutbytteKommentarRedigerDto", "tekst", "string", "Du er flink. MEN husk å fylle ut pasientlisten i etterkant av et møte, ellers er du finito friendo.", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("LaeringsutbytteKommentarRedigerDto", "delt", "boolean", "false", false),
        };
    }
    sampleArrayLaeringsutbytteKommentarRedigerDto(template?: Factory<LaeringsutbytteKommentarRedigerDto>, length?: number): Array<LaeringsutbytteKommentarRedigerDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbytteKommentarRedigerDto")}).map(() => this.sampleLaeringsutbytteKommentarRedigerDto(template));
    }
    sampleLaeringsutbytteKommenterDto(template?: Factory<LaeringsutbytteKommenterDto>): LaeringsutbytteKommenterDto {
        if (typeof this.sampleModelProperties["LaeringsutbytteKommenterDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbytteKommenterDto"](this);
        }

        return {
            studentVurderingId: template && template.studentVurderingId ? (typeof template.studentVurderingId === "function" ? (template.studentVurderingId as Function)(this) : template.studentVurderingId): this.generate("LaeringsutbytteKommenterDto", "studentVurderingId", "string", "d0a66c40-941c-42e4-abe2-b31ab05379e3", false),
            laeringsutbytteId: template && template.laeringsutbytteId ? (typeof template.laeringsutbytteId === "function" ? (template.laeringsutbytteId as Function)(this) : template.laeringsutbytteId): this.generate("LaeringsutbytteKommenterDto", "laeringsutbytteId", "string", "9251b7fc-011d-11ed-a72e-03e4c1502862", false),
            tekst: template && template.tekst ? (typeof template.tekst === "function" ? (template.tekst as Function)(this) : template.tekst): this.generate("LaeringsutbytteKommenterDto", "tekst", "string", "Du er flink. MEN husk å fylle ut pasientlisten i etterkant av et møte, ellers er du finito friendo.", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("LaeringsutbytteKommenterDto", "delt", "boolean", "false", false),
        };
    }
    sampleArrayLaeringsutbytteKommenterDto(template?: Factory<LaeringsutbytteKommenterDto>, length?: number): Array<LaeringsutbytteKommenterDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbytteKommenterDto")}).map(() => this.sampleLaeringsutbytteKommenterDto(template));
    }
    sampleLaeringsutbytteMedRollersKommentarDto(template?: Factory<LaeringsutbytteMedRollersKommentarDto>): LaeringsutbytteMedRollersKommentarDto {
        if (typeof this.sampleModelProperties["LaeringsutbytteMedRollersKommentarDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbytteMedRollersKommentarDto"](this);
        }

        return {
            laeringsutbytte: template && template.laeringsutbytte ? (typeof template.laeringsutbytte === "function" ? (template.laeringsutbytte as Function)(this) : template.laeringsutbytte): this.generate("LaeringsutbytteMedRollersKommentarDto", "laeringsutbytte", "LaeringsutbytteDto", "null", false),
            studentKommentar: template && template.studentKommentar ? (typeof template.studentKommentar === "function" ? (template.studentKommentar as Function)(this) : template.studentKommentar): this.generate("LaeringsutbytteMedRollersKommentarDto", "studentKommentar", "LaeringsutbytteKommentarDto", "null", false),
            underviserKommentar: template && template.underviserKommentar ? (typeof template.underviserKommentar === "function" ? (template.underviserKommentar as Function)(this) : template.underviserKommentar): this.generate("LaeringsutbytteMedRollersKommentarDto", "underviserKommentar", "LaeringsutbytteKommentarDto", "null", false),
            veilederKommentar: template && template.veilederKommentar ? (typeof template.veilederKommentar === "function" ? (template.veilederKommentar as Function)(this) : template.veilederKommentar): this.generate("LaeringsutbytteMedRollersKommentarDto", "veilederKommentar", "LaeringsutbytteKommentarDto", "null", false),
        };
    }
    sampleArrayLaeringsutbytteMedRollersKommentarDto(template?: Factory<LaeringsutbytteMedRollersKommentarDto>, length?: number): Array<LaeringsutbytteMedRollersKommentarDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbytteMedRollersKommentarDto")}).map(() => this.sampleLaeringsutbytteMedRollersKommentarDto(template));
    }
    sampleLaeringsutbyttegruppeDto(template?: Factory<LaeringsutbyttegruppeDto>): LaeringsutbyttegruppeDto {
        if (typeof this.sampleModelProperties["LaeringsutbyttegruppeDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbyttegruppeDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("LaeringsutbyttegruppeDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("LaeringsutbyttegruppeDto", "navn", "string", "Læringsutbyttegruppe", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("LaeringsutbyttegruppeDto", "beskrivelse", "string", "null", false),
            laeringsutbytter: template && template.laeringsutbytter ? (typeof template.laeringsutbytter === "function" ? (template.laeringsutbytter as Function)(this) : template.laeringsutbytter): this.generate("LaeringsutbyttegruppeDto", "laeringsutbytter", "Array<LaeringsutbytteDto>", "null", false),
            vurderingsmetode: template && template.vurderingsmetode ? (typeof template.vurderingsmetode === "function" ? (template.vurderingsmetode as Function)(this) : template.vurderingsmetode): this.generate("LaeringsutbyttegruppeDto", "vurderingsmetode", "LaeringsutbyttegruppeEnumDto", "null", false),
        };
    }
    sampleArrayLaeringsutbyttegruppeDto(template?: Factory<LaeringsutbyttegruppeDto>, length?: number): Array<LaeringsutbyttegruppeDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbyttegruppeDto")}).map(() => this.sampleLaeringsutbyttegruppeDto(template));
    }
    sampleLaeringsutbyttegruppeEnumDto(template?: EnumFactory<LaeringsutbyttegruppeEnumDto>): LaeringsutbyttegruppeEnumDto {
        if (typeof this.sampleModelProperties["LaeringsutbyttegruppeEnumDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbyttegruppeEnumDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                LaeringsutbyttegruppeEnumDto.Fritekst,
                LaeringsutbyttegruppeEnumDto.Karakterbasert
        ]);
    }
    sampleArrayLaeringsutbyttegruppeEnumDto(template?: EnumFactory<LaeringsutbyttegruppeEnumDto>, length?: number): Array<LaeringsutbyttegruppeEnumDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbyttegruppeEnumDto")}).map(() => this.sampleLaeringsutbyttegruppeEnumDto());
    }
    sampleLaeringsutbyttegruppeMinimalDto(template?: Factory<LaeringsutbyttegruppeMinimalDto>): LaeringsutbyttegruppeMinimalDto {
        if (typeof this.sampleModelProperties["LaeringsutbyttegruppeMinimalDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbyttegruppeMinimalDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("LaeringsutbyttegruppeMinimalDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("LaeringsutbyttegruppeMinimalDto", "navn", "string", "Læringsutbyttegruppe", false),
        };
    }
    sampleArrayLaeringsutbyttegruppeMinimalDto(template?: Factory<LaeringsutbyttegruppeMinimalDto>, length?: number): Array<LaeringsutbyttegruppeMinimalDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbyttegruppeMinimalDto")}).map(() => this.sampleLaeringsutbyttegruppeMinimalDto(template));
    }
    sampleLaeringsutbyttegruppeNyDto(template?: Factory<LaeringsutbyttegruppeNyDto>): LaeringsutbyttegruppeNyDto {
        if (typeof this.sampleModelProperties["LaeringsutbyttegruppeNyDto"] === "function") {
            return this.sampleModelProperties["LaeringsutbyttegruppeNyDto"](this);
        }

        return {
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("LaeringsutbyttegruppeNyDto", "navn", "string", "Læringsutbyttegruppe", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("LaeringsutbyttegruppeNyDto", "beskrivelse", "string", "null", false),
            laeringsutbytter: template && template.laeringsutbytter ? (typeof template.laeringsutbytter === "function" ? (template.laeringsutbytter as Function)(this) : template.laeringsutbytter): this.generate("LaeringsutbyttegruppeNyDto", "laeringsutbytter", "Array<LaeringsutbytteDto>", "null", false),
            vurderingsmetode: template && template.vurderingsmetode ? (typeof template.vurderingsmetode === "function" ? (template.vurderingsmetode as Function)(this) : template.vurderingsmetode): this.generate("LaeringsutbyttegruppeNyDto", "vurderingsmetode", "LaeringsutbyttegruppeEnumDto", "null", false),
        };
    }
    sampleArrayLaeringsutbyttegruppeNyDto(template?: Factory<LaeringsutbyttegruppeNyDto>, length?: number): Array<LaeringsutbyttegruppeNyDto> {
        return Array.from({length: length || this.arrayLength("LaeringsutbyttegruppeNyDto")}).map(() => this.sampleLaeringsutbyttegruppeNyDto(template));
    }
    sampleMatchingPraksisstedDto(template?: Factory<MatchingPraksisstedDto>): MatchingPraksisstedDto {
        if (typeof this.sampleModelProperties["MatchingPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MatchingPraksisstedDto"](this);
        }

        return {
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MatchingPraksisstedDto", "navn", "string", "Praksissted", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("MatchingPraksisstedDto", "postnr", "string", "1550", false),
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("MatchingPraksisstedDto", "adresse", "string", "heihågate", false),
        };
    }
    sampleArrayMatchingPraksisstedDto(template?: Factory<MatchingPraksisstedDto>, length?: number): Array<MatchingPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MatchingPraksisstedDto")}).map(() => this.sampleMatchingPraksisstedDto(template));
    }
    sampleMinimalAktivitetInfoDto(template?: Factory<MinimalAktivitetInfoDto>): MinimalAktivitetInfoDto {
        if (typeof this.sampleModelProperties["MinimalAktivitetInfoDto"] === "function") {
            return this.sampleModelProperties["MinimalAktivitetInfoDto"](this);
        }

        return {
            aktivitetId: template && template.aktivitetId ? (typeof template.aktivitetId === "function" ? (template.aktivitetId as Function)(this) : template.aktivitetId): this.generate("MinimalAktivitetInfoDto", "aktivitetId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("MinimalAktivitetInfoDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("MinimalAktivitetInfoDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            emnekode: template && template.emnekode ? (typeof template.emnekode === "function" ? (template.emnekode as Function)(this) : template.emnekode): this.generate("MinimalAktivitetInfoDto", "emnekode", "string", "ACME", false),
            praksistypenavn: template && template.praksistypenavn ? (typeof template.praksistypenavn === "function" ? (template.praksistypenavn as Function)(this) : template.praksistypenavn): this.generate("MinimalAktivitetInfoDto", "praksistypenavn", "string", "Auditorisk Røyksignalisering", false),
            praksisklassenavn: template && template.praksisklassenavn ? (typeof template.praksisklassenavn === "function" ? (template.praksisklassenavn as Function)(this) : template.praksisklassenavn): this.generate("MinimalAktivitetInfoDto", "praksisklassenavn", "string", "Ω", false),
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("MinimalAktivitetInfoDto", "studenter", "number", "null", false),
            aktivitetVurderingStatus: template && template.aktivitetVurderingStatus ? (typeof template.aktivitetVurderingStatus === "function" ? (template.aktivitetVurderingStatus as Function)(this) : template.aktivitetVurderingStatus): this.pickOne([MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Gjennomfoert,MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Aktiv,MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Framtidig]),
        };
    }
    sampleArrayMinimalAktivitetInfoDto(template?: Factory<MinimalAktivitetInfoDto>, length?: number): Array<MinimalAktivitetInfoDto> {
        return Array.from({length: length || this.arrayLength("MinimalAktivitetInfoDto")}).map(() => this.sampleMinimalAktivitetInfoDto(template));
    }
    sampleMinimalAktiviteterDto(template?: Factory<MinimalAktiviteterDto>): MinimalAktiviteterDto {
        if (typeof this.sampleModelProperties["MinimalAktiviteterDto"] === "function") {
            return this.sampleModelProperties["MinimalAktiviteterDto"](this);
        }

        return {
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("MinimalAktiviteterDto", "aktiviteter", "Array<MinimalAktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayMinimalAktiviteterDto(template?: Factory<MinimalAktiviteterDto>, length?: number): Array<MinimalAktiviteterDto> {
        return Array.from({length: length || this.arrayLength("MinimalAktiviteterDto")}).map(() => this.sampleMinimalAktiviteterDto(template));
    }
    sampleMinimalMinimalStudiestedDto(template?: Factory<MinimalMinimalStudiestedDto>): MinimalMinimalStudiestedDto {
        if (typeof this.sampleModelProperties["MinimalMinimalStudiestedDto"] === "function") {
            return this.sampleModelProperties["MinimalMinimalStudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalMinimalStudiestedDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalMinimalStudiestedDto", "navn", "string", "UIO", false),
        };
    }
    sampleArrayMinimalMinimalStudiestedDto(template?: Factory<MinimalMinimalStudiestedDto>, length?: number): Array<MinimalMinimalStudiestedDto> {
        return Array.from({length: length || this.arrayLength("MinimalMinimalStudiestedDto")}).map(() => this.sampleMinimalMinimalStudiestedDto(template));
    }
    sampleMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>): MinimalPraksisstedDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedDto", "navn", "string", "Sykehus", false),
        };
    }
    sampleArrayMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>, length?: number): Array<MinimalPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedDto")}).map(() => this.sampleMinimalPraksisstedDto(template));
    }
    sampleMinimalPraksisstedMedHierarkiDto(template?: Factory<MinimalPraksisstedMedHierarkiDto>): MinimalPraksisstedMedHierarkiDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedMedHierarkiDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedMedHierarkiDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedMedHierarkiDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedMedHierarkiDto", "navn", "string", "Sykehus", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("MinimalPraksisstedMedHierarkiDto", "orgnr", "string", "456789129", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("MinimalPraksisstedMedHierarkiDto", "noder", "MinimalPraksisstedMedHierarkiNoderDto", "null", false),
        };
    }
    sampleArrayMinimalPraksisstedMedHierarkiDto(template?: Factory<MinimalPraksisstedMedHierarkiDto>, length?: number): Array<MinimalPraksisstedMedHierarkiDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedMedHierarkiDto")}).map(() => this.sampleMinimalPraksisstedMedHierarkiDto(template));
    }
    sampleMinimalPraksisstedMedHierarkiNoderDto(template?: Factory<MinimalPraksisstedMedHierarkiNoderDto>): MinimalPraksisstedMedHierarkiNoderDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedMedHierarkiNoderDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedMedHierarkiNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("MinimalPraksisstedMedHierarkiNoderDto", "over", "MinimalPraksisstedMedHierarkiDto", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("MinimalPraksisstedMedHierarkiNoderDto", "under", "Array<MinimalPraksisstedMedHierarkiDto>", "null", false),
        };
    }
    sampleArrayMinimalPraksisstedMedHierarkiNoderDto(template?: Factory<MinimalPraksisstedMedHierarkiNoderDto>, length?: number): Array<MinimalPraksisstedMedHierarkiNoderDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedMedHierarkiNoderDto")}).map(() => this.sampleMinimalPraksisstedMedHierarkiNoderDto(template));
    }
    sampleMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>): MinimalStudiestedDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalStudiestedDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalStudiestedDto", "navn", "string", "UIO", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("MinimalStudiestedDto", "noder", "MinimalStudiestedNoderDto", "null", false),
        };
    }
    sampleArrayMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>, length?: number): Array<MinimalStudiestedDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedDto")}).map(() => this.sampleMinimalStudiestedDto(template));
    }
    sampleMinimalStudiestedNoderDto(template?: Factory<MinimalStudiestedNoderDto>): MinimalStudiestedNoderDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedNoderDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("MinimalStudiestedNoderDto", "over", "Array<MinimalStudiestedDto>", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("MinimalStudiestedNoderDto", "under", "Array<MinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayMinimalStudiestedNoderDto(template?: Factory<MinimalStudiestedNoderDto>, length?: number): Array<MinimalStudiestedNoderDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedNoderDto")}).map(() => this.sampleMinimalStudiestedNoderDto(template));
    }
    sampleMuligePraksisstedDto(template?: Factory<MuligePraksisstedDto>): MuligePraksisstedDto {
        if (typeof this.sampleModelProperties["MuligePraksisstedDto"] === "function") {
            return this.sampleModelProperties["MuligePraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MuligePraksisstedDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MuligePraksisstedDto", "navn", "string", "Sykehus", false),
            dybde: template && template.dybde ? (typeof template.dybde === "function" ? (template.dybde as Function)(this) : template.dybde): this.generate("MuligePraksisstedDto", "dybde", "number", "1", false),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("MuligePraksisstedDto", "deaktivert", "boolean", "null", false),
        };
    }
    sampleArrayMuligePraksisstedDto(template?: Factory<MuligePraksisstedDto>, length?: number): Array<MuligePraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MuligePraksisstedDto")}).map(() => this.sampleMuligePraksisstedDto(template));
    }
    sampleMuligeStudiestedDto(template?: Factory<MuligeStudiestedDto>): MuligeStudiestedDto {
        if (typeof this.sampleModelProperties["MuligeStudiestedDto"] === "function") {
            return this.sampleModelProperties["MuligeStudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MuligeStudiestedDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MuligeStudiestedDto", "navn", "string", "Galtvort", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.pickOne([MuligeStudiestedDtoTypeDtoEnum.Institusjon,MuligeStudiestedDtoTypeDtoEnum.Fakultet,MuligeStudiestedDtoTypeDtoEnum.Institutt,MuligeStudiestedDtoTypeDtoEnum.Gruppe]),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("MuligeStudiestedDto", "deaktivert", "boolean", "true", false),
        };
    }
    sampleArrayMuligeStudiestedDto(template?: Factory<MuligeStudiestedDto>, length?: number): Array<MuligeStudiestedDto> {
        return Array.from({length: length || this.arrayLength("MuligeStudiestedDto")}).map(() => this.sampleMuligeStudiestedDto(template));
    }
    sampleMuligeStudiestedbrukereDto(template?: Factory<MuligeStudiestedbrukereDto>): MuligeStudiestedbrukereDto {
        if (typeof this.sampleModelProperties["MuligeStudiestedbrukereDto"] === "function") {
            return this.sampleModelProperties["MuligeStudiestedbrukereDto"](this);
        }

        return {
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MuligeStudiestedbrukereDto", "navn", "string", "Ola Nordmann", false),
            brukernavn: template && template.brukernavn ? (typeof template.brukernavn === "function" ? (template.brukernavn as Function)(this) : template.brukernavn): this.generate("MuligeStudiestedbrukereDto", "brukernavn", "string", "olanor", false),
            feideId: template && template.feideId ? (typeof template.feideId === "function" ? (template.feideId as Function)(this) : template.feideId): this.generate("MuligeStudiestedbrukereDto", "feideId", "string", "brukernavn@domene.no", false),
        };
    }
    sampleArrayMuligeStudiestedbrukereDto(template?: Factory<MuligeStudiestedbrukereDto>, length?: number): Array<MuligeStudiestedbrukereDto> {
        return Array.from({length: length || this.arrayLength("MuligeStudiestedbrukereDto")}).map(() => this.sampleMuligeStudiestedbrukereDto(template));
    }
    sampleMultiSignatarerDto(template?: Factory<MultiSignatarerDto>): MultiSignatarerDto {
        if (typeof this.sampleModelProperties["MultiSignatarerDto"] === "function") {
            return this.sampleModelProperties["MultiSignatarerDto"](this);
        }

        return {
            eksternbrukere: template && template.eksternbrukere ? (typeof template.eksternbrukere === "function" ? (template.eksternbrukere as Function)(this) : template.eksternbrukere): this.generate("MultiSignatarerDto", "eksternbrukere", "Array<EksternSignatarDto>", "null", false),
            studiestedbrukere: template && template.studiestedbrukere ? (typeof template.studiestedbrukere === "function" ? (template.studiestedbrukere as Function)(this) : template.studiestedbrukere): this.generate("MultiSignatarerDto", "studiestedbrukere", "Array<StudiestedbrukerSignatarDto>", "null", false),
            praksisstedbrukere: template && template.praksisstedbrukere ? (typeof template.praksisstedbrukere === "function" ? (template.praksisstedbrukere as Function)(this) : template.praksisstedbrukere): this.generate("MultiSignatarerDto", "praksisstedbrukere", "Array<PraksisstedbrukerSignatarDto>", "null", false),
        };
    }
    sampleArrayMultiSignatarerDto(template?: Factory<MultiSignatarerDto>, length?: number): Array<MultiSignatarerDto> {
        return Array.from({length: length || this.arrayLength("MultiSignatarerDto")}).map(() => this.sampleMultiSignatarerDto(template));
    }
    sampleNyPraksisaktivitetDto(template?: Factory<NyPraksisaktivitetDto>): NyPraksisaktivitetDto {
        if (typeof this.sampleModelProperties["NyPraksisaktivitetDto"] === "function") {
            return this.sampleModelProperties["NyPraksisaktivitetDto"](this);
        }

        return {
            klasseId: template && template.klasseId ? (typeof template.klasseId === "function" ? (template.klasseId as Function)(this) : template.klasseId): this.generate("NyPraksisaktivitetDto", "klasseId", "string", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("NyPraksisaktivitetDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("NyPraksisaktivitetDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            aktivitetskravId: template && template.aktivitetskravId ? (typeof template.aktivitetskravId === "function" ? (template.aktivitetskravId as Function)(this) : template.aktivitetskravId): this.generate("NyPraksisaktivitetDto", "aktivitetskravId", "string", "null", false),
        };
    }
    sampleArrayNyPraksisaktivitetDto(template?: Factory<NyPraksisaktivitetDto>, length?: number): Array<NyPraksisaktivitetDto> {
        return Array.from({length: length || this.arrayLength("NyPraksisaktivitetDto")}).map(() => this.sampleNyPraksisaktivitetDto(template));
    }
    sampleNyPraksisklasseDto(template?: Factory<NyPraksisklasseDto>): NyPraksisklasseDto {
        if (typeof this.sampleModelProperties["NyPraksisklasseDto"] === "function") {
            return this.sampleModelProperties["NyPraksisklasseDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("NyPraksisklasseDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
        };
    }
    sampleArrayNyPraksisklasseDto(template?: Factory<NyPraksisklasseDto>, length?: number): Array<NyPraksisklasseDto> {
        return Array.from({length: length || this.arrayLength("NyPraksisklasseDto")}).map(() => this.sampleNyPraksisklasseDto(template));
    }
    sampleNyPraksisstedbrukerInvitasjonDto(template?: Factory<NyPraksisstedbrukerInvitasjonDto>): NyPraksisstedbrukerInvitasjonDto {
        if (typeof this.sampleModelProperties["NyPraksisstedbrukerInvitasjonDto"] === "function") {
            return this.sampleModelProperties["NyPraksisstedbrukerInvitasjonDto"](this);
        }

        return {
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("NyPraksisstedbrukerInvitasjonDto", "epost", "string", "user@example.com", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("NyPraksisstedbrukerInvitasjonDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("NyPraksisstedbrukerInvitasjonDto", "etternavn", "string", "Nordmann", false),
            fnr: template && template.fnr ? (typeof template.fnr === "function" ? (template.fnr as Function)(this) : template.fnr): this.generate("NyPraksisstedbrukerInvitasjonDto", "fnr", "string", "1234567800000", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("NyPraksisstedbrukerInvitasjonDto", "praksisstedId", "string", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("NyPraksisstedbrukerInvitasjonDto", "brukerrolle", "BrukerrollerPSDto", "null", false),
        };
    }
    sampleArrayNyPraksisstedbrukerInvitasjonDto(template?: Factory<NyPraksisstedbrukerInvitasjonDto>, length?: number): Array<NyPraksisstedbrukerInvitasjonDto> {
        return Array.from({length: length || this.arrayLength("NyPraksisstedbrukerInvitasjonDto")}).map(() => this.sampleNyPraksisstedbrukerInvitasjonDto(template));
    }
    sampleNyPraksisstedbrukerRolleDto(template?: Factory<NyPraksisstedbrukerRolleDto>): NyPraksisstedbrukerRolleDto {
        if (typeof this.sampleModelProperties["NyPraksisstedbrukerRolleDto"] === "function") {
            return this.sampleModelProperties["NyPraksisstedbrukerRolleDto"](this);
        }

        return {
            praksisstedbrukerId: template && template.praksisstedbrukerId ? (typeof template.praksisstedbrukerId === "function" ? (template.praksisstedbrukerId as Function)(this) : template.praksisstedbrukerId): this.generate("NyPraksisstedbrukerRolleDto", "praksisstedbrukerId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("NyPraksisstedbrukerRolleDto", "type", "PraksisstedRollerDto", "null", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("NyPraksisstedbrukerRolleDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
        };
    }
    sampleArrayNyPraksisstedbrukerRolleDto(template?: Factory<NyPraksisstedbrukerRolleDto>, length?: number): Array<NyPraksisstedbrukerRolleDto> {
        return Array.from({length: length || this.arrayLength("NyPraksisstedbrukerRolleDto")}).map(() => this.sampleNyPraksisstedbrukerRolleDto(template));
    }
    sampleNyStudiestedbrukerInvitasjonDto(template?: Factory<NyStudiestedbrukerInvitasjonDto>): NyStudiestedbrukerInvitasjonDto {
        if (typeof this.sampleModelProperties["NyStudiestedbrukerInvitasjonDto"] === "function") {
            return this.sampleModelProperties["NyStudiestedbrukerInvitasjonDto"](this);
        }

        return {
            feideId: template && template.feideId ? (typeof template.feideId === "function" ? (template.feideId as Function)(this) : template.feideId): this.generate("NyStudiestedbrukerInvitasjonDto", "feideId", "string", "username@domene.no", false),
            fsBrukernavn: template && template.fsBrukernavn ? (typeof template.fsBrukernavn === "function" ? (template.fsBrukernavn as Function)(this) : template.fsBrukernavn): this.generate("NyStudiestedbrukerInvitasjonDto", "fsBrukernavn", "string", "username", false),
            studiestedId: template && template.studiestedId ? (typeof template.studiestedId === "function" ? (template.studiestedId as Function)(this) : template.studiestedId): this.generate("NyStudiestedbrukerInvitasjonDto", "studiestedId", "string", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("NyStudiestedbrukerInvitasjonDto", "brukerrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayNyStudiestedbrukerInvitasjonDto(template?: Factory<NyStudiestedbrukerInvitasjonDto>, length?: number): Array<NyStudiestedbrukerInvitasjonDto> {
        return Array.from({length: length || this.arrayLength("NyStudiestedbrukerInvitasjonDto")}).map(() => this.sampleNyStudiestedbrukerInvitasjonDto(template));
    }
    sampleNyStudiestedbrukerRolleDto(template?: Factory<NyStudiestedbrukerRolleDto>): NyStudiestedbrukerRolleDto {
        if (typeof this.sampleModelProperties["NyStudiestedbrukerRolleDto"] === "function") {
            return this.sampleModelProperties["NyStudiestedbrukerRolleDto"](this);
        }

        return {
            studiestedbrukerId: template && template.studiestedbrukerId ? (typeof template.studiestedbrukerId === "function" ? (template.studiestedbrukerId as Function)(this) : template.studiestedbrukerId): this.generate("NyStudiestedbrukerRolleDto", "studiestedbrukerId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("NyStudiestedbrukerRolleDto", "type", "StudiestedRollerDto", "null", false),
        };
    }
    sampleArrayNyStudiestedbrukerRolleDto(template?: Factory<NyStudiestedbrukerRolleDto>, length?: number): Array<NyStudiestedbrukerRolleDto> {
        return Array.from({length: length || this.arrayLength("NyStudiestedbrukerRolleDto")}).map(() => this.sampleNyStudiestedbrukerRolleDto(template));
    }
    sampleOverlappendePraksisstedavtalesokRequestDto(template?: Factory<OverlappendePraksisstedavtalesokRequestDto>): OverlappendePraksisstedavtalesokRequestDto {
        if (typeof this.sampleModelProperties["OverlappendePraksisstedavtalesokRequestDto"] === "function") {
            return this.sampleModelProperties["OverlappendePraksisstedavtalesokRequestDto"](this);
        }

        return {
            studiestedIdEierAvAvtale: template && template.studiestedIdEierAvAvtale ? (typeof template.studiestedIdEierAvAvtale === "function" ? (template.studiestedIdEierAvAvtale as Function)(this) : template.studiestedIdEierAvAvtale): this.generate("OverlappendePraksisstedavtalesokRequestDto", "studiestedIdEierAvAvtale", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            avtalestedIder: template && template.avtalestedIder ? (typeof template.avtalestedIder === "function" ? (template.avtalestedIder as Function)(this) : template.avtalestedIder): this.generate("OverlappendePraksisstedavtalesokRequestDto", "avtalestedIder", "Array<string>", "null", false),
            praksistypekoder: template && template.praksistypekoder ? (typeof template.praksistypekoder === "function" ? (template.praksistypekoder as Function)(this) : template.praksistypekoder): this.generate("OverlappendePraksisstedavtalesokRequestDto", "praksistypekoder", "Array<string>", "null", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("OverlappendePraksisstedavtalesokRequestDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("OverlappendePraksisstedavtalesokRequestDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
        };
    }
    sampleArrayOverlappendePraksisstedavtalesokRequestDto(template?: Factory<OverlappendePraksisstedavtalesokRequestDto>, length?: number): Array<OverlappendePraksisstedavtalesokRequestDto> {
        return Array.from({length: length || this.arrayLength("OverlappendePraksisstedavtalesokRequestDto")}).map(() => this.sampleOverlappendePraksisstedavtalesokRequestDto(template));
    }
    sampleOverlappendePraksisstedavtalesokResponseDto(template?: Factory<OverlappendePraksisstedavtalesokResponseDto>): OverlappendePraksisstedavtalesokResponseDto {
        if (typeof this.sampleModelProperties["OverlappendePraksisstedavtalesokResponseDto"] === "function") {
            return this.sampleModelProperties["OverlappendePraksisstedavtalesokResponseDto"](this);
        }

        return {
            overlappendeAvtaler: template && template.overlappendeAvtaler ? (typeof template.overlappendeAvtaler === "function" ? (template.overlappendeAvtaler as Function)(this) : template.overlappendeAvtaler): this.generate("OverlappendePraksisstedavtalesokResponseDto", "overlappendeAvtaler", "Array<PraksisstedavtaleDto>", "null", false),
        };
    }
    sampleArrayOverlappendePraksisstedavtalesokResponseDto(template?: Factory<OverlappendePraksisstedavtalesokResponseDto>, length?: number): Array<OverlappendePraksisstedavtalesokResponseDto> {
        return Array.from({length: length || this.arrayLength("OverlappendePraksisstedavtalesokResponseDto")}).map(() => this.sampleOverlappendePraksisstedavtalesokResponseDto(template));
    }
    samplePeriodeDto(template?: Factory<PeriodeDto>): PeriodeDto {
        if (typeof this.sampleModelProperties["PeriodeDto"] === "function") {
            return this.sampleModelProperties["PeriodeDto"](this);
        }

        return {
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PeriodeDto", "startDato", "string", "Tue Nov 16 00:00:00 UTC 2021", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PeriodeDto", "sluttDato", "string", "Tue Nov 16 00:00:00 UTC 2021", false),
        };
    }
    sampleArrayPeriodeDto(template?: Factory<PeriodeDto>, length?: number): Array<PeriodeDto> {
        return Array.from({length: length || this.arrayLength("PeriodeDto")}).map(() => this.samplePeriodeDto(template));
    }
    samplePersonDto(template?: Factory<PersonDto>): PersonDto {
        if (typeof this.sampleModelProperties["PersonDto"] === "function") {
            return this.sampleModelProperties["PersonDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PersonDto", "id", "string", "null", false),
            fsId: template && template.fsId ? (typeof template.fsId === "function" ? (template.fsId as Function)(this) : template.fsId): this.generate("PersonDto", "fsId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PersonDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PersonDto", "etternavn", "string", "Nordmann", false),
        };
    }
    sampleArrayPersonDto(template?: Factory<PersonDto>, length?: number): Array<PersonDto> {
        return Array.from({length: length || this.arrayLength("PersonDto")}).map(() => this.samplePersonDto(template));
    }
    samplePraksisDto(template?: Factory<PraksisDto>): PraksisDto {
        if (typeof this.sampleModelProperties["PraksisDto"] === "function") {
            return this.sampleModelProperties["PraksisDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("PraksisDto", "kode", "string", "SPLGRU", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisDto", "navn", "string", "Grunnleggende sykepleie", false),
        };
    }
    sampleArrayPraksisDto(template?: Factory<PraksisDto>, length?: number): Array<PraksisDto> {
        return Array.from({length: length || this.arrayLength("PraksisDto")}).map(() => this.samplePraksisDto(template));
    }
    samplePraksisaktivitetAvtalerDto(template?: Factory<PraksisaktivitetAvtalerDto>): PraksisaktivitetAvtalerDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetAvtalerDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetAvtalerDto"](this);
        }

        return {
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisaktivitetAvtalerDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisaktivitetAvtalerDto", "avtalenavn", "string", "Praksisavtale mellom UIO og Oslo kommune", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisaktivitetAvtalerDto", "praksissted", "PraksisavtaleStedDto", "null", false),
            bestillingsmodus: template && template.bestillingsmodus ? (typeof template.bestillingsmodus === "function" ? (template.bestillingsmodus as Function)(this) : template.bestillingsmodus): this.generate("PraksisaktivitetAvtalerDto", "bestillingsmodus", "PraksisavtaleStedBestillingspunktTypeDto", "null", false),
            periode: template && template.periode ? (typeof template.periode === "function" ? (template.periode as Function)(this) : template.periode): this.generate("PraksisaktivitetAvtalerDto", "periode", "string", "Periode: 2019-01-01 - Åpen", false),
        };
    }
    sampleArrayPraksisaktivitetAvtalerDto(template?: Factory<PraksisaktivitetAvtalerDto>, length?: number): Array<PraksisaktivitetAvtalerDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetAvtalerDto")}).map(() => this.samplePraksisaktivitetAvtalerDto(template));
    }
    samplePraksisaktivitetBestillingPutDto(template?: Factory<PraksisaktivitetBestillingPutDto>): PraksisaktivitetBestillingPutDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetBestillingPutDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetBestillingPutDto"](this);
        }

        return {
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("PraksisaktivitetBestillingPutDto", "delt", "boolean", "false", false),
            bestillinger: template && template.bestillinger ? (typeof template.bestillinger === "function" ? (template.bestillinger as Function)(this) : template.bestillinger): this.generate("PraksisaktivitetBestillingPutDto", "bestillinger", "Array<PraksisaktivitetPutBestillingDto>", "null", false),
            kapasiteter: template && template.kapasiteter ? (typeof template.kapasiteter === "function" ? (template.kapasiteter as Function)(this) : template.kapasiteter): this.generate("PraksisaktivitetBestillingPutDto", "kapasiteter", "Array<PraksisaktivitetPutKapasitetDto>", "null", false),
            deaktiverteSteder: template && template.deaktiverteSteder ? (typeof template.deaktiverteSteder === "function" ? (template.deaktiverteSteder as Function)(this) : template.deaktiverteSteder): this.generate("PraksisaktivitetBestillingPutDto", "deaktiverteSteder", "Array<PraksisavtaleIdToPraksisstedIderDto>", "null", false),
            skjulteSteder: template && template.skjulteSteder ? (typeof template.skjulteSteder === "function" ? (template.skjulteSteder as Function)(this) : template.skjulteSteder): this.generate("PraksisaktivitetBestillingPutDto", "skjulteSteder", "Array<PraksisavtaleIdToPraksisstedIderDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetBestillingPutDto(template?: Factory<PraksisaktivitetBestillingPutDto>, length?: number): Array<PraksisaktivitetBestillingPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetBestillingPutDto")}).map(() => this.samplePraksisaktivitetBestillingPutDto(template));
    }
    samplePraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>): PraksisaktivitetDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetDto", "sted", "StudiestedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisaktivitetDto", "emne", "EmneDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetDto", "praksis", "PraksisDto", "null", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetDto", "krav", "AktivitetskravDto", "null", false),
            muligeKrav: template && template.muligeKrav ? (typeof template.muligeKrav === "function" ? (template.muligeKrav as Function)(this) : template.muligeKrav): this.generate("PraksisaktivitetDto", "muligeKrav", "Array<AktivitetskravDto>", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("PraksisaktivitetDto", "delt", "boolean", "false", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksisaktivitetDto", "behov", "number", "20", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisaktivitetDto", "kapasitet", "number", "20", false),
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("PraksisaktivitetDto", "studenter", "number", "110", false),
            registreringsVarsler: template && template.registreringsVarsler ? (typeof template.registreringsVarsler === "function" ? (template.registreringsVarsler as Function)(this) : template.registreringsVarsler): this.generate("PraksisaktivitetDto", "registreringsVarsler", "number", "1", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetDto", "status", "PraksisaktivitetStatusDto", "null", false),
            avtaler: template && template.avtaler ? (typeof template.avtaler === "function" ? (template.avtaler as Function)(this) : template.avtaler): this.generate("PraksisaktivitetDto", "avtaler", "Array<PraksisaktivitetAvtalerDto>", "null", false),
            publisertTilFs: template && template.publisertTilFs ? (typeof template.publisertTilFs === "function" ? (template.publisertTilFs as Function)(this) : template.publisertTilFs): this.generate("PraksisaktivitetDto", "publisertTilFs", "boolean", "false", false),
            publisertTilPs: template && template.publisertTilPs ? (typeof template.publisertTilPs === "function" ? (template.publisertTilPs as Function)(this) : template.publisertTilPs): this.generate("PraksisaktivitetDto", "publisertTilPs", "boolean", "false", false),
            onskeliste: template && template.onskeliste ? (typeof template.onskeliste === "function" ? (template.onskeliste as Function)(this) : template.onskeliste): this.generate("PraksisaktivitetDto", "onskeliste", "PraksisaktivitetOnskelisteInfoDto", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisaktivitetDto", "kanEndre", "boolean", "null", false),
            deaktiverteSteder: template && template.deaktiverteSteder ? (typeof template.deaktiverteSteder === "function" ? (template.deaktiverteSteder as Function)(this) : template.deaktiverteSteder): this.generate("PraksisaktivitetDto", "deaktiverteSteder", "Array<PraksisavtaleIdToPraksisstedIderDto>", "null", false),
            skjulteSteder: template && template.skjulteSteder ? (typeof template.skjulteSteder === "function" ? (template.skjulteSteder as Function)(this) : template.skjulteSteder): this.generate("PraksisaktivitetDto", "skjulteSteder", "Array<PraksisavtaleIdToPraksisstedIderDto>", "null", false),
            praksisstederMedFordelteStudenter: template && template.praksisstederMedFordelteStudenter ? (typeof template.praksisstederMedFordelteStudenter === "function" ? (template.praksisstederMedFordelteStudenter as Function)(this) : template.praksisstederMedFordelteStudenter): this.generate("PraksisaktivitetDto", "praksisstederMedFordelteStudenter", "Array<PraksisavtaleIdToPraksisstedIderDto>", "null", false),
            praksisstederMedStudentOnsker: template && template.praksisstederMedStudentOnsker ? (typeof template.praksisstederMedStudentOnsker === "function" ? (template.praksisstederMedStudentOnsker as Function)(this) : template.praksisstederMedStudentOnsker): this.generate("PraksisaktivitetDto", "praksisstederMedStudentOnsker", "Array<string>", "null", false),
            fritekst: template && template.fritekst ? (typeof template.fritekst === "function" ? (template.fritekst as Function)(this) : template.fritekst): this.generate("PraksisaktivitetDto", "fritekst", "string", "Hei på deg, din gamle blei!", false),
            endret: template && template.endret ? (typeof template.endret === "function" ? (template.endret as Function)(this) : template.endret): this.generate("PraksisaktivitetDto", "endret", "PraksisaktivitetEndretDto", "null", false),
            benytterVurdering: template && template.benytterVurdering ? (typeof template.benytterVurdering === "function" ? (template.benytterVurdering as Function)(this) : template.benytterVurdering): this.generate("PraksisaktivitetDto", "benytterVurdering", "boolean", "false", false),
            valgtLaeringsutbyttegruppe: template && template.valgtLaeringsutbyttegruppe ? (typeof template.valgtLaeringsutbyttegruppe === "function" ? (template.valgtLaeringsutbyttegruppe as Function)(this) : template.valgtLaeringsutbyttegruppe): this.generate("PraksisaktivitetDto", "valgtLaeringsutbyttegruppe", "LaeringsutbyttegruppeDto", "null", false),
            fsStatus: template && template.fsStatus ? (typeof template.fsStatus === "function" ? (template.fsStatus as Function)(this) : template.fsStatus): this.generate("PraksisaktivitetDto", "fsStatus", "FSAktivitetstatusDto", "null", false),
        };
    }
    sampleArrayPraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>, length?: number): Array<PraksisaktivitetDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetDto")}).map(() => this.samplePraksisaktivitetDto(template));
    }
    samplePraksisaktivitetEndretDto(template?: Factory<PraksisaktivitetEndretDto>): PraksisaktivitetEndretDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetEndretDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetEndretDto"](this);
        }

        return {
            endretAv: template && template.endretAv ? (typeof template.endretAv === "function" ? (template.endretAv as Function)(this) : template.endretAv): this.generate("PraksisaktivitetEndretDto", "endretAv", "PersonDto", "null", false),
            endretTidspunkt: template && template.endretTidspunkt ? (typeof template.endretTidspunkt === "function" ? (template.endretTidspunkt as Function)(this) : template.endretTidspunkt): this.generate("PraksisaktivitetEndretDto", "endretTidspunkt", "string", "2017-07-21T17:32:28Z", false),
        };
    }
    sampleArrayPraksisaktivitetEndretDto(template?: Factory<PraksisaktivitetEndretDto>, length?: number): Array<PraksisaktivitetEndretDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetEndretDto")}).map(() => this.samplePraksisaktivitetEndretDto(template));
    }
    samplePraksisaktivitetInfoDetaljertPsDto(template?: Factory<PraksisaktivitetInfoDetaljertPsDto>): PraksisaktivitetInfoDetaljertPsDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDetaljertPsDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDetaljertPsDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDetaljertPsDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDetaljertPsDto", "sted", "StudiestedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisaktivitetInfoDetaljertPsDto", "emne", "EmneDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDetaljertPsDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDetaljertPsDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDetaljertPsDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDetaljertPsDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksisaktivitetInfoDetaljertPsDto", "behov", "number", "20", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetInfoDetaljertPsDto", "krav", "string", "Kirurgisk praksis", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetInfoDetaljertPsDto", "status", "PraksisaktivitetStatusDto", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("PraksisaktivitetInfoDetaljertPsDto", "rolle", "Array<PraksisstedRollerDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDetaljertPsDto(template?: Factory<PraksisaktivitetInfoDetaljertPsDto>, length?: number): Array<PraksisaktivitetInfoDetaljertPsDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDetaljertPsDto")}).map(() => this.samplePraksisaktivitetInfoDetaljertPsDto(template));
    }
    samplePraksisaktivitetInfoDetaljertUhDto(template?: Factory<PraksisaktivitetInfoDetaljertUhDto>): PraksisaktivitetInfoDetaljertUhDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDetaljertUhDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDetaljertUhDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDetaljertUhDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDetaljertUhDto", "sted", "StudiestedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisaktivitetInfoDetaljertUhDto", "emne", "EmneDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDetaljertUhDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDetaljertUhDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDetaljertUhDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDetaljertUhDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksisaktivitetInfoDetaljertUhDto", "behov", "number", "20", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetInfoDetaljertUhDto", "krav", "string", "Kirurgisk praksis", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetInfoDetaljertUhDto", "status", "PraksisaktivitetStatusDto", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("PraksisaktivitetInfoDetaljertUhDto", "rolle", "Array<StudiestedRollerDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDetaljertUhDto(template?: Factory<PraksisaktivitetInfoDetaljertUhDto>, length?: number): Array<PraksisaktivitetInfoDetaljertUhDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDetaljertUhDto")}).map(() => this.samplePraksisaktivitetInfoDetaljertUhDto(template));
    }
    samplePraksisaktivitetInfoDto(template?: Factory<PraksisaktivitetInfoDto>): PraksisaktivitetInfoDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDto", "sted", "StudiestedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisaktivitetInfoDto", "emne", "EmneDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksisaktivitetInfoDto", "behov", "number", "20", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDto(template?: Factory<PraksisaktivitetInfoDto>, length?: number): Array<PraksisaktivitetInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDto")}).map(() => this.samplePraksisaktivitetInfoDto(template));
    }
    samplePraksisaktivitetKopiEgenskaperDto(template?: Factory<PraksisaktivitetKopiEgenskaperDto>): PraksisaktivitetKopiEgenskaperDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetKopiEgenskaperDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetKopiEgenskaperDto"](this);
        }

        return {
            kopierAktivitetskrav: template && template.kopierAktivitetskrav ? (typeof template.kopierAktivitetskrav === "function" ? (template.kopierAktivitetskrav as Function)(this) : template.kopierAktivitetskrav): this.generate("PraksisaktivitetKopiEgenskaperDto", "kopierAktivitetskrav", "boolean", "null", false),
            kopierFritekst: template && template.kopierFritekst ? (typeof template.kopierFritekst === "function" ? (template.kopierFritekst as Function)(this) : template.kopierFritekst): this.generate("PraksisaktivitetKopiEgenskaperDto", "kopierFritekst", "boolean", "null", false),
            kopierBestillinger: template && template.kopierBestillinger ? (typeof template.kopierBestillinger === "function" ? (template.kopierBestillinger as Function)(this) : template.kopierBestillinger): this.generate("PraksisaktivitetKopiEgenskaperDto", "kopierBestillinger", "boolean", "null", false),
            kopierRoller: template && template.kopierRoller ? (typeof template.kopierRoller === "function" ? (template.kopierRoller as Function)(this) : template.kopierRoller): this.generate("PraksisaktivitetKopiEgenskaperDto", "kopierRoller", "boolean", "null", false),
            kopierFordeling: template && template.kopierFordeling ? (typeof template.kopierFordeling === "function" ? (template.kopierFordeling as Function)(this) : template.kopierFordeling): this.generate("PraksisaktivitetKopiEgenskaperDto", "kopierFordeling", "boolean", "null", false),
        };
    }
    sampleArrayPraksisaktivitetKopiEgenskaperDto(template?: Factory<PraksisaktivitetKopiEgenskaperDto>, length?: number): Array<PraksisaktivitetKopiEgenskaperDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetKopiEgenskaperDto")}).map(() => this.samplePraksisaktivitetKopiEgenskaperDto(template));
    }
    samplePraksisaktivitetKopiPostDto(template?: Factory<PraksisaktivitetKopiPostDto>): PraksisaktivitetKopiPostDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetKopiPostDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetKopiPostDto"](this);
        }

        return {
            praksisklasseId: template && template.praksisklasseId ? (typeof template.praksisklasseId === "function" ? (template.praksisklasseId as Function)(this) : template.praksisklasseId): this.generate("PraksisaktivitetKopiPostDto", "praksisklasseId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            periode: template && template.periode ? (typeof template.periode === "function" ? (template.periode as Function)(this) : template.periode): this.generate("PraksisaktivitetKopiPostDto", "periode", "PeriodeDto", "null", false),
            egenskaper: template && template.egenskaper ? (typeof template.egenskaper === "function" ? (template.egenskaper as Function)(this) : template.egenskaper): this.generate("PraksisaktivitetKopiPostDto", "egenskaper", "PraksisaktivitetKopiEgenskaperDto", "null", false),
        };
    }
    sampleArrayPraksisaktivitetKopiPostDto(template?: Factory<PraksisaktivitetKopiPostDto>, length?: number): Array<PraksisaktivitetKopiPostDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetKopiPostDto")}).map(() => this.samplePraksisaktivitetKopiPostDto(template));
    }
    samplePraksisaktivitetOnskelisteInfoDto(template?: Factory<PraksisaktivitetOnskelisteInfoDto>): PraksisaktivitetOnskelisteInfoDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetOnskelisteInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetOnskelisteInfoDto"](this);
        }

        return {
            aapnet: template && template.aapnet ? (typeof template.aapnet === "function" ? (template.aapnet as Function)(this) : template.aapnet): this.generate("PraksisaktivitetOnskelisteInfoDto", "aapnet", "boolean", "null", false),
            aktivert: template && template.aktivert ? (typeof template.aktivert === "function" ? (template.aktivert as Function)(this) : template.aktivert): this.generate("PraksisaktivitetOnskelisteInfoDto", "aktivert", "boolean", "null", false),
            kanEndresFra: template && template.kanEndresFra ? (typeof template.kanEndresFra === "function" ? (template.kanEndresFra as Function)(this) : template.kanEndresFra): this.generate("PraksisaktivitetOnskelisteInfoDto", "kanEndresFra", "string", "null", false),
            kanEndresTil: template && template.kanEndresTil ? (typeof template.kanEndresTil === "function" ? (template.kanEndresTil as Function)(this) : template.kanEndresTil): this.generate("PraksisaktivitetOnskelisteInfoDto", "kanEndresTil", "string", "null", false),
            antallOnsker: template && template.antallOnsker ? (typeof template.antallOnsker === "function" ? (template.antallOnsker as Function)(this) : template.antallOnsker): this.generate("PraksisaktivitetOnskelisteInfoDto", "antallOnsker", "number", "5", false),
        };
    }
    sampleArrayPraksisaktivitetOnskelisteInfoDto(template?: Factory<PraksisaktivitetOnskelisteInfoDto>, length?: number): Array<PraksisaktivitetOnskelisteInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetOnskelisteInfoDto")}).map(() => this.samplePraksisaktivitetOnskelisteInfoDto(template));
    }
    samplePraksisaktivitetPutBestillingDto(template?: Factory<PraksisaktivitetPutBestillingDto>): PraksisaktivitetPutBestillingDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetPutBestillingDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetPutBestillingDto"](this);
        }

        return {
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisaktivitetPutBestillingDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisaktivitetPutBestillingDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisaktivitetPutBestillingDto", "bestilling", "number", "20", false),
            bestillingsmodus: template && template.bestillingsmodus ? (typeof template.bestillingsmodus === "function" ? (template.bestillingsmodus as Function)(this) : template.bestillingsmodus): this.generate("PraksisaktivitetPutBestillingDto", "bestillingsmodus", "PraksisavtaleStedBestillingspunktTypeDto", "null", false),
        };
    }
    sampleArrayPraksisaktivitetPutBestillingDto(template?: Factory<PraksisaktivitetPutBestillingDto>, length?: number): Array<PraksisaktivitetPutBestillingDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetPutBestillingDto")}).map(() => this.samplePraksisaktivitetPutBestillingDto(template));
    }
    samplePraksisaktivitetPutDto(template?: Factory<PraksisaktivitetPutDto>): PraksisaktivitetPutDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetPutDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetPutDto"](this);
        }

        return {
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetPutDto", "startDato", "number", "1580143106014", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetPutDto", "sluttDato", "number", "1580143106014", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksisaktivitetPutDto", "behov", "number", "20", false),
            aktivitetskravId: template && template.aktivitetskravId ? (typeof template.aktivitetskravId === "function" ? (template.aktivitetskravId as Function)(this) : template.aktivitetskravId): this.generate("PraksisaktivitetPutDto", "aktivitetskravId", "string", "null", false),
            klassenavn: template && template.klassenavn ? (typeof template.klassenavn === "function" ? (template.klassenavn as Function)(this) : template.klassenavn): this.generate("PraksisaktivitetPutDto", "klassenavn", "string", "Min klasse", false),
            fritekst: template && template.fritekst ? (typeof template.fritekst === "function" ? (template.fritekst as Function)(this) : template.fritekst): this.generate("PraksisaktivitetPutDto", "fritekst", "string", "Hei på deg, din gamle blei!", false),
            benytterVurdering: template && template.benytterVurdering ? (typeof template.benytterVurdering === "function" ? (template.benytterVurdering as Function)(this) : template.benytterVurdering): this.generate("PraksisaktivitetPutDto", "benytterVurdering", "boolean", "null", false),
        };
    }
    sampleArrayPraksisaktivitetPutDto(template?: Factory<PraksisaktivitetPutDto>, length?: number): Array<PraksisaktivitetPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetPutDto")}).map(() => this.samplePraksisaktivitetPutDto(template));
    }
    samplePraksisaktivitetPutKapasitetDto(template?: Factory<PraksisaktivitetPutKapasitetDto>): PraksisaktivitetPutKapasitetDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetPutKapasitetDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetPutKapasitetDto"](this);
        }

        return {
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisaktivitetPutKapasitetDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisaktivitetPutKapasitetDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisaktivitetPutKapasitetDto", "kapasitet", "number", "10", false),
            kapasitetspunkt: template && template.kapasitetspunkt ? (typeof template.kapasitetspunkt === "function" ? (template.kapasitetspunkt as Function)(this) : template.kapasitetspunkt): this.generate("PraksisaktivitetPutKapasitetDto", "kapasitetspunkt", "boolean", "true", false),
            bestillingsmodus: template && template.bestillingsmodus ? (typeof template.bestillingsmodus === "function" ? (template.bestillingsmodus as Function)(this) : template.bestillingsmodus): this.generate("PraksisaktivitetPutKapasitetDto", "bestillingsmodus", "PraksisavtaleStedBestillingspunktTypeDto", "null", false),
        };
    }
    sampleArrayPraksisaktivitetPutKapasitetDto(template?: Factory<PraksisaktivitetPutKapasitetDto>, length?: number): Array<PraksisaktivitetPutKapasitetDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetPutKapasitetDto")}).map(() => this.samplePraksisaktivitetPutKapasitetDto(template));
    }
    samplePraksisaktivitetStatusDto(template?: EnumFactory<PraksisaktivitetStatusDto>): PraksisaktivitetStatusDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetStatusDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetStatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisaktivitetStatusDto.ManglerBehov,
                PraksisaktivitetStatusDto.KanDeles,
                PraksisaktivitetStatusDto.DeltMenManglerKapasitet,
                PraksisaktivitetStatusDto.DeltMedNoenPraksissteder,
                PraksisaktivitetStatusDto.DeltOgHarKapasitet,
                PraksisaktivitetStatusDto.VenterPaaOnskeliste,
                PraksisaktivitetStatusDto.AvsluttetOnskeliste,
                PraksisaktivitetStatusDto.StudenterManglerKlasse,
                PraksisaktivitetStatusDto.StudenterManglerPlass,
                PraksisaktivitetStatusDto.AlleStudenterFordelt,
                PraksisaktivitetStatusDto.FordelingsresultatDelt,
                PraksisaktivitetStatusDto.Aktiv,
                PraksisaktivitetStatusDto.Gjennomfoert,
                PraksisaktivitetStatusDto.Avtalefeil
        ]);
    }
    sampleArrayPraksisaktivitetStatusDto(template?: EnumFactory<PraksisaktivitetStatusDto>, length?: number): Array<PraksisaktivitetStatusDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetStatusDto")}).map(() => this.samplePraksisaktivitetStatusDto());
    }
    samplePraksisaktiviteterDto(template?: Factory<PraksisaktiviteterDto>): PraksisaktiviteterDto {
        if (typeof this.sampleModelProperties["PraksisaktiviteterDto"] === "function") {
            return this.sampleModelProperties["PraksisaktiviteterDto"](this);
        }

        return {
            gamle: template && template.gamle ? (typeof template.gamle === "function" ? (template.gamle as Function)(this) : template.gamle): this.generate("PraksisaktiviteterDto", "gamle", "Array<PraksisaktivitetInfoDto>", "null", false),
            aktive: template && template.aktive ? (typeof template.aktive === "function" ? (template.aktive as Function)(this) : template.aktive): this.generate("PraksisaktiviteterDto", "aktive", "Array<PraksisaktivitetInfoDto>", "null", false),
            fremtidige: template && template.fremtidige ? (typeof template.fremtidige === "function" ? (template.fremtidige as Function)(this) : template.fremtidige): this.generate("PraksisaktiviteterDto", "fremtidige", "Array<PraksisaktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisaktiviteterDto(template?: Factory<PraksisaktiviteterDto>, length?: number): Array<PraksisaktiviteterDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktiviteterDto")}).map(() => this.samplePraksisaktiviteterDto(template));
    }
    samplePraksisaktiviteterInfoDto(template?: Factory<PraksisaktiviteterInfoDto>): PraksisaktiviteterInfoDto {
        if (typeof this.sampleModelProperties["PraksisaktiviteterInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisaktiviteterInfoDto"](this);
        }

        return {
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("PraksisaktiviteterInfoDto", "aktiviteter", "Array<PraksisaktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisaktiviteterInfoDto(template?: Factory<PraksisaktiviteterInfoDto>, length?: number): Array<PraksisaktiviteterInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktiviteterInfoDto")}).map(() => this.samplePraksisaktiviteterInfoDto(template));
    }
    samplePraksisavtaleIdToPraksisstedIderDto(template?: Factory<PraksisavtaleIdToPraksisstedIderDto>): PraksisavtaleIdToPraksisstedIderDto {
        if (typeof this.sampleModelProperties["PraksisavtaleIdToPraksisstedIderDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleIdToPraksisstedIderDto"](this);
        }

        return {
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisavtaleIdToPraksisstedIderDto", "avtaleId", "string", "null", false),
            praksisstedIder: template && template.praksisstedIder ? (typeof template.praksisstedIder === "function" ? (template.praksisstedIder as Function)(this) : template.praksisstedIder): this.generate("PraksisavtaleIdToPraksisstedIderDto", "praksisstedIder", "Array<string>", "null", false),
        };
    }
    sampleArrayPraksisavtaleIdToPraksisstedIderDto(template?: Factory<PraksisavtaleIdToPraksisstedIderDto>, length?: number): Array<PraksisavtaleIdToPraksisstedIderDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleIdToPraksisstedIderDto")}).map(() => this.samplePraksisavtaleIdToPraksisstedIderDto(template));
    }
    samplePraksisavtaleStedBestillingspunktTypeDto(template?: EnumFactory<PraksisavtaleStedBestillingspunktTypeDto>): PraksisavtaleStedBestillingspunktTypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleStedBestillingspunktTypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleStedBestillingspunktTypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleStedBestillingspunktTypeDto.AvtaleSted,
                PraksisavtaleStedBestillingspunktTypeDto.OmfattetAvtaleSted
        ]);
    }
    sampleArrayPraksisavtaleStedBestillingspunktTypeDto(template?: EnumFactory<PraksisavtaleStedBestillingspunktTypeDto>, length?: number): Array<PraksisavtaleStedBestillingspunktTypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleStedBestillingspunktTypeDto")}).map(() => this.samplePraksisavtaleStedBestillingspunktTypeDto());
    }
    samplePraksisavtaleStedDto(template?: Factory<PraksisavtaleStedDto>): PraksisavtaleStedDto {
        if (typeof this.sampleModelProperties["PraksisavtaleStedDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleStedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleStedDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleStedDto", "navn", "string", "Skole A", false),
            bestillingspunkt: template && template.bestillingspunkt ? (typeof template.bestillingspunkt === "function" ? (template.bestillingspunkt as Function)(this) : template.bestillingspunkt): this.generate("PraksisavtaleStedDto", "bestillingspunkt", "PraksisavtaleStedBestillingspunktTypeDto", "null", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisavtaleStedDto", "bestilling", "number", "20", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisavtaleStedDto", "kapasitet", "number", "10", false),
            kapasitetspunkt: template && template.kapasitetspunkt ? (typeof template.kapasitetspunkt === "function" ? (template.kapasitetspunkt as Function)(this) : template.kapasitetspunkt): this.generate("PraksisavtaleStedDto", "kapasitetspunkt", "boolean", "false", false),
            kapasitetstype: template && template.kapasitetstype ? (typeof template.kapasitetstype === "function" ? (template.kapasitetstype as Function)(this) : template.kapasitetstype): this.pickOne([PraksisavtaleStedDtoKapasitetstypeDtoEnum.Praksissted,PraksisavtaleStedDtoKapasitetstypeDtoEnum.Studiested]),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisavtaleStedDto", "valideringsfeil", "PraksisavtalestedValideringfeilDto", "null", false),
            overnoder: template && template.overnoder ? (typeof template.overnoder === "function" ? (template.overnoder as Function)(this) : template.overnoder): this.generate("PraksisavtaleStedDto", "overnoder", "Array<string>", "null", false),
            overnoderOgDeresSosken: template && template.overnoderOgDeresSosken ? (typeof template.overnoderOgDeresSosken === "function" ? (template.overnoderOgDeresSosken as Function)(this) : template.overnoderOgDeresSosken): this.generate("PraksisavtaleStedDto", "overnoderOgDeresSosken", "Array<string>", "null", false),
            soskennoder: template && template.soskennoder ? (typeof template.soskennoder === "function" ? (template.soskennoder as Function)(this) : template.soskennoder): this.generate("PraksisavtaleStedDto", "soskennoder", "Array<string>", "null", false),
            undernoder: template && template.undernoder ? (typeof template.undernoder === "function" ? (template.undernoder as Function)(this) : template.undernoder): this.generate("PraksisavtaleStedDto", "undernoder", "Array<PraksisavtaleStedDto>", "null", false),
            harRegistrertAdminBruker: template && template.harRegistrertAdminBruker ? (typeof template.harRegistrertAdminBruker === "function" ? (template.harRegistrertAdminBruker as Function)(this) : template.harRegistrertAdminBruker): this.generate("PraksisavtaleStedDto", "harRegistrertAdminBruker", "boolean", "null", false),
        };
    }
    sampleArrayPraksisavtaleStedDto(template?: Factory<PraksisavtaleStedDto>, length?: number): Array<PraksisavtaleStedDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleStedDto")}).map(() => this.samplePraksisavtaleStedDto(template));
    }
    samplePraksisavtaleValideringfeiltypeDto(template?: EnumFactory<PraksisavtaleValideringfeiltypeDto>): PraksisavtaleValideringfeiltypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleValideringfeiltypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleValideringfeiltypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleValideringfeiltypeDto.Avtalenavn,
                PraksisavtaleValideringfeiltypeDto.Avtalested,
                PraksisavtaleValideringfeiltypeDto.AvtaleVersjon,
                PraksisavtaleValideringfeiltypeDto.AvtalePraksistyper,
                PraksisavtaleValideringfeiltypeDto.Avtaleeier,
                PraksisavtaleValideringfeiltypeDto.AvtaleDato,
                PraksisavtaleValideringfeiltypeDto.AvtaleData
        ]);
    }
    sampleArrayPraksisavtaleValideringfeiltypeDto(template?: EnumFactory<PraksisavtaleValideringfeiltypeDto>, length?: number): Array<PraksisavtaleValideringfeiltypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleValideringfeiltypeDto")}).map(() => this.samplePraksisavtaleValideringfeiltypeDto());
    }
    samplePraksisavtaleValideringsfeilDto(template?: Factory<PraksisavtaleValideringsfeilDto>): PraksisavtaleValideringsfeilDto {
        if (typeof this.sampleModelProperties["PraksisavtaleValideringsfeilDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleValideringsfeilDto"](this);
        }

        return {
            message: template && template.message ? (typeof template.message === "function" ? (template.message as Function)(this) : template.message): this.generate("PraksisavtaleValideringsfeilDto", "message", "string", "Avtalenavn kan ikke være tom", false),
            errorType: template && template.errorType ? (typeof template.errorType === "function" ? (template.errorType as Function)(this) : template.errorType): this.generate("PraksisavtaleValideringsfeilDto", "errorType", "PraksisavtaleValideringfeiltypeDto", "null", false),
        };
    }
    sampleArrayPraksisavtaleValideringsfeilDto(template?: Factory<PraksisavtaleValideringsfeilDto>, length?: number): Array<PraksisavtaleValideringsfeilDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleValideringsfeilDto")}).map(() => this.samplePraksisavtaleValideringsfeilDto(template));
    }
    samplePraksisavtaleVedleggDto(template?: Factory<PraksisavtaleVedleggDto>): PraksisavtaleVedleggDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleVedleggDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleVedleggDto", "navn", "string", "Sommeravtalen for skøy på landet", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("PraksisavtaleVedleggDto", "type", "PraksisavtaleVedleggTypeDto", "null", false),
            filStorrelse: template && template.filStorrelse ? (typeof template.filStorrelse === "function" ? (template.filStorrelse as Function)(this) : template.filStorrelse): this.generate("PraksisavtaleVedleggDto", "filStorrelse", "number", "3500000", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisavtaleVedleggDto", "vedlegg", "string", "null", false),
        };
    }
    sampleArrayPraksisavtaleVedleggDto(template?: Factory<PraksisavtaleVedleggDto>, length?: number): Array<PraksisavtaleVedleggDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggDto")}).map(() => this.samplePraksisavtaleVedleggDto(template));
    }
    samplePraksisavtaleVedleggMinimalDto(template?: Factory<PraksisavtaleVedleggMinimalDto>): PraksisavtaleVedleggMinimalDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggMinimalDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggMinimalDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleVedleggMinimalDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleVedleggMinimalDto", "navn", "string", "Sommeravtalen for skøy på landet", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("PraksisavtaleVedleggMinimalDto", "type", "PraksisavtaleVedleggTypeDto", "null", false),
            resourceLink: template && template.resourceLink ? (typeof template.resourceLink === "function" ? (template.resourceLink as Function)(this) : template.resourceLink): this.generate("PraksisavtaleVedleggMinimalDto", "resourceLink", "string", "http://localhost/praksisavtale/1234/vedlegg/12124", false),
        };
    }
    sampleArrayPraksisavtaleVedleggMinimalDto(template?: Factory<PraksisavtaleVedleggMinimalDto>, length?: number): Array<PraksisavtaleVedleggMinimalDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggMinimalDto")}).map(() => this.samplePraksisavtaleVedleggMinimalDto(template));
    }
    samplePraksisavtaleVedleggPostDto(template?: Factory<PraksisavtaleVedleggPostDto>): PraksisavtaleVedleggPostDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggPostDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggPostDto"](this);
        }

        return {
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleVedleggPostDto", "navn", "string", "Sommeravtalen for skøy på landet", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("PraksisavtaleVedleggPostDto", "type", "PraksisavtaleVedleggTypeDto", "null", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisavtaleVedleggPostDto", "vedlegg", "File", "null", false),
        };
    }
    sampleArrayPraksisavtaleVedleggPostDto(template?: Factory<PraksisavtaleVedleggPostDto>, length?: number): Array<PraksisavtaleVedleggPostDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggPostDto")}).map(() => this.samplePraksisavtaleVedleggPostDto(template));
    }
    samplePraksisavtaleVedleggTypeDto(template?: EnumFactory<PraksisavtaleVedleggTypeDto>): PraksisavtaleVedleggTypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggTypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggTypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleVedleggTypeDto.Samarbeidsavtale,
                PraksisavtaleVedleggTypeDto.Databehandleravtale,
                PraksisavtaleVedleggTypeDto.Annet
        ]);
    }
    sampleArrayPraksisavtaleVedleggTypeDto(template?: EnumFactory<PraksisavtaleVedleggTypeDto>, length?: number): Array<PraksisavtaleVedleggTypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggTypeDto")}).map(() => this.samplePraksisavtaleVedleggTypeDto());
    }
    samplePraksisavtalestedValideringfeilDto(template?: Factory<PraksisavtalestedValideringfeilDto>): PraksisavtalestedValideringfeilDto {
        if (typeof this.sampleModelProperties["PraksisavtalestedValideringfeilDto"] === "function") {
            return this.sampleModelProperties["PraksisavtalestedValideringfeilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtalestedValideringfeilDto", "id", "string", "53b6328a-1c97-11ed-9817-03ae5cfcb154", false),
            message: template && template.message ? (typeof template.message === "function" ? (template.message as Function)(this) : template.message): this.generate("PraksisavtalestedValideringfeilDto", "message", "string", "Bestilling utenfor avtale", false),
            errorType: template && template.errorType ? (typeof template.errorType === "function" ? (template.errorType as Function)(this) : template.errorType): this.generate("PraksisavtalestedValideringfeilDto", "errorType", "PraksisavtalestedValideringfeiltypeDto", "null", false),
            sourceType: template && template.sourceType ? (typeof template.sourceType === "function" ? (template.sourceType as Function)(this) : template.sourceType): this.pickOne([PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum.Bestilling,PraksisavtalestedValideringfeilDtoSourceTypeDtoEnum.Besvarelse]),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisavtalestedValideringfeilDto", "bestilling", "number", "20", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisavtalestedValideringfeilDto", "kapasitet", "number", "20", false),
            praksisstedForBesvarelsensBestilling: template && template.praksisstedForBesvarelsensBestilling ? (typeof template.praksisstedForBesvarelsensBestilling === "function" ? (template.praksisstedForBesvarelsensBestilling as Function)(this) : template.praksisstedForBesvarelsensBestilling): this.generate("PraksisavtalestedValideringfeilDto", "praksisstedForBesvarelsensBestilling", "MinimalPraksisstedDto", "null", false),
        };
    }
    sampleArrayPraksisavtalestedValideringfeilDto(template?: Factory<PraksisavtalestedValideringfeilDto>, length?: number): Array<PraksisavtalestedValideringfeilDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtalestedValideringfeilDto")}).map(() => this.samplePraksisavtalestedValideringfeilDto(template));
    }
    samplePraksisavtalestedValideringfeiltypeDto(template?: EnumFactory<PraksisavtalestedValideringfeiltypeDto>): PraksisavtalestedValideringfeiltypeDto {
        if (typeof this.sampleModelProperties["PraksisavtalestedValideringfeiltypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtalestedValideringfeiltypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtalestedValideringfeiltypeDto.MissingAvtalested,
                PraksisavtalestedValideringfeiltypeDto.MissingFromAktivitetskrav,
                PraksisavtalestedValideringfeiltypeDto.MissingFromTopTree,
                PraksisavtalestedValideringfeiltypeDto.MissingOmfattetPraksissted,
                PraksisavtalestedValideringfeiltypeDto.DeaktivertSted,
                PraksisavtalestedValideringfeiltypeDto.PathMismatch,
                PraksisavtalestedValideringfeiltypeDto.UtloeptSted,
                PraksisavtalestedValideringfeiltypeDto.UnderliggendeFeil,
                PraksisavtalestedValideringfeiltypeDto.HierarchicalBestilling,
                PraksisavtalestedValideringfeiltypeDto.OverlappingAvtalestedHierarchies,
                PraksisavtalestedValideringfeiltypeDto.OverlappingBesvarelse,
                PraksisavtalestedValideringfeiltypeDto.NotWithinAvtalePeriod,
                PraksisavtalestedValideringfeiltypeDto.InactivePraksistype,
                PraksisavtalestedValideringfeiltypeDto.InactivePraksisavtale
        ]);
    }
    sampleArrayPraksisavtalestedValideringfeiltypeDto(template?: EnumFactory<PraksisavtalestedValideringfeiltypeDto>, length?: number): Array<PraksisavtalestedValideringfeiltypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtalestedValideringfeiltypeDto")}).map(() => this.samplePraksisavtalestedValideringfeiltypeDto());
    }
    samplePraksiskalenderAktivitetDto(template?: Factory<PraksiskalenderAktivitetDto>): PraksiskalenderAktivitetDto {
        if (typeof this.sampleModelProperties["PraksiskalenderAktivitetDto"] === "function") {
            return this.sampleModelProperties["PraksiskalenderAktivitetDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksiskalenderAktivitetDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            klasseId: template && template.klasseId ? (typeof template.klasseId === "function" ? (template.klasseId as Function)(this) : template.klasseId): this.generate("PraksiskalenderAktivitetDto", "klasseId", "string", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksiskalenderAktivitetDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksiskalenderAktivitetDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("PraksiskalenderAktivitetDto", "delt", "boolean", "false", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksiskalenderAktivitetDto", "behov", "number", "20", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksiskalenderAktivitetDto", "kapasitet", "number", "10", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksiskalenderAktivitetDto", "status", "PraksisaktivitetStatusDto", "null", false),
            fsStatus: template && template.fsStatus ? (typeof template.fsStatus === "function" ? (template.fsStatus as Function)(this) : template.fsStatus): this.generate("PraksiskalenderAktivitetDto", "fsStatus", "FSAktivitetstatustypeDto", "null", false),
        };
    }
    sampleArrayPraksiskalenderAktivitetDto(template?: Factory<PraksiskalenderAktivitetDto>, length?: number): Array<PraksiskalenderAktivitetDto> {
        return Array.from({length: length || this.arrayLength("PraksiskalenderAktivitetDto")}).map(() => this.samplePraksiskalenderAktivitetDto(template));
    }
    samplePraksiskalenderDto(template?: Factory<PraksiskalenderDto>): PraksiskalenderDto {
        if (typeof this.sampleModelProperties["PraksiskalenderDto"] === "function") {
            return this.sampleModelProperties["PraksiskalenderDto"](this);
        }

        return {
            klasser: template && template.klasser ? (typeof template.klasser === "function" ? (template.klasser as Function)(this) : template.klasser): this.generate("PraksiskalenderDto", "klasser", "Array<PraksisklasserPrEmneDto>", "null", false),
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("PraksiskalenderDto", "aktiviteter", "Array<PraksiskalenderAktivitetDto>", "null", false),
        };
    }
    sampleArrayPraksiskalenderDto(template?: Factory<PraksiskalenderDto>, length?: number): Array<PraksiskalenderDto> {
        return Array.from({length: length || this.arrayLength("PraksiskalenderDto")}).map(() => this.samplePraksiskalenderDto(template));
    }
    samplePraksisklasseDto(template?: Factory<PraksisklasseDto>): PraksisklasseDto {
        if (typeof this.sampleModelProperties["PraksisklasseDto"] === "function") {
            return this.sampleModelProperties["PraksisklasseDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisklasseDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            bokstav: template && template.bokstav ? (typeof template.bokstav === "function" ? (template.bokstav as Function)(this) : template.bokstav): this.generate("PraksisklasseDto", "bokstav", "string", "A", false),
            undervisningsenhetPeriode: template && template.undervisningsenhetPeriode ? (typeof template.undervisningsenhetPeriode === "function" ? (template.undervisningsenhetPeriode as Function)(this) : template.undervisningsenhetPeriode): this.generate("PraksisklasseDto", "undervisningsenhetPeriode", "UndervisningsenhetPeriodeDto", "null", false),
            presentertNavn: template && template.presentertNavn ? (typeof template.presentertNavn === "function" ? (template.presentertNavn as Function)(this) : template.presentertNavn): this.generate("PraksisklasseDto", "presentertNavn", "string", "Min klasse", false),
        };
    }
    sampleArrayPraksisklasseDto(template?: Factory<PraksisklasseDto>, length?: number): Array<PraksisklasseDto> {
        return Array.from({length: length || this.arrayLength("PraksisklasseDto")}).map(() => this.samplePraksisklasseDto(template));
    }
    samplePraksisklasseMedAktiviteterDto(template?: Factory<PraksisklasseMedAktiviteterDto>): PraksisklasseMedAktiviteterDto {
        if (typeof this.sampleModelProperties["PraksisklasseMedAktiviteterDto"] === "function") {
            return this.sampleModelProperties["PraksisklasseMedAktiviteterDto"](this);
        }

        return {
            praksisklasse: template && template.praksisklasse ? (typeof template.praksisklasse === "function" ? (template.praksisklasse as Function)(this) : template.praksisklasse): this.generate("PraksisklasseMedAktiviteterDto", "praksisklasse", "PraksisklasseDto", "null", false),
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("PraksisklasseMedAktiviteterDto", "aktiviteter", "Array<PraksisaktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisklasseMedAktiviteterDto(template?: Factory<PraksisklasseMedAktiviteterDto>, length?: number): Array<PraksisklasseMedAktiviteterDto> {
        return Array.from({length: length || this.arrayLength("PraksisklasseMedAktiviteterDto")}).map(() => this.samplePraksisklasseMedAktiviteterDto(template));
    }
    samplePraksisklasserPrEmneDto(template?: Factory<PraksisklasserPrEmneDto>): PraksisklasserPrEmneDto {
        if (typeof this.sampleModelProperties["PraksisklasserPrEmneDto"] === "function") {
            return this.sampleModelProperties["PraksisklasserPrEmneDto"](this);
        }

        return {
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisklasserPrEmneDto", "sted", "StudiestedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisklasserPrEmneDto", "emne", "EmneDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisklasserPrEmneDto", "praksis", "PraksisDto", "null", false),
            klasser: template && template.klasser ? (typeof template.klasser === "function" ? (template.klasser as Function)(this) : template.klasser): this.generate("PraksisklasserPrEmneDto", "klasser", "Array<PraksisklasseDto>", "null", false),
        };
    }
    sampleArrayPraksisklasserPrEmneDto(template?: Factory<PraksisklasserPrEmneDto>, length?: number): Array<PraksisklasserPrEmneDto> {
        return Array.from({length: length || this.arrayLength("PraksisklasserPrEmneDto")}).map(() => this.samplePraksisklasserPrEmneDto(template));
    }
    samplePraksisplassTilFordelingDto(template?: Factory<PraksisplassTilFordelingDto>): PraksisplassTilFordelingDto {
        if (typeof this.sampleModelProperties["PraksisplassTilFordelingDto"] === "function") {
            return this.sampleModelProperties["PraksisplassTilFordelingDto"](this);
        }

        return {
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisplassTilFordelingDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisplassTilFordelingDto", "kapasitet", "number", "10", false),
            hierarkiSti: template && template.hierarkiSti ? (typeof template.hierarkiSti === "function" ? (template.hierarkiSti as Function)(this) : template.hierarkiSti): this.generate("PraksisplassTilFordelingDto", "hierarkiSti", "string", "Node1 &gt; Node2 &gt; Node3", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisplassTilFordelingDto", "adresselinje2", "string", "0001 Cemetery Lane", false),
            muligeVeiledere: template && template.muligeVeiledere ? (typeof template.muligeVeiledere === "function" ? (template.muligeVeiledere as Function)(this) : template.muligeVeiledere): this.generate("PraksisplassTilFordelingDto", "muligeVeiledere", "Array<PersonDto>", "null", false),
            hasValideringsfeil: template && template.hasValideringsfeil ? (typeof template.hasValideringsfeil === "function" ? (template.hasValideringsfeil as Function)(this) : template.hasValideringsfeil): this.generate("PraksisplassTilFordelingDto", "hasValideringsfeil", "boolean", "null", false),
        };
    }
    sampleArrayPraksisplassTilFordelingDto(template?: Factory<PraksisplassTilFordelingDto>, length?: number): Array<PraksisplassTilFordelingDto> {
        return Array.from({length: length || this.arrayLength("PraksisplassTilFordelingDto")}).map(() => this.samplePraksisplassTilFordelingDto(template));
    }
    samplePraksisstedByAvtaleIdDto(template?: Factory<PraksisstedByAvtaleIdDto>): PraksisstedByAvtaleIdDto {
        if (typeof this.sampleModelProperties["PraksisstedByAvtaleIdDto"] === "function") {
            return this.sampleModelProperties["PraksisstedByAvtaleIdDto"](this);
        }

        return {
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisstedByAvtaleIdDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedByAvtaleIdDto", "avtaleId", "string", "null", false),
        };
    }
    sampleArrayPraksisstedByAvtaleIdDto(template?: Factory<PraksisstedByAvtaleIdDto>, length?: number): Array<PraksisstedByAvtaleIdDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedByAvtaleIdDto")}).map(() => this.samplePraksisstedByAvtaleIdDto(template));
    }
    samplePraksisstedDto(template?: Factory<PraksisstedDto>): PraksisstedDto {
        if (typeof this.sampleModelProperties["PraksisstedDto"] === "function") {
            return this.sampleModelProperties["PraksisstedDto"](this);
        }

        return {
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisstedDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            level: template && template.level ? (typeof template.level === "function" ? (template.level as Function)(this) : template.level): this.generate("PraksisstedDto", "level", "number", "1", false),
            brukerStatus: template && template.brukerStatus ? (typeof template.brukerStatus === "function" ? (template.brukerStatus as Function)(this) : template.brukerStatus): this.pickOne([PraksisstedDtoBrukerStatusDtoEnum.IkkeInvitert,PraksisstedDtoBrukerStatusDtoEnum.Invitert,PraksisstedDtoBrukerStatusDtoEnum.HarBruker]),
            canInvite: template && template.canInvite ? (typeof template.canInvite === "function" ? (template.canInvite as Function)(this) : template.canInvite): this.generate("PraksisstedDto", "canInvite", "boolean", "null", false),
        };
    }
    sampleArrayPraksisstedDto(template?: Factory<PraksisstedDto>, length?: number): Array<PraksisstedDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedDto")}).map(() => this.samplePraksisstedDto(template));
    }
    samplePraksisstedInfoPutDto(template?: Factory<PraksisstedInfoPutDto>): PraksisstedInfoPutDto {
        if (typeof this.sampleModelProperties["PraksisstedInfoPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedInfoPutDto"](this);
        }

        return {
            adresselinje1: template && template.adresselinje1 ? (typeof template.adresselinje1 === "function" ? (template.adresselinje1 as Function)(this) : template.adresselinje1): this.generate("PraksisstedInfoPutDto", "adresselinje1", "string", "Lorem Ipsum gate 12", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisstedInfoPutDto", "adresselinje2", "string", "2.etg vest", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("PraksisstedInfoPutDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("PraksisstedInfoPutDto", "poststed", "string", "Oslo", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedInfoPutDto", "epost", "string", "resepsjon@lovisenbergdiakonale.no", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("PraksisstedInfoPutDto", "telefonlandnr", "string", "47", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedInfoPutDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayPraksisstedInfoPutDto(template?: Factory<PraksisstedInfoPutDto>, length?: number): Array<PraksisstedInfoPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedInfoPutDto")}).map(() => this.samplePraksisstedInfoPutDto(template));
    }
    samplePraksisstedMedValideringsfeilDto(template?: Factory<PraksisstedMedValideringsfeilDto>): PraksisstedMedValideringsfeilDto {
        if (typeof this.sampleModelProperties["PraksisstedMedValideringsfeilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedMedValideringsfeilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedMedValideringsfeilDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedMedValideringsfeilDto", "navn", "string", "Skole A", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedMedValideringsfeilDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            avtaleNavn: template && template.avtaleNavn ? (typeof template.avtaleNavn === "function" ? (template.avtaleNavn as Function)(this) : template.avtaleNavn): this.generate("PraksisstedMedValideringsfeilDto", "avtaleNavn", "string", "Praksisavtale mellom UIT - UNN", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedMedValideringsfeilDto", "valideringsfeil", "PraksisavtalestedValideringfeilDto", "null", false),
        };
    }
    sampleArrayPraksisstedMedValideringsfeilDto(template?: Factory<PraksisstedMedValideringsfeilDto>, length?: number): Array<PraksisstedMedValideringsfeilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedMedValideringsfeilDto")}).map(() => this.samplePraksisstedMedValideringsfeilDto(template));
    }
    samplePraksisstedRollerDto(template?: EnumFactory<PraksisstedRollerDto>): PraksisstedRollerDto {
        if (typeof this.sampleModelProperties["PraksisstedRollerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedRollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisstedRollerDto.Koordinator,
                PraksisstedRollerDto.Veileder
        ]);
    }
    sampleArrayPraksisstedRollerDto(template?: EnumFactory<PraksisstedRollerDto>, length?: number): Array<PraksisstedRollerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedRollerDto")}).map(() => this.samplePraksisstedRollerDto());
    }
    samplePraksisstedTilFordelingDto(template?: Factory<PraksisstedTilFordelingDto>): PraksisstedTilFordelingDto {
        if (typeof this.sampleModelProperties["PraksisstedTilFordelingDto"] === "function") {
            return this.sampleModelProperties["PraksisstedTilFordelingDto"](this);
        }

        return {
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisstedTilFordelingDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            muligePraksisplasser: template && template.muligePraksisplasser ? (typeof template.muligePraksisplasser === "function" ? (template.muligePraksisplasser as Function)(this) : template.muligePraksisplasser): this.generate("PraksisstedTilFordelingDto", "muligePraksisplasser", "Array<PraksisplassTilFordelingDto>", "null", false),
        };
    }
    sampleArrayPraksisstedTilFordelingDto(template?: Factory<PraksisstedTilFordelingDto>, length?: number): Array<PraksisstedTilFordelingDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedTilFordelingDto")}).map(() => this.samplePraksisstedTilFordelingDto(template));
    }
    samplePraksisstedTilgangerDto(template?: Factory<PraksisstedTilgangerDto>): PraksisstedTilgangerDto {
        if (typeof this.sampleModelProperties["PraksisstedTilgangerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedTilgangerDto"](this);
        }

        return {
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedTilgangerDto", "kanRedigere", "boolean", "null", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisstedTilgangerDto", "praksissted", "MuligePraksisstedDto", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("PraksisstedTilgangerDto", "brukerrolle", "BrukerrollerPSDto", "null", false),
        };
    }
    sampleArrayPraksisstedTilgangerDto(template?: Factory<PraksisstedTilgangerDto>, length?: number): Array<PraksisstedTilgangerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedTilgangerDto")}).map(() => this.samplePraksisstedTilgangerDto(template));
    }
    samplePraksisstedUndernodeDto(template?: Factory<PraksisstedUndernodeDto>): PraksisstedUndernodeDto {
        if (typeof this.sampleModelProperties["PraksisstedUndernodeDto"] === "function") {
            return this.sampleModelProperties["PraksisstedUndernodeDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedUndernodeDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedUndernodeDto", "navn", "string", "DPS, Seksjon Døgn", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("PraksisstedUndernodeDto", "under", "Array<PraksisstedUndernodeDto>", "null", false),
        };
    }
    sampleArrayPraksisstedUndernodeDto(template?: Factory<PraksisstedUndernodeDto>, length?: number): Array<PraksisstedUndernodeDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedUndernodeDto")}).map(() => this.samplePraksisstedUndernodeDto(template));
    }
    samplePraksisstedavtaleAllOfDto(template?: Factory<PraksisstedavtaleAllOfDto>): PraksisstedavtaleAllOfDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleAllOfDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleAllOfDto"](this);
        }

        return {
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleAllOfDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleAllOfDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleAllOfDto(template?: Factory<PraksisstedavtaleAllOfDto>, length?: number): Array<PraksisstedavtaleAllOfDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleAllOfDto")}).map(() => this.samplePraksisstedavtaleAllOfDto(template));
    }
    samplePraksisstedavtaleCommonDto(template?: Factory<PraksisstedavtaleCommonDto>): PraksisstedavtaleCommonDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleCommonDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleCommonDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleCommonDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleCommonDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleCommonDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleCommonDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleCommonDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleCommonDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleCommonDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleCommonDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleCommonDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleCommonDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleCommonDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleCommonDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleCommonDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleCommonDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleCommonDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleCommonDto", "kanEndre", "boolean", "false", false),
        };
    }
    sampleArrayPraksisstedavtaleCommonDto(template?: Factory<PraksisstedavtaleCommonDto>, length?: number): Array<PraksisstedavtaleCommonDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleCommonDto")}).map(() => this.samplePraksisstedavtaleCommonDto(template));
    }
    samplePraksisstedavtaleDto(template?: Factory<PraksisstedavtaleDto>): PraksisstedavtaleDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleDto(template?: Factory<PraksisstedavtaleDto>, length?: number): Array<PraksisstedavtaleDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleDto")}).map(() => this.samplePraksisstedavtaleDto(template));
    }
    samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>): PraksisstedavtaleMedStedForelderHierarkiAllOfDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiAllOfDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiAllOfDto"](this);
        }

        return {
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleMedStedForelderHierarkiAllOfDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleMedStedForelderHierarkiAllOfDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleMedStedForelderHierarkiAllOfDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>, length?: number): Array<PraksisstedavtaleMedStedForelderHierarkiAllOfDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleMedStedForelderHierarkiAllOfDto")}).map(() => this.samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto(template));
    }
    samplePraksisstedavtaleMedStedForelderHierarkiDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto>): PraksisstedavtaleMedStedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleMedStedForelderHierarkiDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto>, length?: number): Array<PraksisstedavtaleMedStedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleMedStedForelderHierarkiDto")}).map(() => this.samplePraksisstedavtaleMedStedForelderHierarkiDto(template));
    }
    samplePraksisstedavtalePostDto(template?: Factory<PraksisstedavtalePostDto>): PraksisstedavtalePostDto {
        if (typeof this.sampleModelProperties["PraksisstedavtalePostDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtalePostDto"](this);
        }

        return {
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtalePostDto", "avtalenavn", "string", "Praksis i musikkpedagogikk", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtalePostDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtalePostDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtalePostDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtalePostDto", "saksansvarlig", "SaksansvarligDto", "null", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtalePostDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedPostDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtalePostDto", "avtalesteder", "Array<AvtalestederMedMuligeOmfattedePraksisstedPostDto>", "null", false),
            praksistypekoder: template && template.praksistypekoder ? (typeof template.praksistypekoder === "function" ? (template.praksistypekoder as Function)(this) : template.praksistypekoder): this.generate("PraksisstedavtalePostDto", "praksistypekoder", "Array<string>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtalePostDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtalePostDto", "delIdentitetsnummer", "boolean", "false", false),
        };
    }
    sampleArrayPraksisstedavtalePostDto(template?: Factory<PraksisstedavtalePostDto>, length?: number): Array<PraksisstedavtalePostDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtalePostDto")}).map(() => this.samplePraksisstedavtalePostDto(template));
    }
    samplePraksisstedavtaleViewDto(template?: EnumFactory<PraksisstedavtaleViewDto>): PraksisstedavtaleViewDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleViewDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleViewDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisstedavtaleViewDto.Praksisstedavtale,
                PraksisstedavtaleViewDto.PraksisstedavtaleMedStedForelderHierarki
        ]);
    }
    sampleArrayPraksisstedavtaleViewDto(template?: EnumFactory<PraksisstedavtaleViewDto>, length?: number): Array<PraksisstedavtaleViewDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleViewDto")}).map(() => this.samplePraksisstedavtaleViewDto());
    }
    samplePraksisstedavtalerDto(template?: Factory<PraksisstedavtalerDto>): PraksisstedavtalerDto {
        if (typeof this.sampleModelProperties["PraksisstedavtalerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtalerDto"](this);
        }

        return {
            avtaler: template && template.avtaler ? (typeof template.avtaler === "function" ? (template.avtaler as Function)(this) : template.avtaler): this.generate("PraksisstedavtalerDto", "avtaler", "Array<PraksisstedavtaleDto>", "null", false),
        };
    }
    sampleArrayPraksisstedavtalerDto(template?: Factory<PraksisstedavtalerDto>, length?: number): Array<PraksisstedavtalerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtalerDto")}).map(() => this.samplePraksisstedavtalerDto(template));
    }
    samplePraksisstedbrukerDto(template?: Factory<PraksisstedbrukerDto>): PraksisstedbrukerDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PraksisstedbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PraksisstedbrukerDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedbrukerDto", "telefonnummer", "string", "12345678", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("PraksisstedbrukerDto", "tilgangsrolle", "BrukerrollerPSDto", "null", false),
            lagtTilAvInstitusjon: template && template.lagtTilAvInstitusjon ? (typeof template.lagtTilAvInstitusjon === "function" ? (template.lagtTilAvInstitusjon as Function)(this) : template.lagtTilAvInstitusjon): this.generate("PraksisstedbrukerDto", "lagtTilAvInstitusjon", "string", "Universitetet i Oslo", false),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("PraksisstedbrukerDto", "deaktivert", "boolean", "null", false),
            plassholder: template && template.plassholder ? (typeof template.plassholder === "function" ? (template.plassholder as Function)(this) : template.plassholder): this.generate("PraksisstedbrukerDto", "plassholder", "boolean", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerDto(template?: Factory<PraksisstedbrukerDto>, length?: number): Array<PraksisstedbrukerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerDto")}).map(() => this.samplePraksisstedbrukerDto(template));
    }
    samplePraksisstedbrukerSignatarDto(template?: Factory<PraksisstedbrukerSignatarDto>): PraksisstedbrukerSignatarDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerSignatarDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerSignatarDto"](this);
        }

        return {
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisstedbrukerSignatarDto", "praksisstedId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PraksisstedbrukerSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PraksisstedbrukerSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedbrukerSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedbrukerSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerSignatarDto(template?: Factory<PraksisstedbrukerSignatarDto>, length?: number): Array<PraksisstedbrukerSignatarDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerSignatarDto")}).map(() => this.samplePraksisstedbrukerSignatarDto(template));
    }
    samplePraksisstedbrukerprofilDto(template?: Factory<PraksisstedbrukerprofilDto>): PraksisstedbrukerprofilDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("PraksisstedbrukerprofilDto", "bruker", "PraksisstedbrukerDto", "null", false),
            praksisstedNavn: template && template.praksisstedNavn ? (typeof template.praksisstedNavn === "function" ? (template.praksisstedNavn as Function)(this) : template.praksisstedNavn): this.generate("PraksisstedbrukerprofilDto", "praksisstedNavn", "string", "Galtvort", false),
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("PraksisstedbrukerprofilDto", "omMeg", "string", "Jeg er veldig glad i øl", false),
            bildeUrl: template && template.bildeUrl ? (typeof template.bildeUrl === "function" ? (template.bildeUrl as Function)(this) : template.bildeUrl): this.generate("PraksisstedbrukerprofilDto", "bildeUrl", "string", "bilde.png", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedbrukerprofilDto", "kanRedigere", "PraksisstedbrukerprofilKanRedigereDto", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("PraksisstedbrukerprofilDto", "tilganger", "Array<PraksisstedTilgangerDto>", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilDto(template?: Factory<PraksisstedbrukerprofilDto>, length?: number): Array<PraksisstedbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilDto")}).map(() => this.samplePraksisstedbrukerprofilDto(template));
    }
    samplePraksisstedbrukerprofilKanRedigereDto(template?: EnumFactory<PraksisstedbrukerprofilKanRedigereDto>): PraksisstedbrukerprofilKanRedigereDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilKanRedigereDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilKanRedigereDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisstedbrukerprofilKanRedigereDto.ProfilOgTilganger,
                PraksisstedbrukerprofilKanRedigereDto.Profil,
                PraksisstedbrukerprofilKanRedigereDto.Ingen
        ]);
    }
    sampleArrayPraksisstedbrukerprofilKanRedigereDto(template?: EnumFactory<PraksisstedbrukerprofilKanRedigereDto>, length?: number): Array<PraksisstedbrukerprofilKanRedigereDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilKanRedigereDto")}).map(() => this.samplePraksisstedbrukerprofilKanRedigereDto());
    }
    samplePraksisstedbrukerprofilPutDto(template?: Factory<PraksisstedbrukerprofilPutDto>): PraksisstedbrukerprofilPutDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilPutDto"](this);
        }

        return {
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("PraksisstedbrukerprofilPutDto", "omMeg", "string", "Vært veileder før", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("PraksisstedbrukerprofilPutDto", "tilganger", "Array<PraksisstedbrukerprofilPutTilgangerInnerDto>", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilPutDto(template?: Factory<PraksisstedbrukerprofilPutDto>, length?: number): Array<PraksisstedbrukerprofilPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilPutDto")}).map(() => this.samplePraksisstedbrukerprofilPutDto(template));
    }
    samplePraksisstedbrukerprofilPutTilgangerInnerDto(template?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto>): PraksisstedbrukerprofilPutTilgangerInnerDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilPutTilgangerInnerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilPutTilgangerInnerDto"](this);
        }

        return {
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisstedbrukerprofilPutTilgangerInnerDto", "praksisstedId", "string", "null", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("PraksisstedbrukerprofilPutTilgangerInnerDto", "tilgangsrolle", "BrukerrollerPSDto", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilPutTilgangerInnerDto(template?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto>, length?: number): Array<PraksisstedbrukerprofilPutTilgangerInnerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilPutTilgangerInnerDto")}).map(() => this.samplePraksisstedbrukerprofilPutTilgangerInnerDto(template));
    }
    samplePraksisstederForAktivitetskravDto(template?: Factory<PraksisstederForAktivitetskravDto>): PraksisstederForAktivitetskravDto {
        if (typeof this.sampleModelProperties["PraksisstederForAktivitetskravDto"] === "function") {
            return this.sampleModelProperties["PraksisstederForAktivitetskravDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstederForAktivitetskravDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstederForAktivitetskravDto", "navn", "string", "Skole A", false),
            oppfyllerKrav: template && template.oppfyllerKrav ? (typeof template.oppfyllerKrav === "function" ? (template.oppfyllerKrav as Function)(this) : template.oppfyllerKrav): this.generate("PraksisstederForAktivitetskravDto", "oppfyllerKrav", "boolean", "null", false),
            undernoder: template && template.undernoder ? (typeof template.undernoder === "function" ? (template.undernoder as Function)(this) : template.undernoder): this.generate("PraksisstederForAktivitetskravDto", "undernoder", "Array<PraksisstederForAktivitetskravDto>", "null", false),
        };
    }
    sampleArrayPraksisstederForAktivitetskravDto(template?: Factory<PraksisstederForAktivitetskravDto>, length?: number): Array<PraksisstederForAktivitetskravDto> {
        return Array.from({length: length || this.arrayLength("PraksisstederForAktivitetskravDto")}).map(() => this.samplePraksisstederForAktivitetskravDto(template));
    }
    samplePraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>): PraksisstedprofilAdresseDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilAdresseDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilAdresseDto"](this);
        }

        return {
            adresselinje1: template && template.adresselinje1 ? (typeof template.adresselinje1 === "function" ? (template.adresselinje1 as Function)(this) : template.adresselinje1): this.generate("PraksisstedprofilAdresseDto", "adresselinje1", "string", "Lorem Ipsum gate 12", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisstedprofilAdresseDto", "adresselinje2", "string", "1. etasje", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("PraksisstedprofilAdresseDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("PraksisstedprofilAdresseDto", "poststed", "string", "Oslo", false),
        };
    }
    sampleArrayPraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>, length?: number): Array<PraksisstedprofilAdresseDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilAdresseDto")}).map(() => this.samplePraksisstedprofilAdresseDto(template));
    }
    samplePraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>): PraksisstedprofilDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedprofilDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedprofilDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("PraksisstedprofilDto", "orgnr", "string", "123423413412", false),
            avdeling: template && template.avdeling ? (typeof template.avdeling === "function" ? (template.avdeling as Function)(this) : template.avdeling): this.generate("PraksisstedprofilDto", "avdeling", "MinimalPraksisstedDto", "null", false),
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("PraksisstedprofilDto", "adresse", "PraksisstedprofilAdresseDto", "null", false),
            nettsideUrl: template && template.nettsideUrl ? (typeof template.nettsideUrl === "function" ? (template.nettsideUrl as Function)(this) : template.nettsideUrl): this.generate("PraksisstedprofilDto", "nettsideUrl", "string", "https://lovisenbergdiakonale.no", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedprofilDto", "epost", "string", "resepsjon@lovisenbergdiakonale.no", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedprofilDto", "telefonnummer", "string", "12345678", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("PraksisstedprofilDto", "telefonlandnr", "string", "+47", false),
            bildeId: template && template.bildeId ? (typeof template.bildeId === "function" ? (template.bildeId as Function)(this) : template.bildeId): this.generate("PraksisstedprofilDto", "bildeId", "string", "null", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedprofilDto", "beskrivelse", "string", "Lorem Ipsum", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisstedprofilDto", "krav", "string", "Personlig egnethet", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("PraksisstedprofilDto", "noder", "PraksisstedprofilNoderDto", "null", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedprofilDto", "kanRedigere", "boolean", "null", false),
            erAdmin: template && template.erAdmin ? (typeof template.erAdmin === "function" ? (template.erAdmin as Function)(this) : template.erAdmin): this.generate("PraksisstedprofilDto", "erAdmin", "boolean", "null", false),
            sistEndret: template && template.sistEndret ? (typeof template.sistEndret === "function" ? (template.sistEndret as Function)(this) : template.sistEndret): this.generate("PraksisstedprofilDto", "sistEndret", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            sistEndretAvStudiestedbruker: template && template.sistEndretAvStudiestedbruker ? (typeof template.sistEndretAvStudiestedbruker === "function" ? (template.sistEndretAvStudiestedbruker as Function)(this) : template.sistEndretAvStudiestedbruker): this.generate("PraksisstedprofilDto", "sistEndretAvStudiestedbruker", "PersonDto", "null", false),
            sistEndretAvPraksisstedbruker: template && template.sistEndretAvPraksisstedbruker ? (typeof template.sistEndretAvPraksisstedbruker === "function" ? (template.sistEndretAvPraksisstedbruker as Function)(this) : template.sistEndretAvPraksisstedbruker): this.generate("PraksisstedprofilDto", "sistEndretAvPraksisstedbruker", "PersonDto", "null", false),
            brukere: template && template.brukere ? (typeof template.brukere === "function" ? (template.brukere as Function)(this) : template.brukere): this.generate("PraksisstedprofilDto", "brukere", "Array<PraksisstedbrukerDto>", "null", false),
        };
    }
    sampleArrayPraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>, length?: number): Array<PraksisstedprofilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilDto")}).map(() => this.samplePraksisstedprofilDto(template));
    }
    samplePraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>): PraksisstedprofilNoderDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilNoderDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("PraksisstedprofilNoderDto", "over", "Array<MinimalPraksisstedDto>", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("PraksisstedprofilNoderDto", "under", "Array<PraksisstedUndernodeDto>", "null", false),
        };
    }
    sampleArrayPraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>, length?: number): Array<PraksisstedprofilNoderDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilNoderDto")}).map(() => this.samplePraksisstedprofilNoderDto(template));
    }
    samplePraksisstedprofilPutDto(template?: Factory<PraksisstedprofilPutDto>): PraksisstedprofilPutDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilPutDto"](this);
        }

        return {
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedprofilPutDto", "beskrivelse", "string", "Lorem Ipsum", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisstedprofilPutDto", "krav", "string", "Personlig egnethet", false),
        };
    }
    sampleArrayPraksisstedprofilPutDto(template?: Factory<PraksisstedprofilPutDto>, length?: number): Array<PraksisstedprofilPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilPutDto")}).map(() => this.samplePraksisstedprofilPutDto(template));
    }
    samplePraksisstedtypeDto(template?: Factory<PraksisstedtypeDto>): PraksisstedtypeDto {
        if (typeof this.sampleModelProperties["PraksisstedtypeDto"] === "function") {
            return this.sampleModelProperties["PraksisstedtypeDto"](this);
        }

        return {
            praksisstedtypekode: template && template.praksisstedtypekode ? (typeof template.praksisstedtypekode === "function" ? (template.praksisstedtypekode as Function)(this) : template.praksisstedtypekode): this.generate("PraksisstedtypeDto", "praksisstedtypekode", "string", "GRSKOLE1-7", false),
            praksisstedtypenavn: template && template.praksisstedtypenavn ? (typeof template.praksisstedtypenavn === "function" ? (template.praksisstedtypenavn as Function)(this) : template.praksisstedtypenavn): this.generate("PraksisstedtypeDto", "praksisstedtypenavn", "string", "Grunnskole 1-7", false),
        };
    }
    sampleArrayPraksisstedtypeDto(template?: Factory<PraksisstedtypeDto>, length?: number): Array<PraksisstedtypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedtypeDto")}).map(() => this.samplePraksisstedtypeDto(template));
    }
    samplePraksistypeDto(template?: Factory<PraksistypeDto>): PraksistypeDto {
        if (typeof this.sampleModelProperties["PraksistypeDto"] === "function") {
            return this.sampleModelProperties["PraksistypeDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("PraksistypeDto", "kode", "string", "ABC123", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksistypeDto", "navn", "string", "Grunnleggende sykepleie", false),
        };
    }
    sampleArrayPraksistypeDto(template?: Factory<PraksistypeDto>, length?: number): Array<PraksistypeDto> {
        return Array.from({length: length || this.arrayLength("PraksistypeDto")}).map(() => this.samplePraksistypeDto(template));
    }
    samplePraksistypeMedAktivitetskravDto(template?: Factory<PraksistypeMedAktivitetskravDto>): PraksistypeMedAktivitetskravDto {
        if (typeof this.sampleModelProperties["PraksistypeMedAktivitetskravDto"] === "function") {
            return this.sampleModelProperties["PraksistypeMedAktivitetskravDto"](this);
        }

        return {
            praksistype: template && template.praksistype ? (typeof template.praksistype === "function" ? (template.praksistype as Function)(this) : template.praksistype): this.generate("PraksistypeMedAktivitetskravDto", "praksistype", "PraksistypeDto", "null", false),
            aktivitetskrav: template && template.aktivitetskrav ? (typeof template.aktivitetskrav === "function" ? (template.aktivitetskrav as Function)(this) : template.aktivitetskrav): this.generate("PraksistypeMedAktivitetskravDto", "aktivitetskrav", "Array<AktivitetskravDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksistypeMedAktivitetskravDto", "kanEndre", "boolean", "null", false),
        };
    }
    sampleArrayPraksistypeMedAktivitetskravDto(template?: Factory<PraksistypeMedAktivitetskravDto>, length?: number): Array<PraksistypeMedAktivitetskravDto> {
        return Array.from({length: length || this.arrayLength("PraksistypeMedAktivitetskravDto")}).map(() => this.samplePraksistypeMedAktivitetskravDto(template));
    }
    samplePraksistypeMedEmnerDto(template?: Factory<PraksistypeMedEmnerDto>): PraksistypeMedEmnerDto {
        if (typeof this.sampleModelProperties["PraksistypeMedEmnerDto"] === "function") {
            return this.sampleModelProperties["PraksistypeMedEmnerDto"](this);
        }

        return {
            praksistype: template && template.praksistype ? (typeof template.praksistype === "function" ? (template.praksistype as Function)(this) : template.praksistype): this.generate("PraksistypeMedEmnerDto", "praksistype", "PraksistypeDto", "null", false),
            emner: template && template.emner ? (typeof template.emner === "function" ? (template.emner as Function)(this) : template.emner): this.generate("PraksistypeMedEmnerDto", "emner", "Array<EmneDto>", "null", false),
        };
    }
    sampleArrayPraksistypeMedEmnerDto(template?: Factory<PraksistypeMedEmnerDto>, length?: number): Array<PraksistypeMedEmnerDto> {
        return Array.from({length: length || this.arrayLength("PraksistypeMedEmnerDto")}).map(() => this.samplePraksistypeMedEmnerDto(template));
    }
    sampleRegistreringsStatusDto(template?: EnumFactory<RegistreringsStatusDto>): RegistreringsStatusDto {
        if (typeof this.sampleModelProperties["RegistreringsStatusDto"] === "function") {
            return this.sampleModelProperties["RegistreringsStatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                RegistreringsStatusDto.Avmeldt,
                RegistreringsStatusDto.IkkeRegistrert,
                RegistreringsStatusDto.Registrert
        ]);
    }
    sampleArrayRegistreringsStatusDto(template?: EnumFactory<RegistreringsStatusDto>, length?: number): Array<RegistreringsStatusDto> {
        return Array.from({length: length || this.arrayLength("RegistreringsStatusDto")}).map(() => this.sampleRegistreringsStatusDto());
    }
    sampleRolleDto(template?: Factory<RolleDto>): RolleDto {
        if (typeof this.sampleModelProperties["RolleDto"] === "function") {
            return this.sampleModelProperties["RolleDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("RolleDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("RolleDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("RolleDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("RolleDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("RolleDto", "telefonnummer", "string", "12345678", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("RolleDto", "type", "RolleTypeDto", "null", false),
            slettet: template && template.slettet ? (typeof template.slettet === "function" ? (template.slettet as Function)(this) : template.slettet): this.generate("RolleDto", "slettet", "boolean", "false", false),
        };
    }
    sampleArrayRolleDto(template?: Factory<RolleDto>, length?: number): Array<RolleDto> {
        return Array.from({length: length || this.arrayLength("RolleDto")}).map(() => this.sampleRolleDto(template));
    }
    sampleRolleTypeDto(template?: Factory<RolleTypeDto>): RolleTypeDto {
        if (typeof this.sampleModelProperties["RolleTypeDto"] === "function") {
            return this.sampleModelProperties["RolleTypeDto"](this);
        }

        return {
            studiestedrolle: template && template.studiestedrolle ? (typeof template.studiestedrolle === "function" ? (template.studiestedrolle as Function)(this) : template.studiestedrolle): this.generate("RolleTypeDto", "studiestedrolle", "StudiestedRollerDto", "null", false),
            praksisstedrolle: template && template.praksisstedrolle ? (typeof template.praksisstedrolle === "function" ? (template.praksisstedrolle as Function)(this) : template.praksisstedrolle): this.generate("RolleTypeDto", "praksisstedrolle", "PraksisstedRollerDto", "null", false),
        };
    }
    sampleArrayRolleTypeDto(template?: Factory<RolleTypeDto>, length?: number): Array<RolleTypeDto> {
        return Array.from({length: length || this.arrayLength("RolleTypeDto")}).map(() => this.sampleRolleTypeDto(template));
    }
    sampleSaksansvarligDto(template?: Factory<SaksansvarligDto>): SaksansvarligDto {
        if (typeof this.sampleModelProperties["SaksansvarligDto"] === "function") {
            return this.sampleModelProperties["SaksansvarligDto"](this);
        }

        return {
            studiestedbrukerId: template && template.studiestedbrukerId ? (typeof template.studiestedbrukerId === "function" ? (template.studiestedbrukerId as Function)(this) : template.studiestedbrukerId): this.generate("SaksansvarligDto", "studiestedbrukerId", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("SaksansvarligDto", "navn", "string", "Annbjørg Bjørgen", false),
        };
    }
    sampleArraySaksansvarligDto(template?: Factory<SaksansvarligDto>, length?: number): Array<SaksansvarligDto> {
        return Array.from({length: length || this.arrayLength("SaksansvarligDto")}).map(() => this.sampleSaksansvarligDto(template));
    }
    sampleStudentVurderingDto(template?: Factory<StudentVurderingDto>): StudentVurderingDto {
        if (typeof this.sampleModelProperties["StudentVurderingDto"] === "function") {
            return this.sampleModelProperties["StudentVurderingDto"](this);
        }

        return {
            studentVurderingId: template && template.studentVurderingId ? (typeof template.studentVurderingId === "function" ? (template.studentVurderingId as Function)(this) : template.studentVurderingId): this.generate("StudentVurderingDto", "studentVurderingId", "string", "9251b7fc-011d-11ed-a72e-03e4c1502862", false),
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("StudentVurderingDto", "student", "VurderingStudentDto", "null", false),
            vurderingsstatus: template && template.vurderingsstatus ? (typeof template.vurderingsstatus === "function" ? (template.vurderingsstatus as Function)(this) : template.vurderingsstatus): this.pickOne([StudentVurderingDtoVurderingsstatusDtoEnum.Aktiv,StudentVurderingDtoVurderingsstatusDtoEnum.AvbruttPraksis,StudentVurderingDtoVurderingsstatusDtoEnum.PraksisFullfrt]),
            studiestedNavn: template && template.studiestedNavn ? (typeof template.studiestedNavn === "function" ? (template.studiestedNavn as Function)(this) : template.studiestedNavn): this.generate("StudentVurderingDto", "studiestedNavn", "string", "null", false),
        };
    }
    sampleArrayStudentVurderingDto(template?: Factory<StudentVurderingDto>, length?: number): Array<StudentVurderingDto> {
        return Array.from({length: length || this.arrayLength("StudentVurderingDto")}).map(() => this.sampleStudentVurderingDto(template));
    }
    sampleStudentbrukerDto(template?: Factory<StudentbrukerDto>): StudentbrukerDto {
        if (typeof this.sampleModelProperties["StudentbrukerDto"] === "function") {
            return this.sampleModelProperties["StudentbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudentbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudentbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudentbrukerDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudentbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudentbrukerDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayStudentbrukerDto(template?: Factory<StudentbrukerDto>, length?: number): Array<StudentbrukerDto> {
        return Array.from({length: length || this.arrayLength("StudentbrukerDto")}).map(() => this.sampleStudentbrukerDto(template));
    }
    sampleStudentbrukerprofilDto(template?: Factory<StudentbrukerprofilDto>): StudentbrukerprofilDto {
        if (typeof this.sampleModelProperties["StudentbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["StudentbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("StudentbrukerprofilDto", "bruker", "StudentbrukerDto", "null", false),
        };
    }
    sampleArrayStudentbrukerprofilDto(template?: Factory<StudentbrukerprofilDto>, length?: number): Array<StudentbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("StudentbrukerprofilDto")}).map(() => this.sampleStudentbrukerprofilDto(template));
    }
    sampleStudenterForVurderingDto(template?: Factory<StudenterForVurderingDto>): StudenterForVurderingDto {
        if (typeof this.sampleModelProperties["StudenterForVurderingDto"] === "function") {
            return this.sampleModelProperties["StudenterForVurderingDto"](this);
        }

        return {
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("StudenterForVurderingDto", "studenter", "Array<StudentVurderingDto>", "null", false),
        };
    }
    sampleArrayStudenterForVurderingDto(template?: Factory<StudenterForVurderingDto>, length?: number): Array<StudenterForVurderingDto> {
        return Array.from({length: length || this.arrayLength("StudenterForVurderingDto")}).map(() => this.sampleStudenterForVurderingDto(template));
    }
    sampleStudenterMedKlasseDto(template?: Factory<StudenterMedKlasseDto>): StudenterMedKlasseDto {
        if (typeof this.sampleModelProperties["StudenterMedKlasseDto"] === "function") {
            return this.sampleModelProperties["StudenterMedKlasseDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudenterMedKlasseDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudenterMedKlasseDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudenterMedKlasseDto", "etternavn", "string", "Nordmann", false),
            fsKlasse: template && template.fsKlasse ? (typeof template.fsKlasse === "function" ? (template.fsKlasse as Function)(this) : template.fsKlasse): this.generate("StudenterMedKlasseDto", "fsKlasse", "string", "2019-A", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("StudenterMedKlasseDto", "klasse", "PraksisklasseDto", "null", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("StudenterMedKlasseDto", "status", "RegistreringsStatusDto", "null", false),
        };
    }
    sampleArrayStudenterMedKlasseDto(template?: Factory<StudenterMedKlasseDto>, length?: number): Array<StudenterMedKlasseDto> {
        return Array.from({length: length || this.arrayLength("StudenterMedKlasseDto")}).map(() => this.sampleStudenterMedKlasseDto(template));
    }
    sampleStudentfordelingDto(template?: Factory<StudentfordelingDto>): StudentfordelingDto {
        if (typeof this.sampleModelProperties["StudentfordelingDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingDto"](this);
        }

        return {
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("StudentfordelingDto", "student", "PersonDto", "null", false),
            undervisere: template && template.undervisere ? (typeof template.undervisere === "function" ? (template.undervisere as Function)(this) : template.undervisere): this.generate("StudentfordelingDto", "undervisere", "Array<PersonDto>", "null", false),
            veiledere: template && template.veiledere ? (typeof template.veiledere === "function" ? (template.veiledere as Function)(this) : template.veiledere): this.generate("StudentfordelingDto", "veiledere", "Array<PersonDto>", "null", false),
            praksisplass: template && template.praksisplass ? (typeof template.praksisplass === "function" ? (template.praksisplass as Function)(this) : template.praksisplass): this.generate("StudentfordelingDto", "praksisplass", "PraksisstedByAvtaleIdDto", "null", false),
            onskeliste: template && template.onskeliste ? (typeof template.onskeliste === "function" ? (template.onskeliste as Function)(this) : template.onskeliste): this.generate("StudentfordelingDto", "onskeliste", "Array<MinimalPraksisstedDto>", "null", false),
            hasValideringsfeil: template && template.hasValideringsfeil ? (typeof template.hasValideringsfeil === "function" ? (template.hasValideringsfeil as Function)(this) : template.hasValideringsfeil): this.generate("StudentfordelingDto", "hasValideringsfeil", "boolean", "null", false),
        };
    }
    sampleArrayStudentfordelingDto(template?: Factory<StudentfordelingDto>, length?: number): Array<StudentfordelingDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingDto")}).map(() => this.sampleStudentfordelingDto(template));
    }
    sampleStudentfordelingMedValgDto(template?: Factory<StudentfordelingMedValgDto>): StudentfordelingMedValgDto {
        if (typeof this.sampleModelProperties["StudentfordelingMedValgDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingMedValgDto"](this);
        }

        return {
            studentfordeling: template && template.studentfordeling ? (typeof template.studentfordeling === "function" ? (template.studentfordeling as Function)(this) : template.studentfordeling): this.generate("StudentfordelingMedValgDto", "studentfordeling", "Array<StudentfordelingDto>", "null", false),
            muligeUndervisere: template && template.muligeUndervisere ? (typeof template.muligeUndervisere === "function" ? (template.muligeUndervisere as Function)(this) : template.muligeUndervisere): this.generate("StudentfordelingMedValgDto", "muligeUndervisere", "Array<PersonDto>", "null", false),
            muligePraksissteder: template && template.muligePraksissteder ? (typeof template.muligePraksissteder === "function" ? (template.muligePraksissteder as Function)(this) : template.muligePraksissteder): this.generate("StudentfordelingMedValgDto", "muligePraksissteder", "Array<PraksisstedTilFordelingDto>", "null", false),
        };
    }
    sampleArrayStudentfordelingMedValgDto(template?: Factory<StudentfordelingMedValgDto>, length?: number): Array<StudentfordelingMedValgDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingMedValgDto")}).map(() => this.sampleStudentfordelingMedValgDto(template));
    }
    sampleStudentfordelingPutDto(template?: Factory<StudentfordelingPutDto>): StudentfordelingPutDto {
        if (typeof this.sampleModelProperties["StudentfordelingPutDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingPutDto"](this);
        }

        return {
            studentId: template && template.studentId ? (typeof template.studentId === "function" ? (template.studentId as Function)(this) : template.studentId): this.generate("StudentfordelingPutDto", "studentId", "string", "null", false),
            underviserIder: template && template.underviserIder ? (typeof template.underviserIder === "function" ? (template.underviserIder as Function)(this) : template.underviserIder): this.generate("StudentfordelingPutDto", "underviserIder", "Array<string>", "null", false),
            praksisplassId: template && template.praksisplassId ? (typeof template.praksisplassId === "function" ? (template.praksisplassId as Function)(this) : template.praksisplassId): this.generate("StudentfordelingPutDto", "praksisplassId", "string", "null", false),
            veilederIder: template && template.veilederIder ? (typeof template.veilederIder === "function" ? (template.veilederIder as Function)(this) : template.veilederIder): this.generate("StudentfordelingPutDto", "veilederIder", "Array<string>", "null", false),
        };
    }
    sampleArrayStudentfordelingPutDto(template?: Factory<StudentfordelingPutDto>, length?: number): Array<StudentfordelingPutDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingPutDto")}).map(() => this.sampleStudentfordelingPutDto(template));
    }
    sampleStudentregistreringDto(template?: Factory<StudentregistreringDto>): StudentregistreringDto {
        if (typeof this.sampleModelProperties["StudentregistreringDto"] === "function") {
            return this.sampleModelProperties["StudentregistreringDto"](this);
        }

        return {
            muligeKlasser: template && template.muligeKlasser ? (typeof template.muligeKlasser === "function" ? (template.muligeKlasser as Function)(this) : template.muligeKlasser): this.generate("StudentregistreringDto", "muligeKlasser", "Array<PraksisklasseDto>", "null", false),
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("StudentregistreringDto", "studenter", "Array<StudenterMedKlasseDto>", "null", false),
        };
    }
    sampleArrayStudentregistreringDto(template?: Factory<StudentregistreringDto>, length?: number): Array<StudentregistreringDto> {
        return Array.from({length: length || this.arrayLength("StudentregistreringDto")}).map(() => this.sampleStudentregistreringDto(template));
    }
    sampleStudentregistreringPutDto(template?: Factory<StudentregistreringPutDto>): StudentregistreringPutDto {
        if (typeof this.sampleModelProperties["StudentregistreringPutDto"] === "function") {
            return this.sampleModelProperties["StudentregistreringPutDto"](this);
        }

        return {
            studentId: template && template.studentId ? (typeof template.studentId === "function" ? (template.studentId as Function)(this) : template.studentId): this.generate("StudentregistreringPutDto", "studentId", "string", "null", false),
            klasseId: template && template.klasseId ? (typeof template.klasseId === "function" ? (template.klasseId as Function)(this) : template.klasseId): this.generate("StudentregistreringPutDto", "klasseId", "string", "null", false),
        };
    }
    sampleArrayStudentregistreringPutDto(template?: Factory<StudentregistreringPutDto>, length?: number): Array<StudentregistreringPutDto> {
        return Array.from({length: length || this.arrayLength("StudentregistreringPutDto")}).map(() => this.sampleStudentregistreringPutDto(template));
    }
    sampleStudentregistreringPutWrappedDto(template?: Factory<StudentregistreringPutWrappedDto>): StudentregistreringPutWrappedDto {
        if (typeof this.sampleModelProperties["StudentregistreringPutWrappedDto"] === "function") {
            return this.sampleModelProperties["StudentregistreringPutWrappedDto"](this);
        }

        return {
            wrapped: template && template.wrapped ? (typeof template.wrapped === "function" ? (template.wrapped as Function)(this) : template.wrapped): this.generate("StudentregistreringPutWrappedDto", "wrapped", "Array<StudentregistreringPutDto>", "null", false),
        };
    }
    sampleArrayStudentregistreringPutWrappedDto(template?: Factory<StudentregistreringPutWrappedDto>, length?: number): Array<StudentregistreringPutWrappedDto> {
        return Array.from({length: length || this.arrayLength("StudentregistreringPutWrappedDto")}).map(() => this.sampleStudentregistreringPutWrappedDto(template));
    }
    sampleStudiestedDto(template?: Factory<StudiestedDto>): StudiestedDto {
        if (typeof this.sampleModelProperties["StudiestedDto"] === "function") {
            return this.sampleModelProperties["StudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudiestedDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("StudiestedDto", "navn", "Array<string>", "[Avdeling, Sengepost]", false),
        };
    }
    sampleArrayStudiestedDto(template?: Factory<StudiestedDto>, length?: number): Array<StudiestedDto> {
        return Array.from({length: length || this.arrayLength("StudiestedDto")}).map(() => this.sampleStudiestedDto(template));
    }
    sampleStudiestedRollerDto(template?: EnumFactory<StudiestedRollerDto>): StudiestedRollerDto {
        if (typeof this.sampleModelProperties["StudiestedRollerDto"] === "function") {
            return this.sampleModelProperties["StudiestedRollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                StudiestedRollerDto.Koordinator,
                StudiestedRollerDto.Underviser
        ]);
    }
    sampleArrayStudiestedRollerDto(template?: EnumFactory<StudiestedRollerDto>, length?: number): Array<StudiestedRollerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedRollerDto")}).map(() => this.sampleStudiestedRollerDto());
    }
    sampleStudiestedTilgangerDto(template?: Factory<StudiestedTilgangerDto>): StudiestedTilgangerDto {
        if (typeof this.sampleModelProperties["StudiestedTilgangerDto"] === "function") {
            return this.sampleModelProperties["StudiestedTilgangerDto"](this);
        }

        return {
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("StudiestedTilgangerDto", "kanRedigere", "boolean", "null", false),
            studiested: template && template.studiested ? (typeof template.studiested === "function" ? (template.studiested as Function)(this) : template.studiested): this.generate("StudiestedTilgangerDto", "studiested", "MuligeStudiestedDto", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("StudiestedTilgangerDto", "brukerrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayStudiestedTilgangerDto(template?: Factory<StudiestedTilgangerDto>, length?: number): Array<StudiestedTilgangerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedTilgangerDto")}).map(() => this.sampleStudiestedTilgangerDto(template));
    }
    sampleStudiestedbrukerDto(template?: Factory<StudiestedbrukerDto>): StudiestedbrukerDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudiestedbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudiestedbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudiestedbrukerDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudiestedbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudiestedbrukerDto", "telefonnummer", "string", "12345678", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("StudiestedbrukerDto", "tilgangsrolle", "BrukerrollerDto", "null", false),
            tilhorighet: template && template.tilhorighet ? (typeof template.tilhorighet === "function" ? (template.tilhorighet as Function)(this) : template.tilhorighet): this.generate("StudiestedbrukerDto", "tilhorighet", "StudiestedTilgangerDto", "null", false),
            kanSlette: template && template.kanSlette ? (typeof template.kanSlette === "function" ? (template.kanSlette as Function)(this) : template.kanSlette): this.generate("StudiestedbrukerDto", "kanSlette", "boolean", "null", false),
        };
    }
    sampleArrayStudiestedbrukerDto(template?: Factory<StudiestedbrukerDto>, length?: number): Array<StudiestedbrukerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerDto")}).map(() => this.sampleStudiestedbrukerDto(template));
    }
    sampleStudiestedbrukerSignatarDto(template?: Factory<StudiestedbrukerSignatarDto>): StudiestedbrukerSignatarDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerSignatarDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerSignatarDto"](this);
        }

        return {
            studiestedId: template && template.studiestedId ? (typeof template.studiestedId === "function" ? (template.studiestedId as Function)(this) : template.studiestedId): this.generate("StudiestedbrukerSignatarDto", "studiestedId", "string", "null", false),
            studiestedbrukerId: template && template.studiestedbrukerId ? (typeof template.studiestedbrukerId === "function" ? (template.studiestedbrukerId as Function)(this) : template.studiestedbrukerId): this.generate("StudiestedbrukerSignatarDto", "studiestedbrukerId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudiestedbrukerSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudiestedbrukerSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudiestedbrukerSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudiestedbrukerSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayStudiestedbrukerSignatarDto(template?: Factory<StudiestedbrukerSignatarDto>, length?: number): Array<StudiestedbrukerSignatarDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerSignatarDto")}).map(() => this.sampleStudiestedbrukerSignatarDto(template));
    }
    sampleStudiestedbrukerprofilDto(template?: Factory<StudiestedbrukerprofilDto>): StudiestedbrukerprofilDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("StudiestedbrukerprofilDto", "bruker", "StudiestedbrukerDto", "null", false),
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("StudiestedbrukerprofilDto", "omMeg", "string", "Jeg er veldig glad i øl", false),
            bildeUrl: template && template.bildeUrl ? (typeof template.bildeUrl === "function" ? (template.bildeUrl as Function)(this) : template.bildeUrl): this.generate("StudiestedbrukerprofilDto", "bildeUrl", "string", "bilde.png", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("StudiestedbrukerprofilDto", "kanRedigere", "boolean", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("StudiestedbrukerprofilDto", "tilganger", "Array<StudiestedTilgangerDto>", "null", false),
        };
    }
    sampleArrayStudiestedbrukerprofilDto(template?: Factory<StudiestedbrukerprofilDto>, length?: number): Array<StudiestedbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerprofilDto")}).map(() => this.sampleStudiestedbrukerprofilDto(template));
    }
    sampleStudiestedbrukerprofilPutDto(template?: Factory<StudiestedbrukerprofilPutDto>): StudiestedbrukerprofilPutDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerprofilPutDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerprofilPutDto"](this);
        }

        return {
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("StudiestedbrukerprofilPutDto", "omMeg", "string", "Jeg liker vin også", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudiestedbrukerprofilPutDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudiestedbrukerprofilPutDto", "telefonnummer", "string", "12345678", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("StudiestedbrukerprofilPutDto", "tilganger", "Array<StudiestedbrukerprofilPutTilgangerInnerDto>", "null", false),
        };
    }
    sampleArrayStudiestedbrukerprofilPutDto(template?: Factory<StudiestedbrukerprofilPutDto>, length?: number): Array<StudiestedbrukerprofilPutDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerprofilPutDto")}).map(() => this.sampleStudiestedbrukerprofilPutDto(template));
    }
    sampleStudiestedbrukerprofilPutTilgangerInnerDto(template?: Factory<StudiestedbrukerprofilPutTilgangerInnerDto>): StudiestedbrukerprofilPutTilgangerInnerDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerprofilPutTilgangerInnerDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerprofilPutTilgangerInnerDto"](this);
        }

        return {
            studiestedId: template && template.studiestedId ? (typeof template.studiestedId === "function" ? (template.studiestedId as Function)(this) : template.studiestedId): this.generate("StudiestedbrukerprofilPutTilgangerInnerDto", "studiestedId", "string", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("StudiestedbrukerprofilPutTilgangerInnerDto", "brukerrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayStudiestedbrukerprofilPutTilgangerInnerDto(template?: Factory<StudiestedbrukerprofilPutTilgangerInnerDto>, length?: number): Array<StudiestedbrukerprofilPutTilgangerInnerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerprofilPutTilgangerInnerDto")}).map(() => this.sampleStudiestedbrukerprofilPutTilgangerInnerDto(template));
    }
    sampleUndervisningsenhetPeriodeDto(template?: Factory<UndervisningsenhetPeriodeDto>): UndervisningsenhetPeriodeDto {
        if (typeof this.sampleModelProperties["UndervisningsenhetPeriodeDto"] === "function") {
            return this.sampleModelProperties["UndervisningsenhetPeriodeDto"](this);
        }

        return {
            undervisningsenhetId: template && template.undervisningsenhetId ? (typeof template.undervisningsenhetId === "function" ? (template.undervisningsenhetId as Function)(this) : template.undervisningsenhetId): this.generate("UndervisningsenhetPeriodeDto", "undervisningsenhetId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            start: template && template.start ? (typeof template.start === "function" ? (template.start as Function)(this) : template.start): this.generate("UndervisningsenhetPeriodeDto", "start", "number", "1580143106014", false),
            slutt: template && template.slutt ? (typeof template.slutt === "function" ? (template.slutt as Function)(this) : template.slutt): this.generate("UndervisningsenhetPeriodeDto", "slutt", "number", "1580143106014", false),
        };
    }
    sampleArrayUndervisningsenhetPeriodeDto(template?: Factory<UndervisningsenhetPeriodeDto>, length?: number): Array<UndervisningsenhetPeriodeDto> {
        return Array.from({length: length || this.arrayLength("UndervisningsenhetPeriodeDto")}).map(() => this.sampleUndervisningsenhetPeriodeDto(template));
    }
    sampleUndervisningsenhetToPraksisklasseMedAktiviteterDto(template?: Factory<UndervisningsenhetToPraksisklasseMedAktiviteterDto>): UndervisningsenhetToPraksisklasseMedAktiviteterDto {
        if (typeof this.sampleModelProperties["UndervisningsenhetToPraksisklasseMedAktiviteterDto"] === "function") {
            return this.sampleModelProperties["UndervisningsenhetToPraksisklasseMedAktiviteterDto"](this);
        }

        return {
            undervisningsenhetPeriode: template && template.undervisningsenhetPeriode ? (typeof template.undervisningsenhetPeriode === "function" ? (template.undervisningsenhetPeriode as Function)(this) : template.undervisningsenhetPeriode): this.generate("UndervisningsenhetToPraksisklasseMedAktiviteterDto", "undervisningsenhetPeriode", "UndervisningsenhetPeriodeDto", "null", false),
            praksisklasseMedAktiviteter: template && template.praksisklasseMedAktiviteter ? (typeof template.praksisklasseMedAktiviteter === "function" ? (template.praksisklasseMedAktiviteter as Function)(this) : template.praksisklasseMedAktiviteter): this.generate("UndervisningsenhetToPraksisklasseMedAktiviteterDto", "praksisklasseMedAktiviteter", "Array<PraksisklasseMedAktiviteterDto>", "null", false),
        };
    }
    sampleArrayUndervisningsenhetToPraksisklasseMedAktiviteterDto(template?: Factory<UndervisningsenhetToPraksisklasseMedAktiviteterDto>, length?: number): Array<UndervisningsenhetToPraksisklasseMedAktiviteterDto> {
        return Array.from({length: length || this.arrayLength("UndervisningsenhetToPraksisklasseMedAktiviteterDto")}).map(() => this.sampleUndervisningsenhetToPraksisklasseMedAktiviteterDto(template));
    }
    sampleVurderingKommentarerDto(template?: Factory<VurderingKommentarerDto>): VurderingKommentarerDto {
        if (typeof this.sampleModelProperties["VurderingKommentarerDto"] === "function") {
            return this.sampleModelProperties["VurderingKommentarerDto"](this);
        }

        return {
            laeringsutbytteMedRollersKommentar: template && template.laeringsutbytteMedRollersKommentar ? (typeof template.laeringsutbytteMedRollersKommentar === "function" ? (template.laeringsutbytteMedRollersKommentar as Function)(this) : template.laeringsutbytteMedRollersKommentar): this.generate("VurderingKommentarerDto", "laeringsutbytteMedRollersKommentar", "Array<LaeringsutbytteMedRollersKommentarDto>", "null", false),
        };
    }
    sampleArrayVurderingKommentarerDto(template?: Factory<VurderingKommentarerDto>, length?: number): Array<VurderingKommentarerDto> {
        return Array.from({length: length || this.arrayLength("VurderingKommentarerDto")}).map(() => this.sampleVurderingKommentarerDto(template));
    }
    sampleVurderingOppsummeringDto(template?: Factory<VurderingOppsummeringDto>): VurderingOppsummeringDto {
        if (typeof this.sampleModelProperties["VurderingOppsummeringDto"] === "function") {
            return this.sampleModelProperties["VurderingOppsummeringDto"](this);
        }

        return {
            oppsummering: template && template.oppsummering ? (typeof template.oppsummering === "function" ? (template.oppsummering as Function)(this) : template.oppsummering): this.generate("VurderingOppsummeringDto", "oppsummering", "string", "Studenten gjorde en god jobb.", false),
            ikkeBestatt: template && template.ikkeBestatt ? (typeof template.ikkeBestatt === "function" ? (template.ikkeBestatt as Function)(this) : template.ikkeBestatt): this.generate("VurderingOppsummeringDto", "ikkeBestatt", "boolean", "null", false),
            samletVurderingDelt: template && template.samletVurderingDelt ? (typeof template.samletVurderingDelt === "function" ? (template.samletVurderingDelt as Function)(this) : template.samletVurderingDelt): this.generate("VurderingOppsummeringDto", "samletVurderingDelt", "boolean", "null", false),
            vurderingBekreftet: template && template.vurderingBekreftet ? (typeof template.vurderingBekreftet === "function" ? (template.vurderingBekreftet as Function)(this) : template.vurderingBekreftet): this.generate("VurderingOppsummeringDto", "vurderingBekreftet", "boolean", "null", false),
            timerFravaer: template && template.timerFravaer ? (typeof template.timerFravaer === "function" ? (template.timerFravaer as Function)(this) : template.timerFravaer): this.generate("VurderingOppsummeringDto", "timerFravaer", "number", "null", false),
        };
    }
    sampleArrayVurderingOppsummeringDto(template?: Factory<VurderingOppsummeringDto>, length?: number): Array<VurderingOppsummeringDto> {
        return Array.from({length: length || this.arrayLength("VurderingOppsummeringDto")}).map(() => this.sampleVurderingOppsummeringDto(template));
    }
    sampleVurderingStudentDto(template?: Factory<VurderingStudentDto>): VurderingStudentDto {
        if (typeof this.sampleModelProperties["VurderingStudentDto"] === "function") {
            return this.sampleModelProperties["VurderingStudentDto"](this);
        }

        return {
            fsStudentId: template && template.fsStudentId ? (typeof template.fsStudentId === "function" ? (template.fsStudentId as Function)(this) : template.fsStudentId): this.generate("VurderingStudentDto", "fsStudentId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("VurderingStudentDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("VurderingStudentDto", "etternavn", "string", "Nordmann", false),
            studentnr: template && template.studentnr ? (typeof template.studentnr === "function" ? (template.studentnr as Function)(this) : template.studentnr): this.generate("VurderingStudentDto", "studentnr", "number", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("VurderingStudentDto", "epost", "string", "user@example.com", false),
            telefon: template && template.telefon ? (typeof template.telefon === "function" ? (template.telefon as Function)(this) : template.telefon): this.generate("VurderingStudentDto", "telefon", "string", "12345678", false),
        };
    }
    sampleArrayVurderingStudentDto(template?: Factory<VurderingStudentDto>, length?: number): Array<VurderingStudentDto> {
        return Array.from({length: length || this.arrayLength("VurderingStudentDto")}).map(() => this.sampleVurderingStudentDto(template));
    }
    sampleVurderingsinnstillingerDto(template?: Factory<VurderingsinnstillingerDto>): VurderingsinnstillingerDto {
        if (typeof this.sampleModelProperties["VurderingsinnstillingerDto"] === "function") {
            return this.sampleModelProperties["VurderingsinnstillingerDto"](this);
        }

        return {
            roller: template && template.roller ? (typeof template.roller === "function" ? (template.roller as Function)(this) : template.roller): this.generate("VurderingsinnstillingerDto", "roller", "VurderingsrollerDto", "null", false),
            vurderingstyper: template && template.vurderingstyper ? (typeof template.vurderingstyper === "function" ? (template.vurderingstyper as Function)(this) : template.vurderingstyper): this.generate("VurderingsinnstillingerDto", "vurderingstyper", "VurderingstyperDto", "null", false),
            usesVurdering: template && template.usesVurdering ? (typeof template.usesVurdering === "function" ? (template.usesVurdering as Function)(this) : template.usesVurdering): this.generate("VurderingsinnstillingerDto", "usesVurdering", "boolean", "null", false),
        };
    }
    sampleArrayVurderingsinnstillingerDto(template?: Factory<VurderingsinnstillingerDto>, length?: number): Array<VurderingsinnstillingerDto> {
        return Array.from({length: length || this.arrayLength("VurderingsinnstillingerDto")}).map(() => this.sampleVurderingsinnstillingerDto(template));
    }
    sampleVurderingskriterieDto(template?: Factory<VurderingskriterieDto>): VurderingskriterieDto {
        if (typeof this.sampleModelProperties["VurderingskriterieDto"] === "function") {
            return this.sampleModelProperties["VurderingskriterieDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("VurderingskriterieDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("VurderingskriterieDto", "navn", "string", "Middelmådig måloppnåelse", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("VurderingskriterieDto", "beskrivelse", "string", "Studenten preges av en tydelig middelmådighet i sin måloppnåelse.", false),
        };
    }
    sampleArrayVurderingskriterieDto(template?: Factory<VurderingskriterieDto>, length?: number): Array<VurderingskriterieDto> {
        return Array.from({length: length || this.arrayLength("VurderingskriterieDto")}).map(() => this.sampleVurderingskriterieDto(template));
    }
    sampleVurderingsrollerDto(template?: Factory<VurderingsrollerDto>): VurderingsrollerDto {
        if (typeof this.sampleModelProperties["VurderingsrollerDto"] === "function") {
            return this.sampleModelProperties["VurderingsrollerDto"](this);
        }

        return {
            underviser: template && template.underviser ? (typeof template.underviser === "function" ? (template.underviser as Function)(this) : template.underviser): this.generate("VurderingsrollerDto", "underviser", "boolean", "null", false),
            veileder: template && template.veileder ? (typeof template.veileder === "function" ? (template.veileder as Function)(this) : template.veileder): this.generate("VurderingsrollerDto", "veileder", "boolean", "null", false),
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("VurderingsrollerDto", "student", "boolean", "null", false),
        };
    }
    sampleArrayVurderingsrollerDto(template?: Factory<VurderingsrollerDto>, length?: number): Array<VurderingsrollerDto> {
        return Array.from({length: length || this.arrayLength("VurderingsrollerDto")}).map(() => this.sampleVurderingsrollerDto(template));
    }
    sampleVurderingstyperDto(template?: Factory<VurderingstyperDto>): VurderingstyperDto {
        if (typeof this.sampleModelProperties["VurderingstyperDto"] === "function") {
            return this.sampleModelProperties["VurderingstyperDto"](this);
        }

        return {
            kontinuerlig: template && template.kontinuerlig ? (typeof template.kontinuerlig === "function" ? (template.kontinuerlig as Function)(this) : template.kontinuerlig): this.generate("VurderingstyperDto", "kontinuerlig", "boolean", "null", false),
            midtveisvurdering: template && template.midtveisvurdering ? (typeof template.midtveisvurdering === "function" ? (template.midtveisvurdering as Function)(this) : template.midtveisvurdering): this.generate("VurderingstyperDto", "midtveisvurdering", "boolean", "null", false),
            sluttvurdering: template && template.sluttvurdering ? (typeof template.sluttvurdering === "function" ? (template.sluttvurdering as Function)(this) : template.sluttvurdering): this.generate("VurderingstyperDto", "sluttvurdering", "boolean", "null", false),
        };
    }
    sampleArrayVurderingstyperDto(template?: Factory<VurderingstyperDto>, length?: number): Array<VurderingstyperDto> {
        return Array.from({length: length || this.arrayLength("VurderingstyperDto")}).map(() => this.sampleVurderingstyperDto(template));
    }
}
